<template>
	<el-dialog :title="getDialogTitle" :visible.sync="dialogVisible" width="88%" :close-on-click-modal="false"
		:before-close="handleClose" top="2vh" custom-class="addxyk-dialog">
		<!-- 表单内容 84760530000170075440 -->
		<el-form ref="inboundForm" :model="formData" :rules="formRules" label-width="120px" size="small"
			v-loading="loading">
			<!-- 上部分：采购信息 -->
			<div class="purchase-info-section">
				<h4 class="section-title">采购信息</h4>
				<el-row :gutter="20">
					<el-col :span="12">
						<el-form-item label="来源药库" prop="warehouseId" required>
							<el-select v-model="formData.warehouseId" placeholder="请选择药库"
								@change="handleWarehouseChange" style="width: 100%" :disabled="true">
								<el-option label="西药库" :value="1"></el-option>
								<el-option label="西药房" :value="3"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="计划采购单" prop="purchasePlanId">
							<div class="plan-code-select">
								<el-select v-model="formData.purchasePlanId" placeholder="请选择计划采购单"
									@change="handlePlanCodeChange" style="width: calc(100% - 40px)"
									:loading="planOptionsLoading" clearable
									:disabled="isViewMode || isSubmitMode || isReviewMode || isPassMode || isRollbackMode || isFastMode">
									<el-option v-for="plan in purchasePlanOptions" :key="plan.id"
										:label="plan.planNo || plan.docNum" :value="plan.id">
										<div class="plan-option">
											<span class="plan-code">{{ plan.planNo || plan.docNum }}</span>
											<span class="plan-supplier" v-if="plan.supplierName">供应商:
												{{ plan.supplierName }}</span>
										</div>
									</el-option>
								</el-select>
								<el-button
									v-if="!isViewMode && !isSubmitMode && !isReviewMode && !isPassMode && !isRollbackMode"
									type="text" icon="el-icon-menu" style="margin-left: 5px;"
									@click="openPurchasePlanDrawer" title="选择采购计划详情单"></el-button>
							</div>
 
							<!-- 显示当前选西的采购计划信息 -->
							<div v-if="formData.purchasePlanId" class="selected-plan-info">
								<el-tag type="success" size="small">
									已选择: {{ getSelectedPlanInfo() }}
								</el-tag>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
 
				<el-row :gutter="20">
					<el-col :span="12">
						<el-form-item label="业务日期" prop="businessDate" required>
							<el-date-picker v-model="formData.businessDate" type="date" placeholder="选择日期"
								value-format="yyyy-MM-dd" format="yyyy-MM-dd" style="width: 100%"
								:disabled="isViewMode || isSubmitMode || isReviewMode || isPassMode || isRollbackMode || isFastMode">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="发票号码" prop="invoiceNo">
							<el-input v-model="formData.invoiceNo" placeholder="请输入发票号码"
								:disabled="isViewMode || isSubmitMode || isReviewMode || isPassMode || isRollbackMode || isFastMode"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
 
				<el-row :gutter="20">
					<el-col :span="12">
						<el-form-item label="供货单位" prop="supplierId" required>
							<div class="supplier-wrapper">
								<!-- 在模板中，供应商下拉列表保持不变，但确保选择时能获取entId -->
								<el-select v-model="formData.supplierId" placeholder="请选择供货单位"
								  @change="handleSupplierChange" :loading="supplierLoading" class="supplier-select"
								  :disabled="isViewMode || isSubmitMode || isReviewMode || isPassMode || isRollbackMode || isFastMode">
								  <el-option v-for="item in supplierList" :key="item.id" :label="item.supplierName"
								    :value="item.id">
								    <div class="supplier-option">
								      <span>{{ item.supplierName }}</span>
								    </div>
								  </el-option>
								</el-select>
								<el-button
									v-if="!isViewMode && !isSubmitMode && !isReviewMode && !isPassMode && !isRollbackMode && !isFastMode"
									type="primary" icon="el-icon-plus" size="mini" @click="handleAddSupplier"
									class="add-supplier-btn" v-el-tooltip="'添加新的供应商单位'"></el-button>
								<el-input v-model="formData.supplierCode" placeholder="供应商号码"
									class="supplier-code-input"
									:disabled="isViewMode || isSubmitMode || isReviewMode || isPassMode || isRollbackMode || isFastMode"></el-input>
							</div>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="入库方式" prop="putinTypeId" required>
							<el-select v-model="formData.putinTypeId" placeholder="请选择入库方式" style="width: 100%"
								:disabled="isViewMode || isSubmitMode || isReviewMode || isPassMode || isRollbackMode || isFastMode">
								<el-option v-for="typed in computedPutinTypeList" :key="typed.id" :label="typed.name"
									:value="typed.id"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
 
				<el-row :gutter="20">
					<el-col :span="24">
						<el-form-item label="备注" prop="remark">
							<el-input v-model="formData.remark" type="textarea" :rows="2" placeholder="请输入备注信息"
								:disabled="isViewMode || isSubmitMode || isReviewMode || isPassMode || isRollbackMode || isFastMode"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</div>
			<!-- 下部分：药品明细信息 -->
			<div class="medicine-detail-section">
			  <div class="section-header">
			    <h4 class="section-title">药品明细信息</h4>
			    
			    <!-- 右侧功能区：包含扫码枪输入和添加药品按钮 -->
			    <div class="right-function-buttons">
			      <!-- 扫码枪输入区域 -->
			      <div class="scan-input-wrapper" v-if="mode === 'add'" style="display: inline-block; margin-right: 10px;">
			        <el-input
			          v-model="outerScanInput"
			          placeholder="请使用扫码枪扫描追溯码"
			          clearable
			          size="mini"
			          @keyup.enter="handleOuterScanConfirm"
			        >
			          <template slot="append">
			            <el-button
			              type="primary"
			              icon="el-icon-Ssearch"
			              @click="handleOuterScanConfirm"
			              size="mini"
			              :loading="outerScanLoading"
			              :disabled="!outerScanInput || outerScanInput.trim() === ''"
			            > 查询</el-button>
			          </template>
			        </el-input>
			      </div>
			      
			      <!-- 添加药品按钮：只在新增或修改模式下显示 -->
			        <el-button
			          v-if="mode === 'add' || mode === 'edit'"
			          type="primary" icon="el-icon-plus" size="mini" @click="handleAddMedicine">
			          添加药品
			        </el-button>
			    </div>
			  </div>
 
				<!-- 药品明细表格 -->
				<el-table :data="medicineList" style="width: 100%" border size="mini" height="300"
					empty-text="暂无药品明细，请点击上方【添加药品】按钮">
					<el-table-column type="index" label="#" width="50" align="center"></el-table-column>
 
					<!-- 药品名称列（下拉选择框） -->
					<el-table-column label="药品名称" width="200" align="center">
					  <template slot-scope="scope">
					    <div class="drug-select-container" :key="scope.row.id || scope.$index">
					      <el-select 
					        v-model="scope.row.drugId" 
					        filterable 
					        placeholder="请选择药品" 
					        size="mini"
					        style="width: 100%" 
					        @change="handleDrugChange(scope.row)" 
					        clearable
					        :clearable="canClearDrug(scope.row)"
					        @clear="handleDrugClear(scope.row)"
					        remote
					        :remote-method="(query) => handleDrugSearch(query, scope.row)"
					        :remote="canRemoteSearch(scope.row)"
					        :loading="scope.row.drugLoading"
					        @focus="handleDrugFocus(scope.row)"
					        v-el-select-infinite-scroll="() => handleDrugScroll(scope.row)"
					        popper-class="drug-select-popper"
					        :disabled="!canSelectDrug(scope.row)"
					      >
					        <!-- 药品选项 -->
					        <el-option 
					          v-for="drug in getDrugOptionsForRow(scope.row)" 
					          :key="drug.id" 
					          :label="getDrugDisplayLabel(drug, scope.row)"
					          :value="drug.id"
					        >
					          <div class="drug-option">
					            <!-- 使用v-html显示高亮后的药品名称 -->
					            <span 
					              class="drug-name" 
					              v-html="getHighlightedDrugName(drug, scope.row)"
					            ></span>
					            
					            <!-- 显示规格信息 -->
					            <template v-if="drug.drugSpecifications || drug.pacSpec || scope.row.spec">
					              <span class="drug-spec">
					                规格：{{ drug.drugSpecifications || drug.pacSpec || scope.row.spec || '' }}
					              </span>
					            </template>
					            
					            <!-- 显示生产厂家信息 -->
					            <template v-if="drug.manufacturerName || scope.row.manufacturer">
					              <span class="drug-spec">
					                生产厂家：{{ drug.manufacturerName || scope.row.manufacturer || '' }}
					              </span>
					            </template>
					          </div>
					        </el-option>
					        
					        <!-- 无搜索结果时的提示 -->
					        <div v-if="showNoSearchResults(scope.row)" slot="empty" class="no-search-results">
					          <i class="el-icon-search"></i>
					          <span>未找到"{{ scope.row ? scope.row.drugSearchQuery : this.drugSearchQuery }}"相关药品</span>
					        </div>
					        
					        <!-- 加载更多选项 -->
					        <el-option 
					          v-if="drugHasMore && !drugSearchLoading && canLoadMore(scope.row)"
					          :key="`load-more-${scope.row.id}-${Date.now()}`" 
					          value="load-more"
					          label="点击加载更多"
					          @click.native="loadMoreDrugs(scope.row)"
					        >
					          <div class="load-more-option" @click.stop="loadMoreDrugs(scope.row)">
					            <i class="el-icon-loading" v-if="loadingMoreDrugs"></i>
					            <span v-else>点击加载更多</span>
					          </div>
					        </el-option>
					      </el-select>
					    </div>
					  </template>
					</el-table-column>
 
					<el-table-column label="入库数量" width="160" align="center">
						<template slot-scope="scope">
							<div class="qty-wrapper">
								<el-input v-model="scope.row.inboundQty" size="mini"
									@change="calculateRowAmount(scope.row)" class="qty-input"
									:disabled="isViewMode || isSubmitMode || isReviewMode || isPassMode || isRollbackMode || isFastMode"></el-input>
								<span class="unit-label">{{ scope.row.unitLabel || '单位' }}</span>
							</div>
						</template>
					</el-table-column>
 
					<el-table-column label="库存类型" width="120" align="center">
						<template slot-scope="scope">
							<el-select v-model="scope.row.purcType" placeholder="类型" size="mini"
								@change="handlePurcTypeChange(scope.row)" style="width: 100%"
								:disabled="isViewMode || isSubmitMode || isReviewMode || isPassMode || isRollbackMode || isFastMode">
								<el-option label="最小单位" :value="1"></el-option>
								<el-option label="包装单位" :value="2"></el-option>
							</el-select>
						</template>
					</el-table-column>
 
					<el-table-column prop="pacCnt" label="包装数量" width="100" align="center">
						<template slot-scope="scope">
							<el-input v-model="scope.row.pacCnt" size="mini" :disabled="true"></el-input>
						</template>
					</el-table-column>
 
					<el-table-column prop="manuLotnum" label="生产批号" width="120" align="center">
						<template slot-scope="scope">
							<el-input v-model="scope.row.manuLotnum" placeholder="批号" size="mini"
								@blur="validateRequired(scope.row, 'manuLotnum')"
								:disabled="isViewMode || isSubmitMode || isReviewMode || isPassMode || isRollbackMode || isFastMode"></el-input>
						</template>
					</el-table-column>
 
					<!-- 生产厂家列 - 根据不同模式显示不同内容 -->
					<el-table-column label="生产厂家" width="150" show-overflow-tooltip>
					  <template slot-scope="scope">
					    <!-- 详情、提交、审核、过单、回退模式：只显示文本 -->
					    <template v-if="isViewMode || isSubmitMode || isReviewMode || isPassMode || isRollbackMode">
					      <div class="manufacturer-readonly">
					        {{ scope.row.manufacturer || '--' }}
					        <el-tag v-if="scope.row.manufacturerOptions && scope.row.manufacturerOptions.length > 1" 
					                size="mini" type="info" style="margin-left: 5px;">
					          {{ scope.row.manufacturerOptions.length }}个厂商
					        </el-tag>
					      </div>
					    </template>
					    
					    <!-- 新增模式：显示下拉选择框 -->
					    <template v-else-if="mode === 'add'">
					      <el-select v-model="scope.row.prodentpNameId" placeholder="请选择厂家" size="mini"
					        @change="handleManufacturerChange(scope.row)" style="width: 100%"
					        :disabled="false"
					        :loading="scope.row.manufacturerLoading">
					        <el-option v-for="manufacturer in scope.row.manufacturerOptions"
					          :key="manufacturer.prodentpId" :label="manufacturer.prodentpName"
					          :value="manufacturer.prodentpId"></el-option>
					      </el-select>
					    </template>
					    
					    <!-- 修改模式：根据行类型显示不同内容 -->
					    <template v-else-if="mode === 'edit'">
					      <!-- 原始数据行：只显示文本 -->
					      <template v-if="!scope.row.isNewRow">
					        <div class="manufacturer-readonly">
					          {{ scope.row.manufacturer || '--' }}
					          <el-tag v-if="scope.row.manufacturerOptions && scope.row.manufacturerOptions.length > 1" 
					                  size="mini" type="info" style="margin-left: 5px;">
					            {{ scope.row.manufacturerOptions.length }}个厂商
					          </el-tag>
					        </div>
					      </template>
					      <!-- 新增行：显示下拉选择框 -->
					      <template v-else>
					        <el-select v-model="scope.row.prodentpNameId" placeholder="请选择厂家" size="mini"
					          @change="handleManufacturerChange(scope.row)" style="width: 100%"
					          :disabled="false"
					          :loading="scope.row.manufacturerLoading">
					          <el-option v-for="manufacturer in scope.row.manufacturerOptions"
					            :key="manufacturer.prodentpId" :label="manufacturer.prodentpName"
					            :value="manufacturer.prodentpId"></el-option>
					        </el-select>
					      </template>
					    </template>
					    
					    <!-- 默认情况 -->
					    <template v-else>
					      <div class="manufacturer-readonly">
					        {{ scope.row.manufacturer || '--' }}
					      </div>
					    </template>
					  </template>
					</el-table-column>
 
					<el-table-column label="生产日期" width="140" align="center">
						<template slot-scope="scope">
							<el-date-picker v-model="scope.row.manuDate" type="date" placeholder="生产日期"
								value-format="yyyy-MM-dd" format="yyyy-MM-dd" size="mini" style="width: 100%"
								:picker-options="getManuDatePickerOptions(scope.row)"
								@change="handleManuDateChange(scope.row)"
								:disabled="isViewMode || isSubmitMode || isReviewMode || isPassMode || isRollbackMode || isFastMode"></el-date-picker>
						</template>
					</el-table-column>
 
					<el-table-column label="有效日期" width="140" align="center">
						<template slot-scope="scope">
							<el-date-picker v-model="scope.row.expyDate" type="date" placeholder="有效日期"
								value-format="yyyy-MM-dd" format="yyyy-MM-dd" size="mini" style="width: 100%"
								:picker-options="getExpiryDatePickerOptions(scope.row)"
								@change="handleExpiryDateChange(scope.row)"
								:disabled="scope.row.expyDateDisabled || isViewMode || isSubmitMode || isReviewMode || isPassMode || isRollbackMode || isFastMode"></el-date-picker>
						</template>
					</el-table-column>
 
					<el-table-column prop="costPric" label="成本" width="160" align="right">
						<template slot-scope="scope">
							<el-input-number v-model="scope.row.costPric" :min="0" :step="0.00000001"
								size="mini" @change="handleCostPriceChange(scope.row)"
								:formatter="value => formatDecimal(value, 8)" :parser="value => parseFloat(value) || 0"
								:disabled="isViewMode || isSubmitMode || isReviewMode || isPassMode || isRollbackMode || isFastMode">
								<!-- <template slot="append">元</template> -->
							</el-input-number>
						</template>
					</el-table-column>
 
					<el-table-column prop="totalCost" label="总成本" width="120" align="right">
						<template slot-scope="scope">
							<span>¥{{ scope.row.totalCost ? formatDecimal(scope.row.totalCost, 8) : '0.00' }}</span>
						</template>
					</el-table-column>
 
					<el-table-column prop="salePric" label="零售" width="120" align="right">
						<template slot-scope="scope">
							<el-input v-model="scope.row.salePric" :min="0" :step="0.00000001" :precision="8"
								size="mini" :disabled="true" :formatter="value => formatDecimal(value, 8)"
								:parser="value => parseFloat(value) || 0">
								<!-- <template slot="append">元</template> -->
							</el-input>
						</template>
					</el-table-column>
 
					<el-table-column prop="totalRetail" label="总零售" width="120" align="right">
						<template slot-scope="scope">
							<span>¥{{ scope.row.totalRetail ? formatDecimal(scope.row.totalRetail, 8) : '0.00' }}</span>
						</template>
					</el-table-column>
 
					<el-table-column prop="markupMethodText" label="加成方式" width="120" align="center">
						<template slot-scope="scope">
							<el-input v-model="scope.row.markupMethodText" size="mini" :disabled="true"
								style="width: 100%"></el-input>
						</template>
					</el-table-column>
 
					<!-- 是否指定售价列 -->
					<el-table-column prop="isFixedPriceText" label="是否指定售价" width="120" align="center">
						<template slot-scope="scope">
							<el-input v-model="scope.row.isFixedPriceText" size="mini" :disabled="true"
								style="width: 100%"></el-input>
						</template>
					</el-table-column>
 
					<el-table-column prop="spec" label="规格" width="100" show-overflow-tooltip>
						<template slot-scope="scope">
							<el-tooltip :content="scope.row.spec || '--'" placement="top"
								:disabled="!scope.row.spec || scope.row.spec.length <= 10">
								<span>{{ scope.row.spec ? (scope.row.spec.length > 10 ? scope.row.spec.substring(0, 10) + '...' : scope.row.spec) : '--' }}</span>
							</el-tooltip>
						</template>
					</el-table-column>
 
					<el-table-column prop="packageSpec" label="包装规格" width="100" show-overflow-tooltip>
						<template slot-scope="scope">
							<el-tooltip :content="scope.row.packageSpec || '--'" placement="top"
								:disabled="!scope.row.packageSpec || scope.row.packageSpec.length <= 10">
								<span>{{ scope.row.packageSpec ? (scope.row.packageSpec.length > 10 ? scope.row.packageSpec.substring(0, 10) + '...' : scope.row.packageSpec) : '--' }}</span>
							</el-tooltip>
						</template>
					</el-table-column>
 
					<el-table-column
					  v-if="!isViewMode && !isSubmitMode && !isReviewMode && !isPassMode && !isRollbackMode && !isFastMode"
					  label="操作"
					  width="180"
					  align="center"
					  fixed="right">
					   <template slot-scope="scope">
					       <!-- 追溯码按钮 - 只有isBar===1时才显示 -->
					       <el-tooltip 
					         v-if="scope.row.isBar === 1"
					         :content="getTraceCodeTooltip(scope.row)" 
					         placement="top"
					       >
					         <span style="display: inline-block;">
					           <el-button 
					             v-if="scope.row.isBar === 1"
					             type="text" 
					             size="mini" 
					             @click="openTraceCodeSupplement(scope.row, scope.$index)"
					             :disabled="!canTraceCode(scope.row)"
					             style="margin-right: 5px;"
					           >
					             {{ scope.row.traceCodeButtonText || '追溯码' }}
					           </el-button>
					         </span>
					       </el-tooltip>
					    
					    <el-button 
					      type="text" 
					      size="mini" 
					      style="color: #F56C6C;"
					      @click="handleRemoveMedicine(scope.$index, scope.row)">
					      移除
					    </el-button>
					  </template>
					</el-table-column>
				</el-table>
 
				<!-- 汇总信息 -->
				<div class="summary-info">
				  <el-row :gutter="20">
				    <el-col :span="6">
				      <div class="summary-item">
				        <span class="label">药品数量：</span>
				        <span class="value">{{ medicineList.length }}</span>
				      </div>
				    </el-col>
				    <el-col :span="6">
				      <div class="summary-item">
				        <span class="label">总入库数量：</span>
				        <span class="value">{{ totalInboundQty }}</span>
				      </div>
				    </el-col>
				    <el-col :span="6">
				      <div class="summary-item">
				        <span class="label">总成本：</span>
				        <span class="value">¥{{ formatCurrency(totalCost) }}</span>
				      </div>
				    </el-col>
				    <el-col :span="6">
				      <div class="summary-item">
				        <span class="label">总零售：</span>
				        <span class="value">¥{{ formatCurrency(totalRetail) }}</span>
				      </div>
				    </el-col>
				  </el-row>
				</div>
			</div>
		</el-form>
 
		<span slot="footer" class="dialog-footer">
			<!-- 查看模式：只显示关闭按钮 -->
			<template v-if="isViewMode">
				<el-button size="small" @click="handleClose">
					关闭
				</el-button>
			</template>
 
			<!-- 新增模式 -->
			<template v-else-if="mode === 'add'">
				<el-button size="small" @click="handleClose">
					取消
				</el-button>
				<el-button type="primary" size="small" @click="handleCreate" :loading="saving"
					:disabled="medicineList.length === 0">
					确认创建
				</el-button>
			</template>
 
			<!-- 修改模式 -->
			<template v-else-if="mode === 'edit'">
				<el-button size="small" @click="handleClose">
					关闭
				</el-button>
				<el-button type="primary" size="small" @click="handleSave" :loading="saving">
					保存
				</el-button>
				<el-button type="success" size="small" @click="handleSaveAndSubmit" :loading="saving">
					保存提交
				</el-button>
			</template>
 
			<!-- 提交模式 -->
			<template v-else-if="mode === 'submit'">
				<el-button size="small" @click="handleClose">
					关闭
				</el-button>
				<el-button type="primary" size="small" @click="handleSubmitConfirm" :loading="saving">
					确认提交
				</el-button>
			</template>
 
			<!-- 审核模式 -->
			<template v-else-if="mode === 'review'">
				<el-button size="small" @click="handleClose">
					关闭
				</el-button>
				<el-button type="warning" size="small" @click="handleRollbackDraft" :loading="saving">
					回退草稿
				</el-button>
				<el-button type="primary" size="small" @click="handleReviewConfirm" :loading="saving">
					确认审核
				</el-button>
			</template>
 
			<!-- 过单入库模式 -->
			<template v-else-if="mode === 'pass'">
				<el-button size="small" @click="handleClose">
					关闭
				</el-button>
				<el-button type="warning" size="small" @click="handleRollbackReview" :loading="saving">
					回退审核
				</el-button>
				<el-button type="success" size="small" @click="handlePassConfirm" :loading="saving">
					确认入库
				</el-button>
			</template>
 
			<!-- 回退模式 -->
			<template v-else-if="mode === 'rollback'">
				<el-button size="small" @click="handleClose">
					关闭
				</el-button>
				<el-button type="warning" size="small" @click="handleRollbackConfirm" :loading="saving">
					确认回退
				</el-button>
			</template>
			<!-- 快速调拨模式 -->
			<template v-else-if="mode === 'fast'">
				<el-button size="small" @click="handleClose">
					关闭
				</el-button>
				<el-button type="primary" size="small" @click="handleFastTransferConfirm" :loading="saving">
					确认无误，快速调拨
				</el-button>
			</template>
		</span>
 
		<!-- 新增供应商模态框 -->
		<el-dialog title="新增供应商" :visible.sync="supplierDialogVisible" width="500px" :close-on-click-modal="false">
			<el-form ref="supplierForm" :model="supplierForm" :rules="supplierRules" label-width="100px" size="small">
				<el-form-item label="供应商名称" prop="supplierName" required>
					<el-input v-model="supplierForm.supplierName" placeholder="请输入供应商名称"></el-input>
				</el-form-item>
				<el-form-item label="联系人" prop="contact" required>
					<el-input v-model="supplierForm.contact" placeholder="请输入联系人"></el-input>
				</el-form-item>
				<el-form-item label="联系人电话" prop="contactPhone" required>
					<el-input v-model="supplierForm.contactPhone" placeholder="请输入联系人电话"></el-input>
				</el-form-item>
				<el-form-item label="供应商地址" prop="address">
					<el-input v-model="supplierForm.address" placeholder="请输入供应商地址"></el-input>
				</el-form-item>
				<el-form-item label="码上放心-企业ID" prop="entId">
					<el-input v-model="supplierForm.entId" placeholder="企业ID"></el-input>
				</el-form-item>
				<el-form-item label="许可证号" prop="permitNumber">
					<el-input v-model="supplierForm.permitNumber" placeholder="请输入许可证号"></el-input>
				</el-form-item>
				<el-form-item label="状态" prop="status" required>
					<el-select v-model="supplierForm.status" placeholder="请选择状态" style="width: 100%">
						<el-option label="禁用" :value="0"></el-option>
						<el-option label="启用" :value="1"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="备注" prop="remark">
					<el-input v-model="supplierForm.remark" type="textarea" :rows="2" placeholder="请输入备注"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="supplierDialogVisible = false">取消</el-button>
				<el-button type="primary" size="small" @click="handleSaveSupplier"
					:loading="supplierSaving">保存</el-button>
			</span>
		</el-dialog>
		
		<!-- 追溯码录入模态框 -->
		<el-dialog 
		  :title="traceCodeDialogTitle" 
		  :visible.sync="traceCodeDialogVisible" 
		  width="80%"
		  :close-on-click-modal="false"
		  :before-close="handleTraceCodeDialogClose"
		  top="5vh"
		  custom-class="trace-code-dialog"
		>
		  <!-- 模态框头部区域 - 浅灰色背景，亮黑色文字 -->
		  <div class="dialog-header" slot="title">
		    <span class="dialog-title-text">{{ traceCodeDialogTitle }}</span>
		  </div>
		  
		  <!-- 模态框内容区域 - 白色背景 -->
		  <div class="trace-code-dialog-content">
		    <!-- 功能按钮区域 - 分为左右布局 -->
		    <div class="function-buttons-section">
		      <div class="function-button-group">
		        <!-- 左侧区域：扫码枪录入区域 -->
		        <div class="left-function-area">
		          <div class="scan-input-area">
		            <h4 class="scan-area-title">扫码枪录入区域</h4>
		            <div class="scan-input-wrapper">
		              <el-input
		                v-model="scanInput"
		                placeholder="请使用扫码枪扫描追溯码，按回车键确认"
		                clearable
		                @keyup.enter="handleScanInput"
		                size="small"
		                style="width: 100%;"
		              >
		                <template slot="append">
		                  <el-button 
		                    type="primary" 
		                    icon="el-icon-guahao" 
		                    @click="handleScanInput"
		                    size="small"
		                  >
		                    确认
		                  </el-button>
		                </template>
		              </el-input>
		            </div>
		            <div class="scan-tips">
		              <i class="el-icon-info"></i>
		              提示：扫描追溯码后按回车键或点击确认按钮
		            </div>
		          </div>
		        </div>
		        
		        <!-- 右侧区域：功能按钮 -->
		        <div class="right-function-area">
		          <!-- 清空按钮 -->
		          <el-tooltip content="清空所有追溯码" placement="top">
		            <div class="function-button-item" @click="handleClearTraceCode">
		              <i class="el-icon-delete function-icon"></i>
		              <span class="function-text">清空</span>
		            </div>
		          </el-tooltip>
		          
		          <!-- 导入按钮 -->
		          <el-tooltip content="导入追溯码" placement="top">
		            <div class="function-button-item" @click="handleImportTraceCode">
		              <i class="el-icon-upload2 function-icon"></i>
		              <span class="function-text">导入</span>
		            </div>
		          </el-tooltip>
		          
		          <!-- 导出按钮 -->
		          <el-tooltip content="导出追溯码" placement="top">
		            <div class="function-button-item" @click="handleExportTraceCode">
		              <i class="el-icon-download function-icon"></i>
		              <span class="function-text">导出</span>
		            </div>
		          </el-tooltip>
		        </div>
		      </div>
		    </div>
		    
		    <!-- 统计信息区域 -->
		    <div class="summary-info-section" v-if="currentTraceMedicine">
		      <el-row :gutter="20">
		        <el-col :span="6">
		          <div class="summary-item">
		            <span class="label">药品名称：</span>
		            <span class="value">{{ currentTraceMedicine.drugName || '--' }}</span>
		          </div>
		        </el-col>
		        <el-col :span="6">
		          <div class="summary-item">
		            <span class="label">入库数量：</span>
		            <span class="value">{{ currentTraceMedicine.inboundQty || 0 }}</span>
		          </div>
		        </el-col>
		        <el-col :span="6">
		          <div class="summary-item">
		            <span class="label">包装数量：</span>
		            <span class="value">{{ currentTraceMedicine.pacCnt || 0 }}</span>
		          </div>
		        </el-col>
		        <el-col :span="6">
		          <div class="summary-item">
		            <span class="label">已录入数量：</span>
		            <span class="value" :class="{ 'warning': totalTraceQty !== currentTraceMedicine.inboundQty }">
		              {{ totalTraceQty }}
		              <span v-if="totalTraceQty !== currentTraceMedicine.inboundQty" style="color: #E6A23C; margin-left: 5px;">
		                (还需录入 {{ currentTraceMedicine.inboundQty - totalTraceQty }} 个)
		              </span>
		            </span>
		          </div>
		        </el-col>
		      </el-row>
		    </div>
		    
		    <!-- 追溯码表格区域 -->
		    <div class="trace-code-table-section">
		      <el-table
		        :data="traceCodeList"
		        style="width: 100%"
		        border
		        size="mini"
		        height="300"
		        v-loading="traceCodeLoading"
		        class="trace-code-table"
		      >
		        <el-table-column
		          label="操作"
		          width="80"
		          align="center"
		          fixed="left"
		        >
		          <template slot-scope="scope">
		            <el-button
		              type="text"
		              size="mini"
		              icon="el-icon-setting"
		              @click="handleTraceCodeSetting(scope.row, scope.$index)"
		              title="设置"
		            ></el-button>
		          </template>
		        </el-table-column>
		        
		        <el-table-column
		          prop="traceCode"
		          label="追溯码"
		          min-width="200"
		          align="center"
		          fixed="left"
		        >
		          <template slot-scope="scope">
		            <el-input
		              v-model="scope.row.traceCode"
		              placeholder="请输入追溯码"
		              size="mini"
		              clearable
		              @blur="validateTraceCode(scope.row)"
		            ></el-input>
		          </template>
		        </el-table-column>
		        
		        <el-table-column
		          prop="drugName"
		          label="药品名称"
		          min-width="150"
		          align="center"
		          show-overflow-tooltip
		        >
		          <template slot-scope="scope">
		            <span>{{ scope.row.drugName || '--' }}</span>
		          </template>
		        </el-table-column>
		        
		        <el-table-column
		          prop="spec"
		          label="规格"
		          width="120"
		          align="center"
		        >
		          <template slot-scope="scope">
		            <span>{{ scope.row.spec || '--' }}</span>
		          </template>
		        </el-table-column>
		        
		        <el-table-column
		          prop="availableQty"
		          label="可用数量"
		          width="100"
		          align="center"
		        >
		          <template slot-scope="scope">
		            <el-input-number
		              v-model="scope.row.availableQty"
		              :min="1"
		              :max="getMaxAvailableQty(scope.row)"
		              :step="1"
		              size="mini"
		              style="width: 100%"
		              @change="handleAvailableQtyChange(scope.row)"
		            ></el-input-number>
		            <div v-if="scope.row.availableQty > getMaxAvailableQty(scope.row)" style="color: #F56C6C; font-size: 12px;">
		              超出最大数量
		            </div>
		          </template>
		        </el-table-column>
		        
		        <el-table-column
		          prop="manufacturer"
		          label="生产厂家"
		          width="150"
		          align="center"
		          show-overflow-tooltip
		        >
		          <template slot-scope="scope">
		            <span>{{ scope.row.manufacturer || '--' }}</span>
		          </template>
		        </el-table-column>
		        
		        <!-- 新增字段：批准文号 -->
		        <el-table-column
		          prop="approvalLicenceNo"
		          label="批准文号"
		          width="150"
		          align="center"
		          show-overflow-tooltip
		        >
		          <template slot-scope="scope">
		            <span>{{ scope.row.approvalLicenceNo || '--' }}</span>
		          </template>
		        </el-table-column>
		        
		        <!-- 新增字段：生产批号 -->
		        <el-table-column
		          prop="batchNo"
		          label="生产批号"
		          width="150"
		          align="center"
		        >
		          <template slot-scope="scope">
		            <span>{{ scope.row.batchNo || '--' }}</span>
		          </template>
		        </el-table-column>
		        
		        <!-- 新增字段：生产日期 -->
		        <el-table-column
		          prop="produceDate"
		          label="生产日期"
		          width="120"
		          align="center"
		        >
		          <template slot-scope="scope">
		            <span>{{ scope.row.produceDate || '--' }}</span>
		          </template>
		        </el-table-column>
		        
		        <!-- 新增字段：有效期 -->
		        <el-table-column
		          prop="expireDate"
		          label="有效期"
		          width="120"
		          align="center"
		        >
		          <template slot-scope="scope">
		            <span>{{ scope.row.expireDate || '--' }}</span>
		          </template>
		        </el-table-column>
		        
		        <!-- 新增字段：码状态 -->
		        <el-table-column
		          prop="codeStatus"
		          label="码状态"
		          width="100"
		          align="center"
		        >
		          <template slot-scope="scope">
		            <el-tag
		              :type="getCodeStatusType(scope.row.codeStatus)"
		              size="mini"
		            >
		              {{ scope.row.codeStatus || '--' }}
		            </el-tag>
		          </template>
		        </el-table-column>
		        
		        <el-table-column
		          prop="remark"
		          label="备注"
		          min-width="150"
		          align="center"
		        >
		          <template slot-scope="scope">
		            <el-input
		              v-model="scope.row.remark"
		              placeholder="请输入备注"
		              size="mini"
		              clearable
		            ></el-input>
		          </template>
		        </el-table-column>
		        
		        <el-table-column
		          label="操作"
		          width="80"
		          align="center"
		          fixed="right"
		        >
		          <template slot-scope="scope">
		            <el-button
		              type="text"
		              size="mini"
		              style="color: #F56C6C;"
		              @click="handleRemoveTraceCode(scope.$index)"
		            >
		              删除
		            </el-button>
		          </template>
		        </el-table-column>
		      </el-table>
		    </div>
		  </div>
		  
		  <!-- 模态框底部按钮 - 白色背景 -->
		  <div slot="footer" class="trace-code-dialog-footer">
		    <el-button
		      size="small"
		      @click="handleCancelTraceCode"
		    >
		      取消
		    </el-button>
		    <el-button
		      type="primary"
		      size="small"
		      @click="handleConfirmTraceCode"
		      :loading="traceCodeLoading"
		      :disabled="!canConfirmTraceCode"
		    >
		      确定
		    </el-button>
		  </div>
		</el-dialog>
		
		<!-- 追溯码录入模态框（通过顶部按钮打开） -->
		<el-dialog 
		  title="追溯码录入"
		  :visible.sync="traceCodeInputDialogVisible" 
		  width="60%"
		  :close-on-click-modal="false"
		  top="5vh"
		  class="trace-code-input-dialog"
		  @close="handleCloseTraceCodeInput"
		>
		  <!-- 模态框内容区域 -->
		  <div class="trace-code-input-dialog-content">
		    <!-- 药品信息表单 -->
		    <div class="medicine-form-section" v-if="traceCodeDetailData">
		      <h4 class="section-title">药品信息（追溯码：{{ traceCodeInputForm.traceCode || '无' }}）</h4>
		      
		      <!-- 使用el-descriptions描述列表 -->
		      <el-descriptions
		        :column="2"
		        border
		        size="small"
		        class="trace-code-descriptions"
		      >
		        <!-- 药品名称 -->
		        <el-descriptions-item label="药品名称" label-class-name="description-label">
		          <el-input 
		            v-model="traceCodeInputForm.drugName" 
		            placeholder="药品名称"
		            :disabled="true"
		            class="description-content"
		          ></el-input>
		        </el-descriptions-item>
		        
		        <!-- 规格 -->
		        <el-descriptions-item label="规格" label-class-name="description-label">
		          <el-input v-model="traceCodeInputForm.spec" disabled class="description-content"></el-input>
		        </el-descriptions-item>
		        
		        <!-- 批准文号 -->
		        <el-descriptions-item label="批准文号" label-class-name="description-label">
		          <el-input 
		            v-model="traceCodeInputForm.approvalLicenceNo" 
		            placeholder="批准文号"
		            :disabled="true"
		            class="description-content"
		          ></el-input>
		        </el-descriptions-item>
		        
		        <!-- 包装数量 -->
		        <el-descriptions-item label="包装数量" label-class-name="description-label">
		          <el-input-number
		            v-model="traceCodeInputForm.pacCnt"
		            :min="1"
		            :step="1"
		            size="small"
		            class="description-content"
		            :disabled="true"
		          ></el-input-number>
		        </el-descriptions-item>
		        
		        <!-- 生产厂家 -->
		        <el-descriptions-item label="生产厂家" label-class-name="description-label">
		          <el-input 
		            v-model="traceCodeInputForm.manufacturer" 
		            placeholder="生产厂家"
		            :disabled="true"
		            class="description-content"
		          ></el-input>
		        </el-descriptions-item>
		        
		        <!-- 生产批号 -->
		        <el-descriptions-item label="生产批号" label-class-name="description-label">
		          <el-input v-model="traceCodeInputForm.manuLotnum" :disabled="true" class="description-content"></el-input>
		        </el-descriptions-item>
		        
		        <!-- 有效期 -->
		        <el-descriptions-item label="有效期" label-class-name="description-label">
		          <el-input v-model="traceCodeInputForm.expireDate" :disabled="true" class="description-content"></el-input>
		        </el-descriptions-item>
		        
		        <!-- 生产日期 -->
		        <el-descriptions-item label="生产日期" label-class-name="description-label">
		          <el-input v-model="traceCodeInputForm.produceDate" :disabled="true" class="description-content"></el-input>
		        </el-descriptions-item>
		        
		        <!-- 剂型 -->
				<el-descriptions-item label="剂型" label-class-name="description-label">
				  <el-input v-model="traceCodeInputForm.dosageFormName" disabled class="description-content"></el-input>
				</el-descriptions-item>
		      </el-descriptions>
		    </div>
		    
		    <!-- 加载状态 -->
		    <div v-if="getSomeWareLoading" class="loading-section">
		      <i class="el-icon-loading"></i>
		      <span>正在查询药品信息...</span>
		    </div>
		  </div>
		  
		  <!-- 模态框底部按钮 -->
		  <span slot="footer" class="trace-code-dialog-footer">
		    <el-button size="small" @click="handleCancelTraceCodeInput">取消</el-button>
		    <!-- 新增条件按钮 -->
		    <el-tooltip
		      v-if="showBottomAddButton"
		      :content="getAddButtonTooltip()"
		      placement="top"
		      :disabled="!isAddButtonDisabled"
		    >
		      <el-button
		        type="warning"
		        size="small"
		        @click="openAddDrugDialog()"
		        :disabled="isAddButtonDisabled"
		      >
		        去添加
		      </el-button>
		    </el-tooltip>
		    <el-button
		      type="primary"
		      size="small"
		      @click="handleConfirmTraceCodeInput"
		      :loading="traceCodeLoading"
		      :disabled="!canConfirmTraceCodeInput"
		    >
		      确定
		    </el-button>
		  </span>
		</el-dialog>
		
		<!-- 添加药品目录模态框 -->
		<!-- <AddDrugDialog
		  v-if="addDrugDialogVisible"
		  :key="'add-drug-' + Date.now()"
		  :visible.sync="addDrugDialogVisible"
		  :drugData="addDrugDialogData"
		  ref="addDrugDialog"
		  @success="handleAddDrugSuccess"
		/> -->
		
		<!-- 追溯码补录模态框 -->
		<el-dialog 
		  title="追溯码补录"
		  :visible.sync="traceCodeSupplementDialogVisible" 
		  width="80%"
		  :close-on-click-modal="false"
		  top="5vh"
		  @close="handleCancelTraceCodeSupplement"
		>
		  <!-- 模态框内容区域 -->
		  <div class="trace-code-supplement-dialog-content">
		    <!-- 添加新的追溯码按钮 -->
		    <div class="add-button-section">
		      <el-button
		        type="primary"
		        icon="el-icon-plus"
		        size="small"
		        @click="handleAddSupplementTraceCode"
		      >
		        添加新的追溯码
		      </el-button>
		    </div>
		    
		    <!-- 追溯码表格区域 -->
		    <div class="trace-code-table-section">
		      <el-table
		        :data="traceCodeSupplementList"
		        style="width: 100%"
		        border
		        size="mini"
		        height="300"
		      >
		        <el-table-column
		          prop="traceCode"
		          label="追溯码"
		          min-width="200"
		          align="center"
		        >
		          <template slot-scope="scope">
		            <el-input
		              v-model="scope.row.traceCode"
		              placeholder="请输入追溯码"
		              size="mini"
		              clearable
		              :disabled="!scope.row.isEditing"
		              @blur="handleTraceCodeBlur(scope.row, scope.$index)"
		            ></el-input>
		          </template>
		        </el-table-column>
		        
		        <el-table-column
		          prop="drugName"
		          label="药品名称"
		          width="150"
		          align="center"
		        >
		          <template slot-scope="scope">
		            <span>{{ scope.row.drugName }}</span>
		          </template>
		        </el-table-column>
		        
		        <el-table-column
		          prop="spec"
		          label="规格"
		          width="120"
		          align="center"
		        >
		          <template slot-scope="scope">
		            <span>{{ scope.row.spec }}</span>
		          </template>
		        </el-table-column>
		        
		        <el-table-column
		          prop="availableQty"
		          label="可用数量"
		          width="150"
		          align="center"
		        >
		          <template slot-scope="scope">
		            <el-input
		              v-model="scope.row.availableQty"
		              size="mini"
		              style="width: 100%"
		              :disabled="!canEditAvailableQty(scope.row)"
		              @change="handleAvailableQtyChange(scope.row, scope.$index)"
		              @blur="handleAvailableQtyBlur(scope.row, scope.$index)"
		            ></el-input>
		            <div v-if="currentTraceMedicine && currentTraceMedicine.pacCnt" 
		                 class="available-qty-tip">
		              包装数量: {{ currentTraceMedicine.pacCnt }}
		            </div>
		          </template>
		        </el-table-column>
		        
		        <el-table-column
		          prop="manufacturer"
		          label="生产厂家"
		          width="150"
		          align="center"
		        >
		          <template slot-scope="scope">
		            <span>{{ scope.row.manufacturer }}</span>
		          </template>
		        </el-table-column>
		        
		        <el-table-column
		          prop="batchNo"
		          label="生产批号"
		          width="150"
		          align="center"
		        >
		          <template slot-scope="scope">
		            <span>{{ scope.row.batchNo }}</span>
		          </template>
		        </el-table-column>
		        
		        <el-table-column
		          prop="produceDate"
		          label="生产日期"
		          width="120"
		          align="center"
		        >
		          <template slot-scope="scope">
		            <span>{{ scope.row.produceDate }}</span>
		          </template>
		        </el-table-column>
		        
		        <el-table-column
		          prop="expireDate"
		          label="有效期"
		          width="120"
		          align="center"
		        >
		          <template slot-scope="scope">
		            <span>{{ scope.row.expireDate }}</span>
		          </template>
		        </el-table-column>
		        
		        <!-- 新增操作列 -->
		        <el-table-column
		          label="操作"
		          width="150"
		          align="center"
		          fixed="right"
		        >
		          <template slot-scope="scope">
		            <!-- 编辑状态：取消、保存按钮 -->
		            <template v-if="scope.row.isEditing">
		              <el-button
		                type="text"
		                size="mini"
		                style="color: #909399;"
		                @click="handleCancelSupplementEdit(scope.$index)"
		              >
		                取消
		              </el-button>
		              <el-button
		                type="text"
		                size="mini"
		                style="color: #409EFF; margin-left: 5px;"
		                @click="handleSaveSupplementRow(scope.$index)"
		              >
		                保存
		              </el-button>
		            </template>
		            
		            <!-- 非编辑状态：编辑、移除按钮 -->
		            <template v-else>
		              <el-button
		                type="text"
		                size="mini"
		                style="color: #409EFF;"
		                @click="handleEditSupplementRow(scope.$index)"
		              >
		                编辑
		              </el-button>
		              <el-button
		                type="text"
		                size="mini"
		                style="color: #F56C6C; margin-left: 5px;"
		                @click="handleRemoveSupplementRow(scope.$index)"
		              >
		                移除
		              </el-button>
		            </template>
		          </template>
		        </el-table-column>
		      </el-table>
		    </div>
		  </div>
		  
		  <!-- 模态框底部按钮 -->
		  <div slot="footer" class="dialog-footer">
		    <el-button
		      size="small"
		      @click="handleCancelTraceCodeSupplement"
		    >
		      取消
		    </el-button>
		    <el-button
		      type="primary"
		      size="small"
		      @click="handleConfirmTraceCodeSupplement"
		    >
		      确定
		    </el-button>
		  </div>
		</el-dialog>
			
		<!-- 在模板中添加过单进度模态框 -->
		<el-dialog
		  title="追溯码上传进度"
		  :visible.sync="passProgressDialogVisible"
		  width="60%"
		  :close-on-click-modal="false"
		  :show-close="false"
		  class="progress-dialog"
		  :before-close="handleProgressDialogClose"
		>
		  <div class="progress-dialog-content">
		    <!-- 步骤列表 -->
		    <div class="step-list">
		      <div 
		        v-for="(step, index) in passProgressSteps" 
		        :key="index" 
		        class="step-item"
		        :class="{
		          'step-active': index === passCurrentStep,
		          'step-completed': step.status === 'finish',
		          'step-error': step.status === 'error'
		        }"
		      >
		        <!-- 步骤图标 -->
		        <div class="step-icon">
		          <i v-if="step.icon" :class="step.icon" :style="{ color: step.status === 'error' ? '#F56C6C' : '#67C23A' }"></i>
		          <div v-else class="step-number">{{ index + 1 }}</div>
		        </div>
		        
		        <!-- 步骤内容 -->
		        <div class="step-content">
		          <div class="step-header">
		            <div class="step-title">{{ step.title }}</div>
		            
		            <!-- 重新补传按钮（只在第六步失败时显示） -->
		            <div v-if="step.showRetryButton && index === 5" class="step-retry-button">
		              <el-button
		                type="warning"
		                size="mini"
		                :loading="step.retryLoading"
		                @click="handleRetryUpload"
		                icon="el-icon-refresh"
		              >
		                重新补传
		              </el-button>
		            </div>
		          </div>
		          
		          <!-- 步骤描述 -->
		          <div v-if="step.description" class="step-description">
		            {{ step.description }}
		          </div>
		          
		          <div v-if="index === 1 && needUploadDrugs.length > 0" class="step-description">
		            需要上传追溯码的药品：
		            <ul>
		              <li v-for="drug in needUploadDrugs" :key="drug.drugName">
		                {{ drug.drugName }}
		              </li>
		            </ul>
		          </div>
		          
		          <div v-if="index === 4 && traceCodeCount > 0" class="step-description">
		            共提取到 {{ traceCodeCount }} 个追溯码
		          </div>
		          
		          <!-- 进度条 -->
		          <div v-if="step.showProgressBar && (step.status === 'process' || step.status === 'finish')" class="step-progress">
		            <el-progress
		              :percentage="step.progress"
		              :stroke-width="8"
		              :show-text="false"
		              :color="step.status === 'error' ? '#F56C6C' : '#409EFF'"
		            ></el-progress>
		            <div class="progress-text">{{ step.progress.toFixed(0) }}%</div>
		          </div>
		          
		          <!-- 完成状态 -->
		          <div v-if="step.status === 'finish' && step.progress >= 100" class="step-complete">
		            <i class="el-icon-success" style="color: #67C23A; margin-right: 5px;"></i>
		            已完成
		          </div>
		          
		          <!-- 错误状态 -->
		          <div v-if="step.status === 'error'" class="step-error">
		            <i class="el-icon-error" style="color: #F56C6C; margin-right: 5px;"></i>
		            失败
		          </div>
		        </div>
		      </div>
		    </div>
		    
		    <!-- 总进度条 -->
		    <div class="total-progress-section">
		      <div class="total-progress-title">总进度</div>
		      <el-progress
		        :percentage="totalProgress"
		        :stroke-width="12"
		        :color="totalProgress < 100 ? '#409EFF' : '#67C23A'"
		        :show-text="true"
		        :format="formatTotalProgress"
		      ></el-progress>
		    </div>
		  </div>
		  
		  <!-- 底部按钮区域 -->
		  <div slot="footer" class="progress-dialog-footer">
		    <!-- 关闭按钮（在上传失败时显示） -->
		    <el-button
		      v-if="showCloseButton"
		      size="small"
		      @click="handleCloseProgressDialog"
		    >
		      关闭
		    </el-button>
		  </div>
		</el-dialog>
		
		<!-- 采购计划详情抽屉 -->
		<el-drawer title="选择采购计划详情单" :visible.sync="purchasePlanDrawerVisible" direction="rtl" :modal="false" size="50%"
			:before-close="handleDrawerClose" class="purchase-plan-drawer">
			<div class="drawer-content">
				<!-- 搜索条件 -->
				<div class="drawer-search">
					<el-form :model="planQueryForm" inline class="plan-query-form" size="small">
						<el-form-item label="采购单号：">
							<el-input v-model="planQueryForm.docNum" placeholder="采购单号" clearable
								@keyup.enter="handlePlanQuery" />
						</el-form-item>
 
						<el-form-item label="开始时间：">
							<el-date-picker v-model="planQueryForm.startTime" type="date" placeholder="开始时间"
								value-format="yyyy-MM-dd" format="yyyy-MM-dd" />
						</el-form-item>
 
						<el-form-item label="结束时间：">
							<el-date-picker v-model="planQueryForm.endTime" type="date" placeholder="结束时间"
								value-format="yyyy-MM-dd" format="yyyy-MM-dd" />
						</el-form-item>
 
						<el-form-item>
							<el-button type="primary" @click="handlePlanQuery">查询</el-button>
							<el-button @click="resetPlanQuery">重置</el-button>
						</el-form-item>
					</el-form>
				</div>
 
				<!-- 采购计划列表 -->
				<div class="drawer-table">
					<el-table :data="purchasePlanList" stripe border style="width: 100%" height="calc(100vh - 250px)"
						v-loading="planLoading" @row-dblclick="handlePlanRowDblClick">
						<el-table-column type="index" label="#" width="50" align="center"></el-table-column>
 
						<el-table-column prop="docNum" label="采购单号" width="120" show-overflow-tooltip></el-table-column>
 
						<el-table-column prop="supplierName" label="供应商" width="150"
							show-overflow-tooltip></el-table-column>
 
						<el-table-column prop="createName" label="创建人" width="100"></el-table-column>
 
						<el-table-column prop="createTime" label="创建时间" width="120">
							<template slot-scope="scope">
								{{ formatDate(scope.row.createTime) }}
							</template>
						</el-table-column>
 
						<el-table-column prop="totalAmt" label="采购合计金额" width="120" align="right">
							<template slot-scope="scope">
								¥{{ scope.row.totalAmt ? formatDecimal(scope.row.totalAmt, 8) : '0.00' }}
							</template>
						</el-table-column>
 
						<el-table-column prop="state" label="状态" width="80" align="center">
							<template slot-scope="scope">
								<el-tag :type="getStatusType(scope.row.state)" size="small">
									{{ getStatusText(scope.row.state) }}
								</el-tag>
							</template>
						</el-table-column>
 
						<el-table-column label="操作" width="80" align="center">
							<template slot-scope="scope">
								<el-button type="text" size="mini" @click="selectPurchasePlan(scope.row)">
									选择
								</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
 
				<!-- 分页 -->
				<div class="drawer-pagination">
					<el-pagination :current-page="planPagination.currentPage" :page-size="planPagination.pageSize"
						:total="planPagination.total" layout="total, prev, pager, next, jumper"
						@current-change="handlePlanPageChange" size="small" />
				</div>
			</div>
		</el-drawer>
	</el-dialog>
</template>
 
<script>
	import { 
	  msfxCodeDetail, 
	  msfxGetEntInfoList, 
	  msfListUpoutDetail, 
	  msfxUploadInoutBill, 
	  msfxUploadRetail,
	  barcodeCheckBar,
	  barcodeScreen,
	  getSomeWare,  // 新增：根据药品名称和包装数量检索接口
	  getCJSomeWare  // 新增：根据批准文号和药品ID获取厂家信息接口
	} from "@/api/systemCatalogue/Western.js";
	
	// 系统参数列表
	import { getSystemList } from "@/api/systemParameter/systemParameter"
	
	import {
		selectDropDownList,
		getWare,
		getProdent,
		docMarkById,
		addXYFDrugStorage,
		getPutin,
		getPlans,
		getPlanData,
		getPurchasingPlan,
		toXYFDrugExamine,
		editXYFPurchase
	} from "@/api/PSI.js";
	import {
		addSupplierEntity
	} from "@/api/supplier.js";
	import {
		fastTransfer
	} from "@/api/systemCatalogue/Western.js";
	import {
		getDInfos,
		updateDrugInformation
	} from "@/api/MedicenCata.js";
	// import AddDrugDialog from './Western/addDialogVisible.vue';

	// 自定义指令：实现下拉框无限滚动
	const elSelectInfiniteScroll = {
		bind(el, binding) {
			const SELECTWRAPPER_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
			if (SELECTWRAPPER_DOM) {
				SELECTWRAPPER_DOM.addEventListener('scroll', function() {
					const condition = this.scrollHeight - this.scrollTop - 1 <= this.clientHeight;
					if (condition) {
						binding.value();
					}
				});
			}
		}
	};
 
	// 自定义指令：tooltip
	const elTooltip = {
		inserted(el, binding) {
			el.setAttribute('title', binding.value);
		}
	};
 
	export default {
		name: 'AddxyfModal',
		components: {
			// AddDrugDialog
		},
		directives: {
			'el-select-infinite-scroll': elSelectInfiniteScroll,
			'el-tooltip': elTooltip
		},
		props: {
			visible: {
				type: Boolean,
				default: false
			},
			mode: {
				type: String,
				default: 'add'
			},
			rowData: {
				type: Object,
				default: () => ({})
			},
			putinTypeList: {
				type: Array,
				default: () => []
			}
		},
		data() {
			return {
				dialogVisible: false,
				loading: false,
				saving: false,
				supplierLoading: false,
				supplierSaving: false,
				supplierDialogVisible: false,
				// 新增：默认药品列表
				defaultDrugOptions: [],
				showBottomAddButton: false, // 控制追溯码录入模态框底部“去添加”按钮
				// 新增：搜索定时器
				searchTimer: null,
				// 药品搜索相关
				drugSearchLoading: false,
				loadingMoreDrugs: false,
				drugOptions: [],
				drugPageNum: 1,
				drugPageSize: 50,
				drugHasMore: true,
				drugSearchQuery: '',
 
				// 当前选西的药品和厂商数据
				allDrugOptions: [], // 保存全部药品列表
				// 入库方式列表
				putinTypeListLocal: [],
 
				// 采购计划相关
				purchasePlanOptions: [],
				planOptionsLoading: false,
				purchasePlanDrawerVisible: false,
				purchasePlanList: [],
				planLoading: false,
				planQueryForm: {
					docNum: '',
					startTime: '',
					endTime: '',
					state: 5
				},
				planPagination: {
					currentPage: 1,
					pageSize: 10,
					total: 0
				},
 
				// 采购信息表单
				formData: {
				  warehouseId: 3, // 1西药库 2中药库,3西药房,4中药房
				  purchasePlanId: '',
				  businessDate: new Date().toISOString().split('T')[0],
				  invoiceNo: '',
				  supplierId: '',
				  entId: '', // 供应商的entId，直接命名为entId
				  supplierCode: '',
				  putinTypeId: 1,
				  remark: ''
				},
				formRules: {
					warehouseId: [{
						required: true,
						message: '请选择采购药库',
						trigger: 'change'
					}],
					supplierId: [{
						required: true,
						message: '请选择供货单位',
						trigger: 'change'
					}],
					putinTypeId: [{
						required: true,
						message: '请选择入库方式',
						trigger: 'change'
					}]
				},
				// 追溯码相关（原始模态框）
				traceCodeDialogVisible: false, // 控制追溯码录入模态框显示
				currentTraceMedicine: null, // 当前操作的药品
				traceCodeList: [], // 追溯码列表数据
				
				// 添加药品目录相关
				showAddDrugButton: false, // 是否显示添加药品目录按钮
				addDrugButtonText: '添加药品目录', // 按钮文本
				addDrugButtonDisabled: false, // 按钮是否禁用
				// 新增：记录getCJSomeWare接口是否返回空数据
				isCJSomeWareEmpty: false,
				// 添加药品目录模态框
				addDrugDialogVisible: false, // 控制添加药品目录模态框显示
				addDrugDialogLoading: false, // 添加药品目录加载状态
				addDrugDialogData: {
				  drugName: '', // 药品名称
				  spec: '', // 规格
				  pacCnt: 1, // 包装数量
				  approvalLicenceNo: '', // 批准文号
				  manufacturer: '', // 生产厂家
				  remark: '' // 备注
				},
				
				// 追溯码录入相关（新增的模态框）
				traceCodeInputDialogVisible: false, // 控制追溯码录入模态框显示
				traceCodeInputLoading: false, // 追溯码录入加载状态
				traceCodeInputData: null, // 存储msfxCodeDetail接口返回的数据
				traceCodeInputList: [], // 追溯码录入表格数据
				traceCodeInputForm: {
				  traceCode: '', // 追溯码
				  drugName: '', // 药品名称
				  spec: '', // 规格
				  inboundQty: 1, // 入库数量
				  purcType: 2, // 库存类型（默认包装单位）
				  pacCnt: 1, // 包装数量
				  manuLotnum: '', // 生产批号
				  manufacturer: '', // 生产厂家
				  manufacturerId: '', // 生产厂家ID
				  approvalLicenceNo: '', // 批准文号
				  produceDate: '', // 生产日期
				  expireDate: '', // 有效期
				  // 新增：生产厂家refEntId
				  refEntId: '',
				  dosageFormName: '', // 新增：剂型中文名称
				  remark: '' // 备注
				},
				// 接口返回的原始数据
				traceCodeDetailData: null,
				// 从getSomeWare接口返回的药品信息
				getSomeWareData: null,
				// 从getCJSomeWare接口返回的厂家信息
				getCJSomeWareData: null,
				// 加载状态
				getSomeWareLoading: false,
				getCJSomeWareLoading: false,
				// 新增：外部扫码输入相关
				outerScanInput: '', // 外部扫码输入框的值
				outerScanLoading: false, // 外部扫码加载状态
				// 追溯码补录相关
				traceCodeSupplementDialogVisible: false, // 控制追溯码补录模态框显示
				traceCodeSupplementList: [], // 追溯码补录表格数据
				
				// 管理员测试相关
				adminModeWindow: false, // 管理员模式窗口期
				adminKeyHandler: null, // 按键监听器
				pendingTraceCode: '', // 待处理的追溯码
				adminTestDialogVisible: false, // 管理员测试模态框显示
				adminTestList: [], // 管理员测试列表
				adminTestLoading: false, // 管理员测试加载状态
				adminWindowTimer: null, // 管理员窗口期定时器,
		
				// 追溯码模态框相关
				traceCodeDialogTitle: '追溯码录入',
				traceCodeLoading: false,
					
				// 新增：扫码输入
				scanInput: '',
				
				// 系统参数相关
				systemParameterList: [], // 系统参数列表
				msfxEntId: '', // 码上放心entid
				systemParameterLoading: false, // 系统参数加载状态
					
				// 新增：总追溯码数量
				totalTraceQty: 0,
				// 供应商表单
				supplierForm: {
					address: "",
					clinicId: 0,
					contact: "",
					contactPhone: "",
					id: 0,
					payAmt: 0,
					permitNumber: "",
					entId: "",
					receAmt: 0,
					remark: "",
					status: 1,
					supplierName: ""
				},
				supplierRules: {
					supplierName: [{
						required: true,
						message: '供应商名称为必填项',
						trigger: 'blur'
					}],
					contact: [{
						required: true,
						message: '联系人为必填项',
						trigger: 'blur'
					}],
					contactPhone: [{
						required: true,
						message: '联系人电话为必填项',
						trigger: 'blur'
					}],
					status: [{
						required: true,
						message: '请选择状态',
						trigger: 'change'
					}]
				},
				// 关键词高亮相关
				currentSearchKeyword: '', // 当前搜索关键词
				highlightColor: '#ff6700', // 高亮颜色
				existingDrugData: null, // 存储getDInfos接口返回的数据
				currentDrugName: '', // 当前药品名称
				// 新增：允许重新选择药品控制
				allowReselectAll: false, // 允许重新选择药品复选框状态
				// 供货单位列表
				supplierList: [],
				// 药品明细列表
				medicineList: [],
				// 汇总信息
				totalInboundQty: 0,
				totalCost: 0,
				totalRetail: 0,
				// 过单进度模态框相关
				    passProgressDialogVisible: false, // 过单进度模态框显示
				    passProgressSteps: [
				      { 
				        title: '当前单据已过单', 
				        status: 'wait', 
				        progress: 0, 
				        icon: '',
				        description: '',
				        showProgressBar: true,
				        showRetryButton: false, // 是否显示重新补传按钮
				        retryLoading: false // 重新补传加载状态
				      },
				      { 
				        title: '正在获取系统参数...', 
				        status: 'wait', 
				        progress: 0, 
				        icon: '',
				        description: '',
				        showProgressBar: true,
				        showRetryButton: false
				      },
				      { 
				        title: '正在验证是否需要上传追溯码', 
				        status: 'wait', 
				        progress: 0, 
				        icon: '',
				        description: '',
				        showProgressBar: true,
				        showRetryButton: false
				      },
				      { 
				        title: '正在提取追溯码...', 
				        status: 'wait', 
				        progress: 0, 
				        icon: '',
				        description: '',
				        showProgressBar: true,
				        showRetryButton: false
				      },
				      { 
				        title: '追溯码提取成功', 
				        status: 'wait', 
				        progress: 0, 
				        icon: '',
				        description: '',
				        showProgressBar: true,
				        showRetryButton: false
				      },
				      { 
				        title: '正在连接码上放心平台进行追溯码上传', 
				        status: 'wait', 
				        progress: 0, 
				        icon: '',
				        description: '',
				        showProgressBar: true,
				        showRetryButton: false
				      },
				      { 
				        title: '上传追溯码已完成', 
				        status: 'wait', 
				        progress: 0, 
				        icon: '',
				        description: '',
				        showProgressBar: true,
				        showRetryButton: false
				      }
				    ],
				    passCurrentStep: 0, // 当前步骤索引
				    passLoading: false, // 过单加载状态
				    needUploadTraceCode: false, // 是否需要上传追溯码
				    traceCodeCount: 0, // 追溯码数量
				    traceCodeString: '', // 追溯码字符串
				    needUploadDrugs: [], // 需要上传追溯码的药品列表
				    
				    // 进度条相关
				    progressTimer: null, // 进度条计时器
				    totalProgress: 0, // 总进度
				    showCloseButton: false, // 是否显示关闭按钮
			};
		},
		computed: {
			// 新增：调试模式
			isDebugMode() {
				return process.env.NODE_ENV === 'development';
			},
			isAddButtonDisabled() {
			  // 当药品存在于系统目录中时禁用，即 drugExistsInSystem 为 true 时禁用
			  return this.drugExistsInSystem;
			},
			getAddButtonTooltip() {
			  if (this.isAddButtonDisabled) {
			    return '当前药品已存在于系统目录中无需再次添加！';
			  }
			  return '';
			},
			getDialogTitle() {
				const docNum = this.rowData ? this.rowData.docNum : '';
				const warehouseName = this.formData.warehouseId === 1 ? '西药库' : '西药房';
				const titles = {
					'add': `创建【${warehouseName}】入库单`,
					'view': `查看（${docNum}） - 入库单`,
					'edit': `修改（${docNum}） - 入库单`,
					'submit': `提交（${docNum}） - 入库单`,
					'review': `审核（${docNum}） - 入库单`,
					'pass': `完成入库（${docNum}） - 入库单`,
					'rollback': `回退（${docNum}） - 入库单`,
					'fast': `将西药库 - ${docNum} - 快速调至药房`
				};
				return titles[this.mode] || '入库单';
			},
			warehouseName() {
				return this.formData.warehouseId === 1 ? '西药库' : '西药房';
			},
			computedPutinTypeList() {
				return this.putinTypeListLocal.length > 0 ? this.putinTypeListLocal : this.putinTypeList;
			},
			// 是否可以确认追溯码录入
			canConfirmTraceCodeInput() {
			    return this.validateTraceCodeInputForm();
			},
			// 判断药品是否存在于系统中
			drugExistsInSystem() {
			    return this.getSomeWareData && 
			           this.getSomeWareData !== '' && 
			           (!Array.isArray(this.getSomeWareData) || this.getSomeWareData.length > 0);
			},
			// 模式判断
			isViewMode() {
				return this.mode === 'view';
			},
			isEditMode() {
				return this.mode === 'edit';
			},
			isSubmitMode() {
				return this.mode === 'submit';
			},
			isReviewMode() {
				return this.mode === 'review';
			},
			isPassMode() {
				return this.mode === 'pass';
			},
			isRollbackMode() {
				return this.mode === 'rollback';
			},
			isFastMode() {
				return this.mode === 'fast';
			},
			isAddMode() {
				return this.mode === 'add';
			}
		},
		watch: {
			visible: {
				immediate: true,
				handler(newVal) {
					this.dialogVisible = newVal;
					if (newVal) {
						this.initData();
						this.loadSuppliers();
						this.loadPutinTypes();
						this.loadPurchasePlanOptions();
 
						// 加载默认药品列表
						this.loadDefaultDrugs();
					}
				}
			},
			medicineList: {
				handler: function(newVal) {
					this.calculateSummary();
				},
				deep: true
			}
		},
		mounted() {
			// 初始化药品搜索
			this.loadDrugs();
		},
		// 组件销毁前清理
		// 在beforeDestroy方法中添加判断
		beforeDestroy() {
		  // 检查unbindAdminKeyListener是否存在
		  if (this.unbindAdminKeyListener && typeof this.unbindAdminKeyListener === 'function') {
		    this.unbindAdminKeyListener();
		  }
		  this.adminModeWindow = false;
		  
		  // 清除定时器
		  if (this.adminWindowTimer) {
		    clearTimeout(this.adminWindowTimer);
		    this.adminWindowTimer = null;
		  }
		  
		  // 清除进度计时器
		  if (this.progressTimer) {
		    clearInterval(this.progressTimer);
		    this.progressTimer = null;
		  }
		  
		  // 确保关闭所有模态框
		  this.addDrugDialogVisible = false;
		  this.traceCodeInputDialogVisible = false;
		  this.traceCodeDialogVisible = false;
		  this.traceCodeSupplementDialogVisible = false;
		  this.passProgressDialogVisible = false;
		},
		methods: {
			// 格式化总进度显示
			  formatTotalProgress(percentage) {
			    return `总进度: ${percentage}%`;
			  },
			  
			// 新增：格式化货币金额（千位分隔符，最多8位小数）
			formatCurrency(value) {
			  if (value === null || value === undefined || isNaN(value)) {
				return '0';
			  }
			  
			  const num = parseFloat(value);
			  if (isNaN(num)) {
				return '0';
			  }
			  
			  // 获取整数部分和小数部分
			  const parts = num.toString().split('.');
			  let integerPart = parts[0];
			  let decimalPart = parts[1] || '';
			  
			  // 对整数部分添加千位分隔符
			  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
			  
			  // 处理小数部分（最多保留8位，不强制补零）
			  if (decimalPart) {
				// 最多保留8位小数
				decimalPart = decimalPart.length > 8 ? decimalPart.substring(0, 8) : decimalPart;
				return `${integerPart}.${decimalPart}`;
			  } else {
				return integerPart;
			  }
			},
			
			// // 格式化小数，保留指定位数，不补零
			formatDecimal(value, maxDecimals = 8) {
			  if (value === null || value === undefined) return '0';
			  
			  const num = parseFloat(value);
			  if (isNaN(num)) return '0';
			  
			  // 获取实际的小数位数
			  const decimalPlaces = (num.toString().split('.')[1] || '').length;
			  // 使用实际小数位数，但不超过最大限制
			  const places = Math.min(decimalPlaces, maxDecimals);
			  
			  return num.toFixed(places);
			},
 
			// 加载入库方式列表
			async loadPutinTypes() {
				try {
					const response = await getPutin();
					if (response && response.code === 200 && response.data) {
						this.putinTypeListLocal = response.data;
						this.formData.putinTypeId = 1;
					}
				} catch (error) {
					console.error('加载入库方式失败:', error);
					this.$message.error('加载入库方式失败');
				}
			},
 
			// 加载采购计划下拉选项
			async loadPurchasePlanOptions() {
				this.planOptionsLoading = true;
				try {
					const response = await getPlans();
					if (response && response.code === 200) {
						this.purchasePlanOptions = response.data || [];
					}
				} catch (error) {
					console.error('加载采购计划下拉选项失败:', error);
				} finally {
					this.planOptionsLoading = false;
				}
			},
 
			// 新增：记录药品信息
			logDrugInfo(row, context) {
				if (this.isDebugMode) {
					console.log(`[药品信息] ${context}`, {
						mode: this.mode,
						drugId: row.drugId,
						drugName: row.drugName,
						spec: row.spec,
						packageSpec: row.packageSpec,
						isNewRow: row.isNewRow
					});
				}
			},
 
			// 采购计划单变化
			handlePlanCodeChange(planId) {
				if (planId) {
				    this.loadPurchasePlanDetails(planId);
				  } else {
				    this.clearPurchasePlanData();
				    // 同时清除所有明细的 planId
				    this.medicineList.forEach(item => {
				      item.planId = '';
				    });
				  }
			},
 
			// 加载采购计划详情
			async loadPurchasePlanDetails(planId) {
				try {
					const response = await getPlanData({
						id: planId
					});
					if (response && response.code === 200) {
						this.fillPurchasePlanData(response.data);
					} else {
						this.$message.error(response.message || '获取采购计划详情失败');
					}
				} catch (error) {
					console.error('加载采购计划详情失败:', error);
					this.$message.error('加载采购计划详情失败');
				}
			},
 
			// 填充采购计划数据
			async fillPurchasePlanData(planData) {
			  if (!planData) return;
			  this.formData.supplierId = planData.supplierId || '';
			  this.formData.supplierCode = planData.supplierCode || '';
			  this.medicineList = [];
			  if (planData.list && planData.list.length > 0) {
			    for (const item of planData.list) {
			      // 关键修改：使用明细项自身的 planId，而不是采购计划主 ID
			      const newMedicine = await this.createMedicineFromPlan(item, item.planId);
			      this.medicineList.push(newMedicine);
			    }
			  }
			  this.$message.success('采购计划数据已加载');
			},
			
			// 新增：根据药品名称搜索药品（返回搜索结果列表）
			async searchDrugsByName(drugName) {
			  if (!drugName || !drugName.trim()) return [];
			  try {
			    const response = await getWare({ pageNum: 1, pageSize: 50, name: drugName.trim() });
			    if (response && response.code === 200) {
			      const drugs = response.data?.content || response.data || [];
			      return drugs.map(drug => ({
			        id: drug.id,
			        drugName: drug.drugName || drug.name || drug.label,
			        drugSpecifications: drug.drugSpecifications || drug.drugSpec || '',
			        pacSpec: drug.pacSpec || '',
			        markUpId: drug.markUpId || 1,
			        isFixPrice: drug.isFixPrice || 0,
			        costPric: drug.costPric || 0,
			        dosUnt: drug.dosUnt || '单位',
			        pacUnt: drug.pacUnt || '包装单位',
			        pacCnt: drug.pacCnt || 1,
			        manufacturerName: drug.manufacturerName || drug.manufacturer || '',
			        isBar: drug.isBar || 0,
			        periodControl: drug.periodControl !== undefined ? parseInt(drug.periodControl) : 1, // 修改
			        expyDate: drug.expyDate !== undefined && drug.expyDate !== null ? parseInt(drug.expyDate) : null, // 新增
			      }));
			    }
			  } catch (error) {
			    console.error('搜索药品失败:', error);
			  }
			  return [];
			},
			
			// 优化：从采购计划项创建药品行，支持通过药品名称搜索并正确匹配
			async createMedicineFromPlan(planItem, planId) {
			  const newMedicine = {
			    id: planItem.id || '',
			    drugId: planItem.drugId || '',
			    drugName: planItem.drugName || '',
			    inboundQty: planItem.purcCnt || 1,
			    purcType: planItem.purcType || 2,
			    pacCnt: planItem.pacCnt || 1,
			    planId: planId || '',
			    manuLotnum: planItem.manuLotnum || '',
			    manuDate: planItem.manuDate || '',
			    expyDate: planItem.expyDate || '',
			    prodentpNameId: planItem.prodentpNameId || '',
			    manufacturer: planItem.prodentpName || '',
			    manufacturerOptions: [],
			    manufacturerLoading: false,
			    costPric: planItem.purcPric || 0,
			    totalCost: 0,
			    salePric: planItem.salePric || 0,
			    totalRetail: 0,
			    markupMethod: planItem.markupMethod || 1,
			    spec: planItem.drugSpec || '',
			    packageSpec: planItem.pacSpec || '',
			    dosUnt: planItem.dosUnt || '单位',
			    pacUnt: planItem.pacUnt || '包装单位',
			    unitLabel: (planItem.purcType === 1 ? planItem.dosUnt : planItem.pacUnt) || '单位',
			    expyDateDisabled: false,
			    isBar: 0,
			    traceCodes: [],
			    tracCodeJson: '',
			    // 新增：用于搜索的结果存储
			    drugSearchQuery: '',
			    drugSearchResults: [],
			    drugLoading: false
			  };
			
			  // 先尝试通过 drugId 获取药品详情
			  let drugMatched = false;
			  if (newMedicine.drugId) {
			    const existingDrug = this.drugOptions.find(d => d.id == newMedicine.drugId);
			    if (existingDrug) {
			      // 直接使用已有药品信息
			      this.applyDrugToRow(newMedicine, existingDrug);
			      drugMatched = true;
			    } else {
			      // 尝试通过接口获取
			      try {
			        const response = await getWare({ pageNum: 1, pageSize: 1, drugName: newMedicine.drugName });
			        if (response && response.code === 200) {
			          const drugList = response.data?.content || response.data;
			          if (drugList && drugList.length) {
			            const drug = drugList[0];
			            this.applyDrugToRow(newMedicine, drug);
			            drugMatched = true;
			            // 添加到全局选项
			            if (!this.drugOptions.some(d => d.id === drug.id)) {
			              this.drugOptions.push(drug);
			            }
			          }
			        }
			      } catch (e) {
			        console.warn('通过 drugId 获取药品失败:', e);
			      }
			    }
			  }
			
			  // 如果通过 drugId 未匹配成功，则使用药品名称搜索并匹配
			  if (!drugMatched && planItem.drugName) {
			    const searchResults = await this.searchDrugsByName(planItem.drugName);
			    let matchedDrug = null;
			    // 优先按 drugId 匹配
			    if (newMedicine.drugId) {
			      matchedDrug = searchResults.find(d => d.id == newMedicine.drugId);
			    }
			    // 如果还没有匹配，按名称精确匹配（去除空格后对比）
			    if (!matchedDrug && planItem.drugName) {
			      const normalizedName = planItem.drugName.trim().toLowerCase();
			      matchedDrug = searchResults.find(d => 
			        (d.drugName || '').trim().toLowerCase() === normalizedName
			      );
			    }
			    // 如果还没有，取第一个结果
			    if (!matchedDrug && searchResults.length) {
			      matchedDrug = searchResults[0];
			    }
			    if (matchedDrug) {
			      this.applyDrugToRow(newMedicine, matchedDrug);
			      // 确保全局选项中有该药品
			      if (!this.drugOptions.some(d => d.id === matchedDrug.id)) {
			        this.drugOptions.push(matchedDrug);
			      }
			      // 保存搜索结果到行，用于下拉框显示（确保下拉框能看到匹配的药品）
			      newMedicine.drugSearchResults = searchResults;
			      newMedicine.drugSearchQuery = planItem.drugName;
			      drugMatched = true;
			    } else {
			      console.warn('未找到匹配的药品, 药品名称:', planItem.drugName);
			    }
			  }
			
			  // 如果仍然没有匹配，则保留原 drugId 作为临时显示（显示 drugId）
			  if (!drugMatched && newMedicine.drugId) {
			    newMedicine.drugName = planItem.drugName || String(newMedicine.drugId);
			  }
			
			  // 加载生产厂家选项
			  if (newMedicine.drugId) {
			    await this.loadManufacturers(newMedicine);
			  }
			
			  this.calculateRowAmount(newMedicine);
			  return newMedicine;
			},
			
			// 辅助方法：将药品对象信息应用到行
			applyDrugToRow(row, drug) {
			  row.drugId = drug.id;
			  row.drugName = drug.drugName;
			  row.spec = drug.drugSpecifications || drug.drugSpec || '';
			  row.packageSpec = drug.pacSpec || '';
			  row.costPric = drug.costPric || 0;
			  row.pacCnt = drug.pacCnt || 1;
			  row.dosUnt = drug.dosUnt || '单位';
			  row.pacUnt = drug.pacUnt || '包装单位';
			  row.isBar = drug.isBar || 0;
			  row.markUpId = drug.markUpId || 1;
			  row.isFixPrice = drug.isFixPrice || 0;
			  row.markupMethodText = this.getMarkupMethodText(row.markUpId, row.isFixPrice);
			  row.isFixedPriceText = row.isFixPrice === 1 ? '已指定' : '未指定';
			  row.unitLabel = row.purcType === 1 ? row.dosUnt : row.pacUnt;
			  row.periodControl = drug.periodControl !== undefined ? parseInt(drug.periodControl) : 1;
			  row.expyDateDisabled = row.periodControl === 0;
			  row.expyDateDays = drug.expyDate !== undefined && drug.expyDate !== null ? parseInt(drug.expyDate) : null;  // 新增
			
			  // 根据加成方式计算零售价
			  if (row.costPric > 0) {
			    if (row.markUpId === 4) {
			      row.salePric = row.costPric;
			    } else {
			      this.loadMarkupInfo(row);
			    }
			  }
			  this.calculateRowAmount(row);
			},
 
			// 为采购计划项加载药品详情
			async loadDrugDetailsForPlanItem(medicine) {
			  try {
			    const response = await getWare({
			      pageNum: 1,
			      pageSize: 1,
			      id: medicine.drugId
			    });
			
			    if (response && response.code === 200 && response.data) {
			      const drugList = response.data.content || response.data;
			      if (drugList.length > 0) {
			        const drug = drugList[0];
			
			        // 设置加成方式
			        medicine.markupMethodText = this.getMarkupMethodText(
			          drug.markUpId || 1,
			          drug.isFixPrice || 0
			        );
					medicine.periodControl = drug.periodControl !== undefined ? parseInt(drug.periodControl) : 1;
					medicine.expyDateDays = drug.expyDate !== undefined && drug.expyDate !== null ? parseInt(drug.expyDate) : null; // 新增
					medicine.expyDateDisabled = medicine.periodControl === 0;
			        // 设置是否指定售价
			        medicine.isFixedPriceText = drug.isFixPrice === 1 ? '已指定' : '未指定';
					// 关键修改：如果是不加成（markUpId=4），零售价直接等于成本价
					  if (row.markUpId === 4) {
					    console.log(`markUpId=${row.markUpId}（不加成），设置零售价等于成本价`);
					    row.salePric = row.costPric * row.inboundQty || 0;
					  }
			        // 更新药品信息
			        medicine.drugName = drug.drugName || medicine.drugName;
			        medicine.spec = drug.drugSpecifications || drug.drugSpec || medicine.spec;
			        medicine.packageSpec = drug.pacSpec || medicine.packageSpec;
			        
			        // 关键：获取isBar字段
			        medicine.isBar = drug.isBar || 0;
			        console.log('采购计划药品isBar字段:', medicine.isBar, '药品名称:', medicine.drugName);
			
			        // 将药品添加到下拉选项列表中
			        if (!this.drugOptions.some(item => item.id === drug.id)) {
			          this.drugOptions.push(drug);
			        }
			      }
			    }
			  } catch (error) {
			    console.error('加载药品详情失败:', error);
			  }
			},
 
			// 清空采购计划数据
			clearPurchasePlanData() {
				this.formData.supplierId = '';
				this.formData.supplierCode = '';
				this.medicineList = [];
			},
 
			// 打开采购计划抽屉
			openPurchasePlanDrawer() {
				this.purchasePlanDrawerVisible = true;
				this.loadPurchasePlanList();
			},
 
			// 加载采购计划列表
			async loadPurchasePlanList() {
				this.planLoading = true;
				try {
					const params = {
						pageNum: this.planPagination.currentPage,
						pageSize: this.planPagination.pageSize,
						startTime: this.planQueryForm.startTime,
						endTime: this.planQueryForm.endTime,
						state: this.planQueryForm.state,
						docNum: this.planQueryForm.docNum
					};
 
					const response = await getPurchasingPlan(params);
					if (response && response.code === 200) {
						this.purchasePlanList = response.data.content || response.data || [];
						this.planPagination.total = response.data.totalSize || response.data.totalElements || 0;
					} else {
						this.$message.error(response.message || '加载采购计划列表失败');
					}
				} catch (error) {
					console.error('加载采购计划列表失败:', error);
					this.$message.error('加载采购计划列表失败');
				} finally {
					this.planLoading = false;
				}
			},
			
			// 获取系统参数列表
			async getSystemParameters() {
			  try {
			    this.systemParameterLoading = true;
			    console.log('开始获取系统参数列表');
			    
			    const response = await getSystemList();
			    console.log('系统参数接口返回:', response);
			    
			    if (response && response.code === 200 && response.data) {
			      this.systemParameterList = response.data;
			      console.log('系统参数列表:', this.systemParameterList);
			      
			      // 查找码上放心entid
			      this.findMsfxEntId();
			      
			      return true;
			    } else {
			      console.warn('获取系统参数失败:', response?.message);
			      return false;
			    }
			  } catch (error) {
			    console.error('获取系统参数异常:', error);
			    return false;
			  } finally {
			    this.systemParameterLoading = false;
			  }
			},
			
			// 查找码上放心entid
			findMsfxEntId() {
			  if (!this.systemParameterList || this.systemParameterList.length === 0) {
			    console.warn('系统参数列表为空');
			    this.msfxEntId = '';
			    return;
			  }
			  
			  console.log('开始查找码上放心entid');
			  
			  // 查找name为"码上放心entid"的参数
			  const msfxParam = this.systemParameterList.find(param => 
			    param.name && param.name.trim() === '码上放心entid'
			  );
			  
			  if (msfxParam && msfxParam.value) {
			    this.msfxEntId = msfxParam.value.trim();
			    console.log('找到码上放心entid:', this.msfxEntId);
			  } else {
			    console.warn('未找到码上放心entid参数');
			    this.msfxEntId = '';
			    
			    // 尝试其他可能的名称
			    const possibleNames = ['码上放心entid', 'msfxEntId', 'ent_id', 'entId', '码上放心_entid'];
			    for (const name of possibleNames) {
			      const param = this.systemParameterList.find(p => 
			        p.name && p.name.trim().toLowerCase() === name.toLowerCase()
			      );
			      if (param && param.value) {
			        this.msfxEntId = param.value.trim();
			        console.log(`通过别名"${name}"找到码上放心entid:`, this.msfxEntId);
			        break;
			      }
			    }
			  }
			},
			
			// 采购计划搜索
			handlePlanQuery() {
				this.planPagination.currentPage = 1;
				this.loadPurchasePlanList();
			},
 
			// 重置采购计划查询
			resetPlanQuery() {
				this.planQueryForm = {
					docNum: '',
					startTime: '',
					endTime: '',
					state: 5
				};
				this.planPagination.currentPage = 1;
				this.loadPurchasePlanList();
			},
 
			// 采购计划行双击
			handlePlanRowDblClick(row) {
				this.fillPurchasePlanData(row);
				this.purchasePlanDrawerVisible = false;
			},
 
			// 采购计划行点击
			selectPurchasePlan(row) {
				this.fillPurchasePlanData(row);
				this.purchasePlanDrawerVisible = false;
			},
 
			// 采购计划分页变化
			handlePlanPageChange(page) {
				this.planPagination.currentPage = page;
				this.loadPurchasePlanList();
			},
 
			// 获取选西的采购计划信息
			getSelectedPlanInfo() {
				if (!this.formData.purchasePlanId) return '';
				const selectedPlan = this.purchasePlanOptions.find(item => item.id === this.formData.purchasePlanId);
				return selectedPlan ?
					`${selectedPlan.planNo || selectedPlan.docNum} - ${selectedPlan.supplierName || ''}` : '';
			},
 
			// 获取加成方式显示文字
			getMarkupMethodText(markUpId, isFixPrice) {
				switch (markUpId) {
					case 1:
						return '比例加成';
					case 2:
						return '固定加成';
					case 3:
						return '手工比例加成';
					case 4:
						return '不加成';
					default:
						return '未知';
				}
			},
 
			// 关闭抽屉
			handleDrawerClose(done) {
				this.$confirm('确认关闭抽屉吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					done();
				}).catch(() => {});
			},
 
			// 初始化数据
			initData() {
				if (this.mode === 'add') {
					this.resetForm();
				} else if (this.rowData) {
					this.fillDataFromRowData();
				}
 
				// 加载默认药品列表
				this.loadDefaultDrugs();
				
				if (this.$refs.inboundForm) {
					this.$refs.inboundForm.clearValidate();
				}
			},
 
			// 从行数据填充表单
			async fillDataFromRowData() {
				if (!this.rowData) return;
 
				console.log('从行数据填充表单，行数据:', this.rowData);
 
				// 保存原始药品数据
				this.originalDrugDetails = this.rowData;
 
				// 填充采购信息
				this.formData = {
					warehouseId: this.rowData.shedId || 3,
					purchasePlanId: this.rowData.planId || '',
					businessDate: this.rowData.invoDate || new Date().toISOString().split('T')[0],
					invoiceNo: this.rowData.purcInvoCodg || '',
					supplierId: this.rowData.supplyCandidateId || '',
					supplierCode: this.rowData.supplyCode || '',
					putinTypeId: this.rowData.putinTypeId || 1,
					remark: this.rowData.remarks || ''
				};
 
				// 关键优化：在所有非新增模式下，都需要确保药品信息完整
				if (this.mode !== 'add' && this.rowData.list && this.rowData.list.length > 0) {
				    console.log(`${this.mode}模式，开始加载药品信息`);
				
				    // 先确保药品选项中有这些药品（等待加载完成）
				    await this.ensureDrugsInOptions();
				
				    // 再创建药品列表
				    this.medicineList = [];
				    for (const item of this.rowData.list) {
				        const newMedicine = await this.createMedicineFromRowData(item);
				        this.medicineList.push(newMedicine);
				    }
				}
 
				// 计算汇总
				this.calculateSummary();
 
				console.log('药品明细填充完成:', this.medicineList);
			},
 
			// 修改：获取药品选项（根据模式）
			getDrugOptionsForMode(row) {
				if (this.mode === 'edit' && !this.allowReselectAll) {
					// 修改模式下，不允许重新选择，从drugOptions西查找当前药品
					if (row.drugId) {
						const currentDrug = this.drugOptions.find(drug => drug.id === row.drugId);
						if (currentDrug) {
							return [currentDrug];
						} else {
							// 如果没有找到，创建临时选项
							return [{
								id: row.drugId,
								drugName: row.drugName || '未知药品',
								label: row.drugName || '未知药品'
							}];
						}
					} else {
						return [];
					}
				} else {
					// 其他模式或允许重新选择，使用全局药品列表
					return this.drugOptions;
				}
			},
 
			// 新增：确保药品在drugOptions西
			async ensureDrugsInOptions() {
				if (!this.rowData || !this.rowData.list) return;
 
				console.log(`开始确保药品在drugOptions中，模式：${this.mode}`);
 
				const drugIds = this.rowData.list
					.filter(item => item.drugId)
					.map(item => item.drugId);
 
				if (drugIds.length === 0) {
					console.log('没有药品ID需要加载');
					return;
				}
 
				console.log('需要加载的药品ID:', drugIds);
 
				// 分批加载缺失的药品
				for (const drugId of drugIds) {
					await this.loadDrugByIdForOptions(drugId);
				}
			},
 
			// 新增：为药品选项列表加载药品
			async loadDrugByIdForOptions(drugId) {
				try {
					const response = await getWare({
						pageNum: 1,
						pageSize: 1,
						id: drugId
					});
 
					if (response && response.code === 200 && response.data) {
						const drugList = response.data.content || response.data;
						if (drugList.length > 0) {
							const drug = drugList[0];
 
							// 检查是否已存在
							const exists = this.drugOptions.some(item => item.id === drug.id);
							if (!exists) {
								this.drugOptions.push(drug);
								console.log('药品已添加到drugOptions:', drug.drugName);
							}
						}
					}
				} catch (error) {
					console.error('为选项列表加载药品失败:', error);
				}
			},
 
			// 新增：通过ID加载药品（适用于行数据）
			async loadDrugByIdForRowData(drugId) {
				try {
					console.log('通过ID加载药品（行数据）:', drugId);
 
					// 从行数据西找到对应的药品
					const drugItem = this.rowData.list.find(item => item.drugId === drugId);
					if (!drugItem) {
						console.log('在行数据西未找到药品:', drugId);
						return;
					}
 
					// 首先尝试通过ID精确匹配
					const response = await getWare({
						pageNum: 1,
						pageSize: 1,
						id: drugId
					});
 
					if (response && response.code === 200 && response.data) {
						const drugList = response.data.content || response.data;
						if (drugList.length > 0) {
							const drug = drugList[0];
							console.log('通过ID找到药品:', drug);
 
							// 将药品添加到drugOptions西
							if (!this.drugOptions.some(item => item.id === drug.id)) {
								this.drugOptions.push(drug);
								console.log('药品已添加到drugOptions:', drug.drugName);
							}
 
							return drug;
						} else {
							console.log('通过ID未找到药品，尝试通过名称搜索');
							await this.searchDrugByNameFromRowData(drugId, drugItem);
						}
					}
				} catch (error) {
					console.error('通过ID加载药品失败:', error);
					// 如果通过ID失败，尝试通过名称搜索
					const drugItem = this.rowData.list.find(item => item.drugId === drugId);
					if (drugItem) {
						await this.searchDrugByNameFromRowData(drugId, drugItem);
					}
				}
				return null;
			},
 
			// 新增：通过行数据西的药品名称搜索药品
			async searchDrugByNameFromRowData(drugId, drugItem) {
				if (!drugItem || !drugItem.drugName) {
					console.log('药品名称为空，无法搜索');
					return;
				}
 
				console.log('通过药品名称搜索:', drugItem.drugName);
 
				try {
					const response = await getWare({
						pageNum: 1,
						pageSize: 50,
						name: drugItem.drugName
					});
 
					if (response && response.code === 200 && response.data) {
						const drugList = response.data.content || response.data;
						console.log('搜索到药品数量:', drugList.length);
 
						// 在搜索结果西查找匹配的药品
						const foundDrug = drugList.find(drug => {
							// 比较ID是否匹配
							if (drug.id === drugId) {
								return true;
							}
							// 或者比较名称是否相同（去除空格和特殊字符）
							const drugName1 = (drug.drugName || '').trim().toLowerCase();
							const drugName2 = (drugItem.drugName || '').trim().toLowerCase();
							return drugName1 === drugName2;
						});
 
						if (foundDrug) {
							console.log('通过名称找到药品:', foundDrug);
 
							// 将药品添加到drugOptions西
							if (!this.drugOptions.some(item => item.id === foundDrug.id)) {
								this.drugOptions.push(foundDrug);
								console.log('药品已添加到drugOptions:', foundDrug.drugName);
							}
						} else {
							console.log('搜索结果西未找到匹配的药品，创建临时药品');
							this.createTemporaryDrugFromRowData(drugItem);
						}
					}
				} catch (error) {
					console.error('通过名称搜索药品失败:', error);
					this.createTemporaryDrugFromRowData(drugItem);
				}
			},
 
			// 新增：为行数据创建临时药品
			createTemporaryDrugFromRowData(drugItem) {
				const tempDrug = {
					id: drugItem.drugId,
					drugName: drugItem.drugName,
					drugSpecifications: drugItem.drugSpec,
					pacSpec: drugItem.pacSpec,
					markUpId: drugItem.markUpId || 1,
					isFixPrice: drugItem.isFixPrice || 0
				};
 
				if (!this.drugOptions.some(item => item.id === tempDrug.id)) {
					this.drugOptions.push(tempDrug);
					console.log('已创建临时药品并添加到drugOptions:', tempDrug);
				}
			},
 
			// 修改：获取药品选项（根据行）
			getDrugOptionsForRow(row) {
				if (!row) return [];
			  console.log('获取药品选项:', {
			    mode: this.mode,
			    isNewRow: row.isNewRow,
			    drugId: row.drugId,
			    drugName: row.drugName,
			    isViewOrProcessMode: this.isViewMode || this.isSubmitMode || this.isReviewMode || 
				this.isPassMode || this.isRollbackMode || this.isFastMode
			  });
			  
			  // 如果是查看、提交、审核、过单、回退、快速调拨等只读模式
			  if (this.isViewMode || this.isSubmitMode || this.isReviewMode || 
			      this.isPassMode || this.isRollbackMode || this.isFastMode) {
			    console.log('只读模式，返回当前药品信息:', row.drugName || row.drugId);
			    
			    // 在这些只读模式下，只需要显示当前药品，不需要搜索选项
			    if (row.drugId) {
			      // 尝试从drugOptions中查找完整的药品信息
			      const foundDrug = this.drugOptions.find(drug => drug.id === row.drugId);
			      if (foundDrug) {
			        console.log('在drugOptions中找到药品:', foundDrug.drugName);
			        return [foundDrug];
			      } else {
			        // 如果没有找到完整药品信息，创建包含药品名称的选项
			        return [{
			          id: row.drugId,
			          drugName: row.drugName || '未知药品',
			          label: row.drugName || row.drugId, // 关键修复：使用drugName而不是drugId
			          drugSpecifications: row.spec,
			          pacSpec: row.packageSpec
			        }];
			      }
			    }
			    return [];
			  }
			  
			  // 如果是新增模式
			  if (this.mode === 'add') {
			    // 如果有搜索查询，使用搜索结果
			    if (row.drugSearchQuery && row.drugSearchQuery.trim()) {
			      console.log('新增模式，使用搜索结果:', row.drugSearchResults?.length);
			      return row.drugSearchResults || [];
			    }
			    // 否则使用全局药品列表
			    console.log('新增模式，使用全局列表:', this.drugOptions.length);
			    return this.drugOptions;
			  }
			  
			  // 如果是修改模式
			  if (this.mode === 'edit') {
			    // 如果是新增行
			    if (row.isNewRow) {
			      // 如果有搜索查询，使用搜索结果
			      if (row.drugSearchQuery && row.drugSearchQuery.trim()) {
			        console.log('修改模式新增行，使用搜索结果:', row.drugSearchResults?.length);
			        return row.drugSearchResults || [];
			      }
			      // 否则使用全局药品列表
			      console.log('修改模式新增行，使用全局列表:', this.drugOptions.length);
			      return this.drugOptions;
			    }
			    
			    // 如果是原始数据行，查找匹配的药品
			    if (row.drugId) {
			      const foundDrug = this.drugOptions.find(drug => drug.id === row.drugId);
			      if (foundDrug) {
			        console.log('修改模式原始行，找到匹配药品:', foundDrug.drugName);
			        return [foundDrug];
			      } else {
			        // 如果没有找到，尝试从行数据中获取药品信息
			        if (row.drugName) {
			          console.log('修改模式原始行，创建临时选项:', row.drugName);
			          return [{
			            id: row.drugId,
			            drugName: row.drugName,
			            label: row.drugName, // 关键修复：使用drugName而不是drugId
			            drugSpecifications: row.spec,
			            pacSpec: row.packageSpec
			          }];
			        } else {
			          // 尝试从原始数据加载
			          return this.getDrugFromOriginalData(row);
			        }
			      }
			    }
			  }
			  
			  // 默认情况
			  console.log('默认情况，返回空数组');
			  return [];
			},
			
			// 处理追溯码录入按钮点击（通过顶部按钮打开）
			handleTraceCodeInput() {
			  console.log('打开追溯码录入模态框');
			  
			  // 不清空表单，直接打开模态框
			  this.traceCodeInputDialogVisible = true;
			},
			
			// 重置追溯码录入表单
			resetTraceCodeInputForm() {
			  console.log('重置追溯码录入表单');
			  this.traceCodeInputForm = {
			    traceCode: '',
			    drugName: '',
			    spec: '',
			    inboundQty: 1,
			    purcType: 2,
			    pacCnt: 1,
			    manuLotnum: '',
			    manufacturer: '',
			    manufacturerId: '',
			    approvalLicenceNo: '',
			    produceDate: '',
			    expireDate: '',
			    refEntId: '',
			    remark: '',
			    unitLabel: '包装单位',
			    pacUnt: '',
			    dosUnt: ''
			  };
			  this.traceCodeDetailData = null;
			  this.getSomeWareData = null;
			  this.getCJSomeWareData = null;
			  this.traceCodeInputList = [];
			  
			  // 重置添加药品目录按钮状态
			  this.showAddDrugButton = false;
			  this.addDrugButtonText = '添加药品目录';
			  this.addDrugButtonDisabled = false;
			},
			
			// 处理追溯码扫描输入
			async handleTraceCodeScanInput() {
			  if (!this.traceCodeInputForm.traceCode || this.traceCodeInputForm.traceCode.trim() === '') {
			    this.$message.warning('请输入追溯码');
			    return;
			  }
			  
			  const traceCode = this.traceCodeInputForm.traceCode.trim();
			  console.log('开始查询追溯码:', traceCode);
			  
			  // 检查追溯码是否已经在药品明细表格中
			  const isAlreadyAdded = this.checkIfTraceCodeAlreadyAdded(traceCode);
			  if (isAlreadyAdded) {
			    this.$message.error('该追溯码已存在，请勿重复录入！');
			    return;
			  }
			  
			  try {
			    this.traceCodeInputLoading = true;
			    
			    // 重置添加药品目录按钮状态
			    this.showAddDrugButton = false;
			    this.addDrugButtonText = '添加药品目录';
			    this.addDrugButtonDisabled = false;
			    
			    // 重置表单数据
			    this.traceCodeDetailData = null;
			    this.getSomeWareData = null;
			    this.getCJSomeWareData = null;
			    this.traceCodeInputList = [];
			    
			    // 重置表单
			    this.traceCodeInputForm = {
			      traceCode: traceCode,
			      drugName: '',
			      spec: '',
			      inboundQty: 1,
			      purcType: 2, // 默认包装单位
			      pacCnt: 1,
			      manuLotnum: '',
			      manufacturer: '',
			      manufacturerId: '',
			      approvalLicenceNo: '',
			      produceDate: '',
			      expireDate: '',
			      refEntId: '',
			      remark: '',
			      unitLabel: '包装单位',
			      pacUnt: '', // 新增：包装单位
			      dosUnt: ''  // 新增：最小单位
			    };
			    
			    // 调用msfxCodeDetail接口获取追溯码详情
			    const response = await msfxCodeDetail({
			      codes: traceCode
			    });
			    
			    if (response.code === 200 && response.data && response.data.length > 0) {
			      const traceCodeData = response.data[0];
			      console.log('追溯码详情接口返回:', traceCodeData);
			      
			      // 提取接口返回的数据
			      const drugInfo = traceCodeData.drugEntBaseDTO || {};
			      const produceInfo = traceCodeData.codeProduceInfoDTO?.produceInfoList?.[0] || {};
			      const entInfo = traceCodeData.pUserEntDTO || {};
			      const codeStatus = traceCodeData.codeStatusTypeDTO || {};
			      
			      // 提取药品名称
			      const drugName = drugInfo.physicName || '';
			      // 提取规格
			      const spec = drugInfo.pkgSpecCrit || '';
			      // 提取生产厂家
			      const manufacturer = entInfo.entName || '';
			      const manufacturerId = entInfo.refEntId || '';
			      // 提取批准文号
			      const approvalLicenceNo = drugInfo.approvalLicenceNo || '';
			      // 提取生产批次号
			      const batchNo = produceInfo.batchNo || '';
			      // 提取有效期
			      const expireDate = produceInfo.originalExpireDate || '';
			      // 提取生产日期
			      const produceDate = produceInfo.produceDateStr || '';
			      // 提取包装数量
			      const prepnSpec = drugInfo.prepnSpec || '1';
			      const pacCnt = this.extractNumberFromString(prepnSpec) || 1;
			      // 提取剂型（prepnTypeDesc）
			      const prepnTypeDesc = drugInfo.prepnTypeDesc || '';
			      // 填充表单数据
			      this.traceCodeInputForm.drugName = drugName;
			      this.traceCodeInputForm.spec = spec;
			      this.traceCodeInputForm.pacCnt = pacCnt;
			      this.traceCodeInputForm.manufacturer = manufacturer;
			      this.traceCodeInputForm.manufacturerId = manufacturerId;
			      this.traceCodeInputForm.approvalLicenceNo = approvalLicenceNo;
			      this.traceCodeInputForm.manuLotnum = batchNo;
			      this.traceCodeInputForm.expireDate = expireDate;
			      this.traceCodeInputForm.produceDate = produceDate;
			      this.traceCodeInputForm.purcType = 2; // 默认包装单位
			      this.traceCodeInputForm.inboundQty = 1; // 默认入库数量
			      this.traceCodeInputForm.unitLabel = '包装单位';
			      this.traceCodeInputForm.dosageFormName = prepnTypeDesc;
			      // 保存接口返回的原始数据
			      this.traceCodeDetailData = traceCodeData;
			      
			      this.$message.success('追溯码信息获取成功');
			      
			      // 药品名称和包装数量已填写，调用getSomeWare接口
			      if (drugName && pacCnt) {
			        await this.callGetSomeWare(drugName, pacCnt);
			      }
			      
			    } else {
			      this.$message.error(response?.message || '未找到追溯码信息或接口返回异常');
			    }
			  } catch (error) {
			    console.error('获取追溯码详情失败:', error);
			    this.$message.error('获取追溯码详情失败，请检查追溯码是否正确');
			  } finally {
			    this.traceCodeInputLoading = false;
			  }
			},
			
			// 检查追溯码是否已添加到药品明细表格中
			checkIfTraceCodeAlreadyAdded(traceCode) {
			  for (const medicine of this.medicineList) {
			    if (medicine.traceCodes && medicine.traceCodes.length > 0) {
			      const found = medicine.traceCodes.some(item => item.traceCode === traceCode);
			      if (found) {
			        return true;
			      }
			    }
			  }
			  return false;
			},
			
			// 从字符串中提取数字
			extractNumberFromString(str) {
			  console.log('extractNumberFromString输入:', str, '类型:', typeof str);
			  
			  // 如果输入为空或不是字符串，返回默认值
			  if (str === null || str === undefined || str === '') {
			    console.log('输入为空，返回默认值1');
			    return 1;
			  }
			  
			  // 确保输入是字符串
			  const inputStr = String(str);
			  console.log('转换后的字符串:', inputStr);
			  
			  try {
			    // 尝试匹配数字，包括小数
			    const matches = inputStr.match(/(\d+(\.\d+)?)/);
			    console.log('正则匹配结果:', matches);
			    
			    if (matches && matches[1]) {
			      const result = parseFloat(matches[1]);
			      console.log('解析后的数字:', result);
			      
			      // 确保结果是有效的数字
			      if (isNaN(result) || result <= 0) {
			        console.log('解析结果无效，返回默认值1');
			        return 1;
			      }
			      
			      return result;
			    } else {
			      console.log('未匹配到数字，返回默认值1');
			      return 1;
			    }
			  } catch (error) {
			    console.error('提取数字时出错:', error);
			    return 1;
			  }
			},
			
			// 调用getSomeWare接口
			async callGetSomeWare(drugName, pacCnt) {
			  if (!drugName || !pacCnt) {
			    console.log('callGetSomeWare参数无效:', { drugName, pacCnt });
			    return;
			  }
			  
			  console.log('开始调用getSomeWare接口:', { drugName, pacCnt });
			  
			  try {
			    this.getSomeWareLoading = true;
			    
			    const response = await getSomeWare({
			      drugName: drugName,
			      pacCnt: pacCnt
			    });
			    
			    console.log('getSomeWare接口返回:', response);
			    
			    if (response && response.code === 200) {
			      // 检查返回的数据是否为空
			      if (response.data && response.data !== '' && 
			          (!Array.isArray(response.data) || response.data.length > 0)) {
			        this.getSomeWareData = response.data;
			        console.log('getSomeWare接口返回有数据:', this.getSomeWareData);
			        
			        // 接口返回数据不为空，设置添加按钮状态为"已添加"并禁用
			        this.showAddDrugButton = true;
			        this.addDrugButtonText = '已添加';
			        this.addDrugButtonDisabled = true;
			        
			        // 更新追溯码录入表单中的单位信息
			        this.traceCodeInputForm.pacUnt = response.data.pacUnt || '包装单位';
			        this.traceCodeInputForm.dosUnt = response.data.dosUnt || '最小单位';
			        this.updateUnitLabel(this.traceCodeInputForm);
			        
			        console.log('已更新单位信息:', {
			          pacUnt: this.traceCodeInputForm.pacUnt,
			          dosUnt: this.traceCodeInputForm.dosUnt,
			          unitLabel: this.traceCodeInputForm.unitLabel
			        });
			        
			        // 如果接口返回了药品ID，并且批准文号已填写，则调用getCJSomeWare接口
			        if (this.getSomeWareData.id && this.traceCodeInputForm.approvalLicenceNo) {
			          try {
			            await this.callGetCJSomeWare(this.getSomeWareData.id, this.traceCodeInputForm.approvalLicenceNo);
			          } catch (cjError) {
			            console.warn('调用getCJSomeWare失败:', cjError);
			            // 不阻止主流程
			          }
			        }
			        
			      } else {
			        // 接口返回数据为空，显示提示弹框
			        this.handleEmptyDrugResponse(drugName);
			      }
			    } else {
			      console.warn('getSomeWare接口返回非200状态:', response?.message);
			      this.$message.warning(response?.message || '未找到相关药品信息');
			    }
			  } catch (error) {
			    console.error('调用getSomeWare接口失败:', error);
			    // 这里不显示错误消息，避免干扰用户体验
			  } finally {
			    this.getSomeWareLoading = false;
			  }
			},
			
			// 处理药品为空的情况
			handleEmptyDrugResponse(drugName) {
			  this.$confirm(
			    `${drugName}该药品未存在于本系统目录中，请先去添加该药品基本信息档案！`,
			    '提示',
			    {
			      confirmButtonText: '去添加',
			      cancelButtonText: '取消',
			      type: 'warning',
			      center: true
			    }
			  ).then(() => {
			    // 用户点击“去添加”
			    this.traceCodeInputList = [];
			    this.$nextTick(() => {
			      this.openAddDrugDialog(drugName);
			    });
			  }).catch(() => {
			    // 用户点击“取消”，显示底部“去添加”按钮
			    this.showBottomAddButton = true;
			    // 同时保留右上角的“添加药品目录”按钮（已存在）
			    this.showAddDrugButton = true;
			    this.addDrugButtonText = '添加药品目录';
			    this.addDrugButtonDisabled = false;
			  });
			},
			
			// 更新已录入追溯码的标题
			updateTraceCodeTableTitle() {
			  if (this.traceCodeInputList && this.traceCodeInputList.length > 0) {
			    // 如果有已录入的追溯码，显示数量
			    document.querySelector('.trace-code-table-section h4.section-title').innerText = 
			      `已录入的追溯码 (${this.traceCodeInputList.length})`;
			  } else {
			    // 如果没有已录入的追溯码，显示原始标题
			    document.querySelector('.trace-code-table-section h4.section-title').innerText = 
			      '已录入的追溯码';
			  }
			},
			
			// 打开添加药品目录模态框
			openAddDrugDialog(drugName) {
			  // 如果 drugName 是事件对象，则忽略它
			  if (drugName && typeof drugName === 'object' && drugName.target) {
			    drugName = this.traceCodeInputForm.drugName || '';
			  }
			  
			  if (!drugName) {
			    drugName = this.traceCodeInputForm.drugName || '';
			  }
			  
			  const traceData = this.traceCodeDetailData;
			  console.log(traceData,'traceDatatraceDatatraceDatatraceData');
			  let drugId = '';
			  let prepnTypeDesc = '';
			  if (traceData && traceData.drugEntBaseDTO) {
			    drugId = traceData.drugEntBaseDTO.id || '';
			    prepnTypeDesc = traceData.drugEntBaseDTO.prepnTypeDesc || '';
			  }
			  
			  this.addDrugDialogData = {
			    drugName: drugName,
			    spec: this.traceCodeInputForm.spec || '',
			    pacCnt: this.traceCodeInputForm.pacCnt || 1,
			    approvalLicenceNo: this.traceCodeInputForm.approvalLicenceNo || '',
			    manufacturer: this.traceCodeInputForm.manufacturer || '',
			    manufacturerId: this.traceCodeInputForm.manufacturerId || '',
			    remark: this.traceCodeInputForm.remark || '',
			    isBar: 1,
			    drugId: drugId,
			    prepnTypeDesc: prepnTypeDesc,
			  };
			  
			  this.addDrugDialogVisible = true;
			  this.showBottomAddButton = false;
			},
			
			// 调用getCJSomeWare接口
			async callGetCJSomeWare(drugId, approvalLicenceNo) {
			  if (!drugId || !approvalLicenceNo) {
			    return;
			  }
			  
			  try {
			    this.getCJSomeWareLoading = true;
			    
			    const response = await getCJSomeWare({
			      drugId: drugId,
			      approvalNumber: approvalLicenceNo
			    });
			    
			    console.log('getCJSomeWare接口返回:', response);
			    
			    if (response && response.code === 200) {
			      // 检查返回数据是否为空
			      if (response.data === null || 
			          response.data === undefined || 
			          response.data === '' || 
			          (Array.isArray(response.data) && response.data.length === 0)) {
			        console.warn('getCJSomeWare接口返回空数据');
			        
			        // 记录getCJSomeWare数据为空的状态
			        this.isCJSomeWareEmpty = true;
			        
			        // 不更新getCJSomeWareData，保持为null
			        this.getCJSomeWareData = null;
			        
			        // 弹框提示
			        this.$alert(
			          `当前录入的追溯码：${this.traceCodeInputForm.traceCode}的生产厂家不存在于本系统，请先在药品基本信息中核查生产厂家,批准文号！`,
			          '提示',
			          {
			            confirmButtonText: '确定',
			            type: 'warning',
			            callback: action => {
			              console.log('用户确认了生产厂家不存在的提示');
			            }
			          }
			        );
			        
			        this.$message.warning('未找到相关厂家信息，但药品将继续添加到表格中');
			      } else {
			        // 接口返回有效数据
			        this.getCJSomeWareData = response.data;
			        this.isCJSomeWareEmpty = false; // 重置标志
			        console.log('getCJSomeWare接口返回有效数据:', this.getCJSomeWareData);
			        
			        // 更新生产厂家信息
			        if (this.getCJSomeWareData && this.getCJSomeWareData.id) {
			          this.traceCodeInputForm.manufacturer = this.getCJSomeWareData.prodentpName || '';
			          this.traceCodeInputForm.manufacturerId = this.getCJSomeWareData.prodentpNameId || '';
			        }
			      }
			    } else {
			      console.warn('getCJSomeWare接口返回非200状态:', response?.message);
			      this.$message.warning(response?.message || '未找到相关厂家信息，但药品将继续添加到表格中');
			      
			      // 记录getCJSomeWare数据为空的状态
			      this.isCJSomeWareEmpty = true;
			      this.getCJSomeWareData = null;
			    }
			  } catch (error) {
			    console.error('调用getCJSomeWare接口失败:', error);
			    this.$message.error('查询厂家信息失败，但药品将继续添加到表格中');
			    
			    // 记录getCJSomeWare数据为空的状态
			    this.isCJSomeWareEmpty = true;
			    this.getCJSomeWareData = null;
			  } finally {
			    this.getCJSomeWareLoading = false;
			  }
			},
			
			// 药品名称变更
			handleDrugNameChange() {
			  if (this.traceCodeInputForm.drugName && this.traceCodeInputForm.pacCnt) {
			    this.callGetSomeWare(this.traceCodeInputForm.drugName, this.traceCodeInputForm.pacCnt);
			  }
			},
			
			// 包装数量变更
			handlePackageQtyChange() {
			  if (this.traceCodeInputForm.drugName && this.traceCodeInputForm.pacCnt) {
			    this.callGetSomeWare(this.traceCodeInputForm.drugName, this.traceCodeInputForm.pacCnt);
			  }
			},
			
			// 批准文号变更
			async handleApprovalLicenceNoChange() {
			  if (this.traceCodeInputForm.approvalLicenceNo && this.getSomeWareData && this.getSomeWareData.id) {
			    await this.callGetCJSomeWare(this.getSomeWareData.id, this.traceCodeInputForm.approvalLicenceNo);
			  }
			},
			
			// 确认追溯码录入
			async handleConfirmTraceCodeInput() {
			  // 显示全局 loading
			  const loadingInstance = this.$loading({
			    lock: true,
			    text: '正在检查药品库...',
			    background: 'rgba(0, 0, 0, 0.7)'
			  });
			
			  try {
			    // 1. 最少等待1.8秒，同时重新调用 getSomeWare 验证
			    const delayPromise = new Promise(resolve => setTimeout(resolve, 1800));
			    const drugName = this.traceCodeInputForm.drugName;
			    const pacCnt = this.traceCodeInputForm.pacCnt;
			    let verifyPromise = Promise.resolve();
			    if (drugName && pacCnt) {
			      verifyPromise = this.callGetSomeWare(drugName, pacCnt);
			    }
			    await Promise.all([delayPromise, verifyPromise]);
			
			    // 2. 再次检查药品是否存在于系统中
			    if (!this.drugExistsInSystem) {
			      this.$message.warning('该药品不存在于系统目录中，请先添加药品目录');
			      loadingInstance.close();
			      return;
			    }
			
			    // 3. 验证必填项
			    if (!this.validateTraceCodeInputForm()) {
			      this.$message.warning('请填写所有必填项');
			      loadingInstance.close();
			      return;
			    }
			
			    // 4. 验证追溯码次数
			    if (!this.validateTraceCodeCount()) {
			      loadingInstance.close();
			      return;
			    }
			
			    // 5. 检查追溯码是否已添加到药品明细表格中
			    const traceCode = this.traceCodeInputForm.traceCode;
			    const isAlreadyAdded = this.checkIfTraceCodeAlreadyAdded(traceCode);
			    if (isAlreadyAdded) {
			      this.$message.error('该追溯码已存在，请勿重复录入！');
			      loadingInstance.close();
			      return;
			    }
			
			    // 6. 执行原有添加逻辑（从原方法中复制）
			    // 从追溯码录入数据中提取药品信息
			    const traceCodeData = this.traceCodeDetailData;
			    const drugInfo = traceCodeData.drugEntBaseDTO || {};
			    const entInfo = traceCodeData.pUserEntDTO || {};
			
			    // 修复：安全地获取 produceInfo
			    const codeProduceInfoDTO = traceCodeData.codeProduceInfoDTO || {};
			    const produceInfoList = codeProduceInfoDTO.produceInfoList || [];
			    const produceInfo = produceInfoList[0] || {};
			
			    // 获取生产厂家refEntId
			    const refEntId = entInfo?.refEntId || '';
			
			    // 获取药品名称（中文）
			    const drugName2 = drugInfo.physicName || '';
			
			    // 获取生产厂家名称
			    const manufacturer = entInfo.entName || '';
			
			    // 获取批准文号
			    const approvalLicenceNo = drugInfo.approvalLicenceNo || '';
			
			    // 获取药品ID
			    const drugId = this.getSomeWareData ? this.getSomeWareData.id : '';
			
			    // 获取包装数量
			    const pacCnt2 = this.traceCodeInputForm.pacCnt || 1;
			    const inboundQty = 1; // 从追溯码录入模态框添加的默认为1
			    const purcType = 2; // 默认为包装单位
			
			    // 从getSomeWare接口获取的单位信息
			    const dosUnt = this.getSomeWareData ? (this.getSomeWareData.dosUnt || '最小单位') : '最小单位';
			    const pacUnt = this.getSomeWareData ? (this.getSomeWareData.pacUnt || '包装单位') : '包装单位';
			    const pacSpec = this.getSomeWareData ? (this.getSomeWareData.pacSpec || '') : '';
			
			    // 关键：从getSomeWare接口获取isBar字段
			    const isBar = this.getSomeWareData ? (this.getSomeWareData.isBar || 0) : 0;
			
			    console.log('从getSomeWare接口获取的药品信息:', {
			      drugId: drugId,
			      drugName: drugName2,
			      isBar: isBar,
			      pacUnt: pacUnt,
			      dosUnt: dosUnt
			    });
			
			    // 修复：从追溯码详情安全获取生产批号、生产日期、有效期
			    const manuLotnum = produceInfo.batchNo || '';
			    const manuDate = produceInfo.produceDateStr || '';
			    const expyDate = produceInfo.originalExpireDate || '';
			
			    console.log('从追溯码详情获取的生产信息:', {
			      生产批号: manuLotnum,
			      生产日期: manuDate,
			      有效日期: expyDate
			    });
			
			    // 从追溯码录入中获取追溯码列表
			    const traceCodes = [{
			      traceCode: traceCode,
			      drugName: drugName2,
			      manufacturer: manufacturer,
			      batchNo: manuLotnum,
			      availableQty: pacCnt2
			    }];
			
			    console.log('追溯码信息:', {
			      追溯码数量: traceCodes.length,
			      traceCodes: traceCodes
			    });
			
			    // 判断是否有追溯码
			    const hasTraceCode = traceCodes && traceCodes.length > 0;
			
			    // 构建追溯码JSON，增加 manuLotnum 字段
			    let tracCodeJson = [];
			    if (hasTraceCode && isBar === 1) {
			      // 关键修改：根据库存类型确定chgCnt
			      // 从追溯码录入添加的默认为包装单位，chgCnt取包装数量
			      const chgCnt = pacCnt2;
			
			      console.log('计算chgCnt:', {
			        库存类型: '包装单位（默认）',
			        包装数量: pacCnt2,
			        计算结果: chgCnt
			      });
			
			      // 创建一个数组，每个元素是 {barcode: "追溯码", chgCnt: 包装数量, manuLotnum: 生产批号}
			      tracCodeJson = traceCodes.map(item => ({
			        barcode: item.traceCode,
			        chgCnt: chgCnt,
			        manuLotnum: manuLotnum   // 新增字段：生产批号
			      }));
			    }
			
			    // 将追溯码数组转换为JSON字符串
			    const tracCodeJsonString = tracCodeJson.length > 0 ? JSON.stringify(tracCodeJson) : '';
			
			    // 创建药品行
			    const newMedicine = await this.createMedicineRow({
			      drugId,
			      drugName: drugName2,
			      manufacturer,
			      manufacturerId: this.traceCodeInputForm.manufacturerId,
			      approvalLicenceNo,
			      spec: drugInfo.pkgSpecCrit || '',
			      pacSpec,
			      dosUnt,
			      pacUnt,
			      pacCnt: pacCnt2,
			      inboundQty,
			      purcType,
			      isBar: isBar,
			      traceCodes: traceCodes,
			      tracCodeJson: tracCodeJsonString,
			      refEntId,
			      markUpId: this.getSomeWareData ? (this.getSomeWareData.markUpId || 1) : 1,
			      isFixPrice: this.getSomeWareData ? (this.getSomeWareData.isFixPrice || 0) : 0,
			      unitLabel: pacUnt,
			      manuLotnum: manuLotnum,
			      manuDate: manuDate,
			      expyDate: expyDate
			    }, hasTraceCode && isBar === 1);
			
			    console.log('新创建的药品行:', {
			      drugName: newMedicine.drugName,
			      isBar: newMedicine.isBar,
			      traceCodes: newMedicine.traceCodes,
			      traceCodeButtonText: newMedicine.traceCodeButtonText
			    });
			
			    this.medicineList.push(newMedicine);
			
			    // 将药品添加到全局药品选项列表
			    if (drugId) {
			      const drugOption = {
			        id: drugId,
			        drugName: drugName2,
			        label: drugName2,
			        drugSpecifications: drugInfo.pkgSpecCrit || '',
			        pacSpec: pacSpec,
			        markUpId: this.getSomeWareData ? (this.getSomeWareData.markUpId || 1) : 1,
			        isFixPrice: this.getSomeWareData ? (this.getSomeWareData.isFixPrice || 0) : 0,
			        pacCnt: pacCnt2,
			        dosUnt: dosUnt,
			        pacUnt: pacUnt,
			        manufacturerName: manufacturer,
			        isBar: isBar
			      };
			
			      const exists = this.drugOptions.some(item => item.id === drugOption.id);
			      if (!exists) {
			        this.drugOptions.push(drugOption);
			      }
			    }
			
			    this.$message.success(`已成功添加药品: ${drugName2}`);
			
			    // 关闭模态框
			    this.traceCodeInputDialogVisible = false;
			    this.resetTraceCodeInputForm();
			    loadingInstance.close();
			
			  } catch (error) {
			    console.error('添加药品失败:', error);
			    this.$message.error('添加药品失败: ' + error.message);
			    loadingInstance.close();
			  }
			},
			
			// 创建药品行
			async createMedicineRow(params, hasTraceCode = false) {
			  const {
			    drugId, drugName, manufacturer, manufacturerId, approvalLicenceNo, 
			    spec, pacSpec, dosUnt, pacUnt, pacCnt, inboundQty, purcType, isBar,
			    traceCodes, tracCodeJson, refEntId, markUpId, isFixPrice, unitLabel,
			    manuLotnum, manuDate, expyDate, produceDate, expireDate
			  } = params;
			  
			  console.log('创建药品行参数:', { 
			    drugId, drugName, manufacturer, manufacturerId, 
			    hasTraceCode, isBar, traceCodes: traceCodes || [],
			    isBarFromParams: isBar,
			    isCJSomeWareEmpty: this.isCJSomeWareEmpty,
			    getCJSomeWareData: this.getCJSomeWareData
			  });
			  
			  // 关键修改：从getSomeWareData获取isBar字段
			  const finalIsBar = (this.getSomeWareData && this.getSomeWareData.isBar === 1) ? 1 : (isBar || 0);
			  const hasTraceCodeFinal = hasTraceCode && finalIsBar === 1;
			  const traceCodesCount = (traceCodes && traceCodes.length) || 0;
			  const finalPeriodControl = periodControl !== undefined ? parseInt(periodControl) : 1;
			  const newMedicine = {
			    id: Date.now() + Math.random(),
			    drugId: drugId,
			    drugName: drugName,
			    inboundQty: inboundQty,
			    purcType: purcType,
			    pacCnt: pacCnt,
			    manuLotnum: manuLotnum || '',
			    manuDate: manuDate || '',
			    expyDate: expyDate || '',
			    prodentpNameId: '', // 初始化为空，下面会根据情况设置
				expyDateDisabled: finalPeriodControl === 0,
			    manufacturer: manufacturer || '',
			    manufacturerOptions: [],
			    manufacturerLoading: false,
			    costPric: 0,
			    totalCost: 0,
			    salePric: 0,
			    totalRetail: 0,
			    markupMethod: 1,
			    markupMethodText: '',
			    isFixedPriceText: '',
			    spec: spec,
			    packageSpec: pacSpec,
			    dosUnt: dosUnt,
			    pacUnt: pacUnt,
			    unitLabel: unitLabel,
			    expyDateDisabled: false,
			    isBar: finalIsBar, // 使用从getSomeWareData获取的isBar
			    traceCodes: traceCodes || [], // 确保traceCodes不为undefined
			    tracCodeJson: tracCodeJson || '',
			    traceCodeButtonText: hasTraceCodeFinal && finalIsBar === 1 ? `追溯码(${traceCodesCount})` : '追溯码',
			    isNewRow: true,
			    refEntId: refEntId,
			    label: drugName,
			    markUpId: markUpId,
				expyDateDays: finalExpyDateDays,  // 新增
			    isFixPrice: isFixPrice
			  };
			  
			  console.log('创建的药品行信息:', {
			    drugName: newMedicine.drugName,
			    isBar: newMedicine.isBar,
			    traceCodes: newMedicine.traceCodes,
			    traceCodeButtonText: newMedicine.traceCodeButtonText,
			    hasTraceCodeFinal: hasTraceCodeFinal,
			    traceCodesCount: traceCodesCount
			  });
			  
			  // 设置加成方式显示文字
			  newMedicine.markupMethodText = this.getMarkupMethodText(markUpId, isFixPrice);
			  newMedicine.isFixedPriceText = (isFixPrice === 1) ? '已指定' : '未指定';
			  
			  // 计算行金额
			  this.calculateRowAmount(newMedicine);
			  
			  // 根据是否有追溯码选择生产厂家数据
			  if (hasTraceCodeFinal) {
			    // 有追溯码的情况：使用getCJSomeWare接口返回的生产厂家数据
			    console.log('有追溯码，处理生产厂家数据:', {
			      isCJSomeWareEmpty: this.isCJSomeWareEmpty,
			      getCJSomeWareData: this.getCJSomeWareData
			    });
			    
			    // 如果getCJSomeWare接口返回空数据，不设置生产厂家选项
			    if (this.isCJSomeWareEmpty || !this.getCJSomeWareData) {
			      console.log('getCJSomeWare接口返回空数据，生产厂家下拉选择框将为空');
			      
			      // 设置追溯码详情中的生产厂家名称，但下拉选项为空数组
			      newMedicine.manufacturer = manufacturer || '';
			      newMedicine.prodentpNameId = ''; // 不设置生产厂家ID
			      newMedicine.manufacturerOptions = []; // 空数组，下拉框不显示任何选项
			      
			      console.log('已设置生产厂家信息（下拉选项为空）:', {
			        manufacturer: newMedicine.manufacturer,
			        prodentpNameId: newMedicine.prodentpNameId,
			        manufacturerOptionsLength: newMedicine.manufacturerOptions.length
			      });
			    } else if (this.getCJSomeWareData) {
			      // 从getCJSomeWareData中获取生产厂家ID
			      const cjManufacturerId = this.getCJSomeWareData.id || this.getCJSomeWareData.manufacturerId || '';
			      const cjManufacturerName = this.getCJSomeWareData.prodentpName || this.getCJSomeWareData.manufacturerName || '';
			      
			      newMedicine.manufacturer = cjManufacturerName;
			      newMedicine.prodentpNameId = cjManufacturerId; // 使用接口返回的ID
			      newMedicine.manufacturerOptions = [{
			        prodentpId: cjManufacturerId,
			        prodentpName: cjManufacturerName
			      }];
			      
			      console.log('已设置getCJSomeWare生产厂家数据:', {
			        manufacturer: newMedicine.manufacturer,
			        prodentpNameId: newMedicine.prodentpNameId
			      });
			    } else if (manufacturer && manufacturerId) {
			      // 如果没有getCJSomeWare数据，但追溯码详情中有厂家信息
			      newMedicine.manufacturer = manufacturer;
			      newMedicine.prodentpNameId = manufacturerId; // 使用manufacturerId
			      newMedicine.manufacturerOptions = [{
			        prodentpId: manufacturerId,
			        prodentpName: manufacturer
			      }];
			      
			      console.log('使用追溯码详情中的生产厂家数据:', {
			        manufacturer: newMedicine.manufacturer,
			        prodentpNameId: newMedicine.prodentpNameId
			      });
			    }
			  } else {
			    // 无追溯码的情况：按照原有流程走getProdent
			    console.log('无追溯码，调用getProdent接口获取生产厂家列表');
			    
			    try {
			      newMedicine.manufacturerLoading = true;
			      
			      // 调用getProdent接口获取生产厂家列表
			      const prodentResponse = await getProdent({
			        drugId: drugId,
			        approvalNumber: approvalLicenceNo
			      });
			      
			      console.log('getProdent接口返回:', prodentResponse);
			      
			      if (prodentResponse && prodentResponse.code === 200 && prodentResponse.data) {
			        const manufacturerList = Array.isArray(prodentResponse.data) ? prodentResponse.data : [];
			        
			        // 设置生产厂家选项
			        newMedicine.manufacturerOptions = manufacturerList.map(item => ({
			          prodentpId: item.prodentpId || item.id || '', // 使用接口返回的ID
			          prodentpName: item.prodentpName || item.manufacturerName || ''
			        }));
			        
			        // 如果有生产厂家选项，默认选择第一个
			        if (newMedicine.manufacturerOptions.length > 0) {
			          newMedicine.prodentpNameId = newMedicine.manufacturerOptions[0].prodentpId; // 使用接口返回的ID
			          newMedicine.manufacturer = newMedicine.manufacturerOptions[0].prodentpName;
			          
			          console.log('默认选择第一个生产厂家:', {
			            prodentpNameId: newMedicine.prodentpNameId,
			            manufacturer: newMedicine.manufacturer
			          });
			        }
			      } else {
			        console.warn('getProdent接口返回空数据或无数据');
			      }
			    } catch (error) {
			      console.error('调用getProdent接口失败:', error);
			    } finally {
			      newMedicine.manufacturerLoading = false;
			    }
			  }
			  
			  return newMedicine;
			},
			
			// 验证追溯码录入表单
			validateTraceCodeInputForm() {
			  const requiredFields = [
			    'drugName',    // 药品名称
			    'pacCnt',  // 包装数量
			    'inboundQty',  // 入库数量
			    'manufacturer', // 生产厂家
			    'approvalLicenceNo' // 批准文号
			  ];
			  
			  for (const field of requiredFields) {
			    if (!this.traceCodeInputForm[field] || this.traceCodeInputForm[field] === '') {
			      return false;
			    }
			  }
			  
			  return true;
			},
			
			// 新增：从原始数据加载药品
			getDrugFromOriginalData(row) {
				// 尝试从原始行数据中查找药品
				if (this.rowData && this.rowData.list) {
					const originalItem = this.rowData.list.find(item =>
						item.drugId === row.drugId || item.id === row.id
					);
					if (originalItem && originalItem.drugName) {
						return [{
							id: row.drugId,
							drugName: originalItem.drugName,
							label: originalItem.drugName,
							drugSpecifications: originalItem.drugSpec,
							pacSpec: originalItem.pacSpec
						}];
					}
				}
				return [];
			},
 
			// 新增：从行数据获取药品信息
			getDrugInfoFromRowData(row) {
				return {
					drugName: row.drugName || '未知药品',
					drugSpecifications: row.spec || '',
					pacSpec: row.packageSpec || '',
					markUpId: row.markUpId || 1,
					isFixPrice: row.isFixPrice || 0,
					costPric: row.costPric || 0,
					dosUnt: row.dosUnt || '单位',
					pacUnt: row.pacUnt || '包装单位'
				};
			},
			// 新增：处理药品下拉框失焦事件
			handleDrugBlur(row) {
				// 只在修改模式的新增行中处理
				if (this.isEditMode && row.isNewRow) {
					// 延迟处理，避免和选择事件冲突
					setTimeout(() => {
						// 如果当前有搜索内容但没有选择药品，清空输入并重新加载全部选项
						if (row.drugSearchQuery && row.drugSearchQuery.trim() && !row.drugId) {
							this.$message.info(`清空搜索内容，重新加载药品列表`);
							this.resetRowDrugSearch(row);
							// 重新加载全部药品列表
							this.loadDefaultDrugs();
						}
					}, 200);
				}
			},
 
			// 新增：重置行的药品搜索
			resetRowDrugSearch(row) {
				if (row.isNewRow) {
					row.drugSearchQuery = '';
					row.drugSearchResults = [];
				}
			},
 
			// 新增：显示无搜索数据消息
			showNoSearchDataMessage(row) {
				// 只在修改模式的新增行中显示
				if (this.isEditMode && row.isNewRow) {
					return row.drugSearchQuery &&
						row.drugSearchQuery.trim() &&
						row.drugSearchResults &&
						row.drugSearchResults.length === 0;
				}
				return false;
			},
 
			// 新增：获取药品显示标签
			getDrugDisplayLabel(drug, row) {
			  if (!row) return drug.drugName || '';
			  // 修改模式下的原始数据行（非新增行）：使用行内存储的名称
			  if (this.mode === 'edit' && !row.isNewRow && row.drugName) {
			    return row.drugName;
			  }
			  // 新增模式 或 修改模式的新增行：使用药品对象自身的名称
			  if (drug.drugName) {
			    return drug.drugName;
			  }
			  if (drug.label) {
			    return drug.label;
			  }
			  return '未知药品';
			},
 
			// 从行数据创建药品明细
			async createMedicineFromRowData(item) {
			  // 尝试从 drugOptions 中查找药品信息以获取 periodControl 和 expyDateDays
			  let periodControl = 1;
			  let expyDateDays = null;
			  if (item.drugId) {
			    const foundDrug = this.drugOptions.find(d => d.id === item.drugId);
			    if (foundDrug) {
			      periodControl = foundDrug.periodControl !== undefined ? parseInt(foundDrug.periodControl) : 1;
			      expyDateDays = foundDrug.expyDate !== undefined && foundDrug.expyDate !== null ? parseInt(foundDrug.expyDate) : null;
			    }
			  }
			  // 如果 item 本身携带了 periodControl，优先使用
			  if (item.periodControl !== undefined) {
			    periodControl = parseInt(item.periodControl);
			  }
			  if (item.expyDateDays !== undefined) {
			    expyDateDays = item.expyDateDays !== null ? parseInt(item.expyDateDays) : null;
			  }
			
			  const newMedicine = {
			    id: item.id,
			    drugId: item.drugId || '',
			    drugName: item.name || item.drugName || '',
			    inboundQty: item.purcCnt || 1,
			    purcType: item.purcType || 2,
			    pacCnt: item.pacCnt || 1,
			    manuLotnum: item.manuLotnum || '',
			    manuDate: item.manuDate || '',
			    expyDate: item.expyDate || '',
			    prodentpNameId: item.prodentpNameId || '',
			    manufacturer: item.prodentpName || '',
			    manufacturerOptions: [],
			    manufacturerLoading: false,
			    costPric: item.purcPric || 0,
			    totalCost: item.purcAmt || 0,
			    salePric: item.salePric || 0,
			    totalRetail: item.saleAmt || 0,
			    markupMethod: item.markupMethod || 1,
			    markupMethodText: this.getMarkupMethodText(item.markUpId || 1, item.isFixPrice || 0),
			    isFixedPriceText: '',
			    spec: item.drugSpec || '',
			    packageSpec: item.pacSpec || '',
			    dosUnt: item.dosUnt || '单位',
			    pacUnt: item.pacUnt || '包装单位',
			    unitLabel: (item.purcType === 1 ? item.dosUnt : item.pacUnt) || '单位',
			    expyDateDisabled: false,
			    isNewRow: false,
			    markUpId: item.markUpId || 1,
			    isFixPrice: item.isFixPrice || 0,
			    traceCodes: item.traceCodes || [],
			    tracCodeJson: item.tracCodeJson || '',
			    periodControl: periodControl,
			    expyDateDays: expyDateDays,
			  };
			
			  // 设置是否指定售价
			  if (item.isFixPrice !== undefined) {
			    newMedicine.isFixedPriceText = item.isFixPrice === 1 ? '已指定' : '未指定';
			  }
			  // 关键：设置有效日期禁用状态
			  newMedicine.expyDateDisabled = newMedicine.periodControl === 0;
			
			  // 确保药品信息完整（如果 drugName 为空则从接口加载）
			  await this.ensureDrugDetailsForRow(newMedicine);
			
			  return newMedicine;
			},
 
			// 新增：为行数据确保药品详情
			async ensureDrugDetailsForRow(medicine) {
				// 如果已经有药品名称，不需要额外处理
				if (medicine.drugName && medicine.drugName.trim() !== '') {
					return;
				}
 
				// 尝试从drugOptions中查找
				if (medicine.drugId) {
					const foundDrug = this.drugOptions.find(drug => drug.id === medicine.drugId);
					if (foundDrug && foundDrug.drugName) {
						medicine.drugName = foundDrug.drugName;
						medicine.spec = foundDrug.drugSpecifications || medicine.spec;
						medicine.packageSpec = foundDrug.pacSpec || medicine.packageSpec;
						return;
					}
				}
 
				// 如果还是没有，尝试从接口加载
				if (medicine.drugId) {
					await this.loadDrugByIdForDisplay(medicine);
				}
			},
 
			// 新增：为显示加载药品
			async loadDrugByIdForDisplay(medicine) {
				try {
					const response = await getWare({
						pageNum: 1,
						pageSize: 1,
						id: medicine.drugId
					});
 
					if (response && response.code === 200 && response.data) {
						const drugList = response.data.content || response.data;
						if (drugList.length > 0) {
							const drug = drugList[0];
							medicine.drugName = drug.drugName || medicine.drugName;
							medicine.spec = drug.drugSpecifications || medicine.spec;
							medicine.packageSpec = drug.pacSpec || medicine.packageSpec;
 
							// 添加到药品选项列表
							if (!this.drugOptions.some(item => item.id === drug.id)) {
								this.drugOptions.push(drug);
							}
						}
					}
				} catch (error) {
					console.error('为显示加载药品失败:', error);
				}
			},
 
			// 新增：通过ID加载药品
			async loadDrugById(drugId) {
				try {
					console.log('通过ID加载药品:', drugId);
 
					const response = await getWare({
						pageNum: 1,
						pageSize: 1,
						id: drugId
					});
 
					if (response && response.code === 200 && response.data) {
						const drugList = response.data.content || response.data;
						if (drugList.length > 0) {
							const drug = drugList[0];
							console.log('通过ID找到药品:', drug);
 
							// 将药品添加到drugOptions西
							if (!this.drugOptions.some(item => item.id === drug.id)) {
								this.drugOptions.push(drug);
								console.log('药品已添加到drugOptions:', drug.drugName);
							}
 
							return drug;
						} else {
							console.log('通过ID未找到药品，尝试通过名称搜索');
							await this.searchDrugByNameFromList(drugId);
						}
					}
				} catch (error) {
					console.error('通过ID加载药品失败:', error);
					// 如果通过ID失败，尝试通过名称搜索
					await this.searchDrugByNameFromList(drugId);
				}
				return null;
			},
 
			// 新增：通过列表西的药品名称搜索药品
			async searchDrugByNameFromList(drugId) {
				// 从行数据西找到对应的药品
				const drugItem = this.rowData.list.find(item => item.drugId === drugId);
				if (!drugItem || !drugItem.drugName) {
					console.log('未找到药品名称，无法搜索');
					return;
				}
 
				console.log('通过药品名称搜索:', drugItem.drugName);
 
				try {
					const response = await getWare({
						pageNum: 1,
						pageSize: 50,
						name: drugItem.drugName
					});
 
					if (response && response.code === 200 && response.data) {
						const drugList = response.data.content || response.data;
						console.log('搜索到药品数量:', drugList.length);
 
						// 在搜索结果西查找匹配的药品
						const foundDrug = drugList.find(drug => drug.id === drugId);
						if (foundDrug) {
							console.log('通过名称找到药品:', foundDrug);
 
							// 将药品添加到drugOptions西
							if (!this.drugOptions.some(item => item.id === foundDrug.id)) {
								this.drugOptions.push(foundDrug);
								console.log('药品已添加到drugOptions:', foundDrug.drugName);
							}
						} else {
							console.log('搜索结果西未找到匹配的药品，创建临时药品');
							this.createTemporaryDrug(drugItem);
						}
					}
				} catch (error) {
					console.error('通过名称搜索药品失败:', error);
					this.createTemporaryDrug(drugItem);
				}
			},
 
			// 新增：创建临时药品
			createTemporaryDrug(drugItem) {
				const tempDrug = {
					id: drugItem.drugId,
					drugName: drugItem.drugName,
					drugSpecifications: drugItem.drugSpec,
					pacSpec: drugItem.pacSpec,
					markUpId: drugItem.markUpId || 1,
					isFixPrice: drugItem.isFixPrice || 0
				};
 
				if (!this.drugOptions.some(item => item.id === tempDrug.id)) {
					this.drugOptions.push(tempDrug);
					console.log('已创建临时药品:', tempDrug);
				}
			},
 
 
			// 新增：确保药品详情完整
			async ensureDrugDetails(medicine) {
				// 如果药品名称不完整，尝试从drugOptions西获取
				if (!medicine.drugName && medicine.drugId) {
					const drug = this.drugOptions.find(d => d.id === medicine.drugId);
					if (drug) {
						medicine.drugName = drug.drugName;
						medicine.spec = drug.drugSpecifications || medicine.spec;
						medicine.packageSpec = drug.pacSpec || medicine.packageSpec;
 
						// 设置加成方式
						medicine.markupMethodText = this.getMarkupMethodText(
							drug.markUpId || 1,
							drug.isFixPrice || 0
						);
 
						// 设置是否指定售价
						medicine.isFixedPriceText = drug.isFixPrice === 1 ? '已指定' : '未指定';
					}
				}
			},
 
			// 重置表单
			resetForm() {
				this.formData = {
					warehouseId: 3,
					purchasePlanId: '',
					businessDate: new Date().toISOString().split('T')[0],
					invoiceNo: '',
					supplierId: '',
					supplierCode: '',
					putinTypeId: 1,
					remark: ''
				};
				this.medicineList = [];
				this.totalInboundQty = 0;
				this.totalCost = 0;
				this.totalRetail = 0;
 
				// 重置允许重新选择药品状态
				this.allowReselectAll = false;
 
				// 重置原始药品数据
				this.originalDrugDetails = null;
 
				// 重置搜索条件
				this.resetDrugSearch();
			},
 
			// 加载供货单位列表
			async loadSuppliers() {
			  this.supplierLoading = true;
			  try {
			    const response = await selectDropDownList();
			    if (response && response.data && response.data.content) {
			      this.supplierList = response.data.content;
			      
			      // 检查供应商数据结构，确保有entId字段
			      console.log('供应商列表数据结构:', this.supplierList[0]);
			      
			      // 如果供应商没有entId字段，尝试从现有字段中查找
			      this.supplierList.forEach(supplier => {
			        // 尝试从不同字段中查找entId
			        if (!supplier.entId) {
			          // 可能包含entId的字段名
			          const possibleEntIdFields = ['entId', 'entid', 'ent_id', 'supplierEntId', 'supplierEntid'];
			          for (const field of possibleEntIdFields) {
			            if (supplier[field]) {
			              supplier.entId = supplier[field];
			              console.log(`供应商${supplier.supplierName}从${field}字段获取entId: ${supplier.entId}`);
			              break;
			            }
			          }
			          
			          // 如果仍然没有entId，使用id作为备选
			          if (!supplier.entId && supplier.id) {
			            supplier.entId = supplier.id.toString();
			            console.log(`供应商${supplier.supplierName}使用id作为entId: ${supplier.entId}`);
			          }
			        }
			      });
			      
			      console.log('处理后的供应商列表:', this.supplierList);
			    }
			  } catch (error) {
			    console.error('加载供货单位失败:', error);
			    this.$message.error('加载供货单位失败');
			  } finally {
			    this.supplierLoading = false;
			  }
			},
 
			// 加载药品列表
			async loadDrugs(isLoadMore = false) {
				if (!isLoadMore) {
					this.drugSearchLoading = true;
					this.drugPageNum = 1;
				} else {
					this.loadingMoreDrugs = true;
					this.drugPageNum++;
				}
 
				try {
					const response = await getWare({
						pageNum: this.drugPageNum,
						pageSize: this.drugPageSize,
						name: this.drugSearchQuery
					});
 
					if (response && response.code === 200 && response.data) {
						const newDrugs = response.data.content || response.data;
 
						if (isLoadMore) {
							this.drugOptions = [...this.drugOptions, ...newDrugs];
						} else {
							this.drugOptions = newDrugs;
						}
 
						this.drugHasMore = newDrugs.length >= this.drugPageSize;
					}
				} catch (error) {
					console.error('加载药品列表失败:', error);
					this.$message.error('加载药品列表失败');
				} finally {
					this.drugSearchLoading = false;
					this.loadingMoreDrugs = false;
				}
			},
			
			// 新增：检查是否可以搜索
			canSearchDrug(row) {
			  // 新增模式下都可以搜索
			  if (this.mode === 'add') {
			    return true;
			  }
			  
			  // 修改模式下，只有新增行可以搜索
			  if (this.mode === 'edit') {
			    return row.isNewRow;
			  }
			  
			  return false;
			},
			
			// 新增：检查是否可以远程搜索
			canRemoteSearch(row) {
			  if (!row) return false;
			  return this.canSearchDrug(row);
			},
			
			// 新增：检查是否可以清除
			canClearDrug(row) {
			  if (!row) return false;
			  // 新增模式下可以清除
			  if (this.mode === 'add') {
			    return true;
			  }
			  
			  // 修改模式下，只有新增行可以清除
			  if (this.mode === 'edit') {
			    return row.isNewRow;
			  }
			  
			  return false;
			},
			
			// 新增：显示无搜索结果提示
			showNoSearchResults(row) {
				if (!row) return false; // 增加判空
			  // 在新增模式或修改模式的新增行中，如果有搜索查询但没有搜索结果
			  if ((this.mode === 'add' || (this.mode === 'edit' && row.isNewRow))) {
			    const hasSearchQuery = row.drugSearchQuery && row.drugSearchQuery.trim() || 
			                          this.drugSearchQuery && this.drugSearchQuery.trim();
			    const hasSearchResults = row.drugSearchResults && row.drugSearchResults.length > 0;
			    
			    return hasSearchQuery && !hasSearchResults;
			  }
			  return false;
			},
			
			// 修改：检查是否可以加载更多
			canLoadMore(row) {
			  if (!row) return false;
			  // 必须有更多数据且不在加载中
			  if (!this.drugHasMore || this.drugSearchLoading || this.loadingMoreDrugs) {
			    return false;
			  }
			  
			  // 新增模式下可以加载更多
			  if (this.mode === 'add') {
			    return true;
			  }
			  
			  // 修改模式下，只有新增行可以加载更多
			  if (this.mode === 'edit') {
			    return row.isNewRow;
			  }
			  
			  return false;
			},
			
			// 处理外部扫码确认
			async handleOuterScanConfirm() {
			  if (!this.outerScanInput || this.outerScanInput.trim() === '') {
			    this.$message.warning('请输入追溯码');
			    return;
			  }
			  
			  const traceCode = this.outerScanInput.trim();
			  console.log('外部扫码确认，追溯码:', traceCode);
			  
			  // 注意：这里不检查追溯码是否已添加，因为用户可能在模态框中取消
			  // 只在确定添加时才检查
			  
			  try {
			    this.outerScanLoading = true;
			    
			    // 清空外部输入框
			    this.outerScanInput = '';
			    
			    // 打开追溯码录入模态框
			    this.traceCodeInputDialogVisible = true;
			    
			    // 设置追溯码到表单
			    this.traceCodeInputForm.traceCode = traceCode;
			    
			    // 调用msfxCodeDetail接口获取追溯码详情
			    const response = await msfxCodeDetail({
			      codes: traceCode
			    });
			    
			    if (response.code === 200 && response.data && response.data.length > 0) {
			      const traceCodeData = response.data[0];
			      console.log('追溯码详情接口返回:', traceCodeData);
			      
			      // 提取接口返回的数据
			      const drugInfo = traceCodeData.drugEntBaseDTO || {};
			      const produceInfo = traceCodeData.codeProduceInfoDTO?.produceInfoList?.[0] || {};
			      const entInfo = traceCodeData.pUserEntDTO || {};
			      
			      // 提取药品名称
			      const drugName = drugInfo.physicName || '';
			      // 提取规格
			      const spec = drugInfo.pkgSpecCrit || '';
			      // 提取生产厂家
			      const manufacturer = entInfo.entName || '';
			      const manufacturerId = entInfo.refEntId || '';
			      // 提取批准文号
			      const approvalLicenceNo = drugInfo.approvalLicenceNo || '';
			      // 提取生产批次号
			      const batchNo = produceInfo.batchNo || '';
			      // 提取有效期
			      const expireDate = produceInfo.originalExpireDate || '';
			      // 提取生产日期
			      const produceDate = produceInfo.produceDateStr || '';
			      // 提取包装数量
			      const prepnSpec = drugInfo.prepnSpec || '1';
			      const pacCnt = this.extractNumberFromString(prepnSpec) || 1;
			      // 提取剂型（prepnTypeDesc）
			      const prepnTypeDesc = drugInfo.prepnTypeDesc || '';
			      
			      // 填充表单数据
			      this.traceCodeInputForm.drugName = drugName;
			      this.traceCodeInputForm.spec = spec;
			      this.traceCodeInputForm.pacCnt = pacCnt;
				  this.traceCodeInputForm.dosageFormName = prepnTypeDesc;
			      this.traceCodeInputForm.manufacturer = manufacturer;
			      this.traceCodeInputForm.manufacturerId = manufacturerId;
			      this.traceCodeInputForm.approvalLicenceNo = approvalLicenceNo;
			      this.traceCodeInputForm.manuLotnum = batchNo;
			      this.traceCodeInputForm.expireDate = expireDate;
			      this.traceCodeInputForm.produceDate = produceDate;
			      this.traceCodeInputForm.purcType = 2; // 默认包装单位
			      this.traceCodeInputForm.inboundQty = 1; // 默认入库数量
			      this.traceCodeInputForm.unitLabel = '包装单位';
			      this.traceCodeInputForm.pacUnt = ''; // 等待getSomeWare接口返回
			      this.traceCodeInputForm.dosUnt = ''; // 等待getSomeWare接口返回
			      
			      // 保存接口返回的原始数据
			      this.traceCodeDetailData = traceCodeData;
			      
			      this.$message.success('追溯码信息获取成功');
			      
			      // 药品名称和包装数量已填写，调用getSomeWare接口
			      if (drugName && pacCnt) {
			        await this.callGetSomeWare(drugName, pacCnt);
			      }
			      
			    } else {
			      this.$message.error(response?.message || '未找到追溯码信息或接口返回异常');
			    }
			  } catch (error) {
			    console.error('获取追溯码详情失败:', error);
			    this.$message.error('获取追溯码详情失败，请检查追溯码是否正确');
			  } finally {
			    this.outerScanLoading = false;
			  }
			},
			
			// 药品搜索
			async handleDrugSearch(query, row) {
			  console.log('药品搜索触发:', {
			    mode: this.mode,
			    query: query,
			    rowIndex: this.medicineList.indexOf(row),
			    isNewRow: row.isNewRow
			  });
			
			  // 保存搜索关键词
			  this.currentSearchKeyword = query || '';
			  
			  // 检查是否可以搜索
			  if (!this.canSearchDrug(row)) {
			    console.log('当前不允许搜索药品');
			    return;
			  }
			
			  // 保存搜索查询
			  this.drugSearchQuery = query || '';
			  
			  // 为当前行保存搜索查询
			  if (row.isNewRow || this.mode === 'add') {
			    row.drugSearchQuery = query || '';
			  }
			
			  // 如果搜索词为空，清空搜索结果并重置搜索条件
			  if (!query || query.trim() === '') {
			    console.log('搜索词为空，清空搜索结果并重置');
			    
			    // 清空搜索关键词
			    this.currentSearchKeyword = '';
			    
			    // 清空当前行的搜索结果
			    if (row.isNewRow || this.mode === 'add') {
			      row.drugSearchResults = [];
			    }
			    
			    // 重置搜索条件
			    this.resetDrugSearch();
			    
			    // 重新加载默认药品列表
			    this.loadDefaultDrugs();
			    return;
			  }
			
			  // 重置分页和搜索状态
			  this.drugPageNum = 1;
			  this.drugHasMore = true;
			  this.drugSearchLoading = true;
			
			  // 设置行级加载状态
			  if (row.isNewRow || this.mode === 'add') {
			    row.drugLoading = true;
			  }
			
			  // 清除之前的定时器
			  if (this.searchTimer) {
			    clearTimeout(this.searchTimer);
			  }
			
			  // 设置防抖，避免频繁请求
			  this.searchTimer = setTimeout(async () => {
			    await this.performDrugSearch(query, row);
			  }, 300);
			},
			
			// 新增：高亮文本中的关键词
			highlightKeyword(text, keyword) {
			  if (!text || !keyword || !keyword.trim()) {
			    return text || '';
			  }
			  
			  const searchText = String(text);
			  const searchKeyword = String(keyword).trim();
			  
			  // 如果搜索关键词为空，返回原文本
			  if (!searchKeyword) {
			    return searchText;
			  }
			  
			  try {
			    // 创建正则表达式，忽略大小写，使用全局匹配
			    const regex = new RegExp(`(${this.escapeRegExp(searchKeyword)})`, 'gi');
			    
			    // 替换匹配的关键词为高亮样式
			    return searchText.replace(regex, '<span class="highlight-keyword">$1</span>');
			  } catch (error) {
			    console.error('高亮关键词失败:', error);
			    return searchText;
			  }
			},
			
			// 新增：转义正则表达式特殊字符
			escapeRegExp(string) {
			  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
			},
			
			// 新增：获取高亮后的药品名称
			getHighlightedDrugName(drug, row) {
			  if (!row) return drug.drugName || '';
			  // 获取药品显示名称（已区分行类型）
			  const drugName = this.getDrugDisplayLabel(drug, row) || '';
			  if (this.currentSearchKeyword && this.currentSearchKeyword.trim()) {
			    return this.highlightKeyword(drugName, this.currentSearchKeyword);
			  }
			  return drugName;
			},
			
			// 执行药品搜索
			async performDrugSearch(query, row) {
			  console.log('执行药品搜索:', query);
			  
			  try {
			    // 构建搜索参数
			    const searchParams = {
			      pageNum: this.drugPageNum,
			      pageSize: this.drugPageSize
			    };
			    
			    // 使用合适的参数名drugName
			    if (query && query.trim()) {
			      // 尝试使用多个可能的参数名
			      searchParams.drugName = query.trim();  // 主要使用drugName
			      searchParams.name = query.trim();  // 备用参数
			    }
			    
			    console.log('搜索参数:', searchParams);
			    
			    // 调用getWare接口
			    const response = await getWare(searchParams);
			    
			    console.log('搜索接口返回:', {
			      code: response.code,
			      dataCount: response.data?.content?.length || response.data?.length || 0,
			      hasData: !!(response.data?.content || response.data)
			    });
			    
			    if (response && response.code === 200) {
			      const newDrugs = response.data?.content || response.data || [];
			      
			      console.log('搜索到药品数量:', newDrugs.length);
			      console.log('搜索结果前5个:', newDrugs.slice(0, 5));
			      
			      // 更新药品选项列表
			      this.updateDrugOptionsAfterSearch(newDrugs);
			      
			      // 为当前行保存搜索结果
			      if (row.isNewRow || this.mode === 'add') {
			        row.drugSearchResults = newDrugs;
			        console.log('已为当前行保存搜索结果:', row.drugSearchResults.length, '个');
			      }
			      
			      // 更新是否有更多数据的状态
			      this.drugHasMore = newDrugs.length >= this.drugPageSize;
			      
			      // 显示搜索成功的消息
			      if (newDrugs.length > 0) {
			        console.log('搜索成功，找到', newDrugs.length, '个药品');
			      } else {
			        console.log('未找到相关药品');
			        this.$message.info(`未找到 "${query}" 的相关药品`);
			      }
			    } else {
			      console.error('搜索接口返回异常:', response?.message);
			      this.$message.error(response?.message || '搜索药品失败');
			    }
			  } catch (error) {
			    console.error('执行药品搜索失败:', error);
			    this.$message.error('搜索药品失败: ' + (error.message || '网络错误'));
			  } finally {
			    this.drugSearchLoading = false;
			    if (row.isNewRow || this.mode === 'add') {
			      row.drugLoading = false;
			    }
			  }
			},
			
			// 新增：更新药品选项列表
			updateDrugOptionsAfterSearch(newDrugs) {
			  console.log('更新药品选项列表:', {
			    新数据数量: newDrugs.length,
			    当前页: this.drugPageNum,
			    是第一次搜索: this.drugPageNum === 1
			  });
			  
			  // 如果是第一页搜索，直接替换
			  if (this.drugPageNum === 1) {
			    this.drugOptions = newDrugs;
			    console.log('第一页搜索，替换药品列表，新长度:', newDrugs.length);
			  } else {
			    // 如果是加载更多，追加到现有列表
			    this.drugOptions = [...this.drugOptions, ...newDrugs];
			    console.log('加载更多，追加到列表，总长度:', this.drugOptions.length);
			  }
			  
			  // 确保数据正确
			  this.drugOptions = this.drugOptions.map(drug => {
			    // 确保每个药品对象都有必要的字段
			    return {
			      id: drug.id,
			      drugName: drug.drugName || drug.name || drug.label || '未知药品',
			      drugSpecifications: drug.drugSpecifications || drug.drugSpec || drug.spec || '',
			      pacSpec: drug.pacSpec || drug.packageSpec || '',
			      markUpId: drug.markUpId || 1,
			      isFixPrice: drug.isFixPrice || 0,
			      costPric: drug.costPric || 0,
			      dosUnt: drug.dosUnt || '单位',
			      pacUnt: drug.pacUnt || '包装单位',
			      pacCnt: drug.pacCnt || 1,
			      manufacturerName: drug.manufacturerName || drug.manufacturer || '',
				  periodControl: drug.periodControl !== undefined ? parseInt(drug.periodControl) : 1, // 新增
				  expyDate: drug.expyDate !== undefined && drug.expyDate !== null ? parseInt(drug.expyDate) : null, // 新增
			      ...drug // 保留其他字段
			    };
			  });
			  
			  console.log('更新后的药品选项列表前5个:', this.drugOptions.slice(0, 5));
			},
			
			// 新增：判断是否可以显示"没有更多"
			canShowNoMore(row) {
				return this.canLoadMore(row);
			},
 
			// 新增：显示无数据消息
			showNoDataMessage(row) {
				// 只有当有搜索词且没有结果时才显示
				return this.drugSearchQuery &&
					this.drugSearchQuery.trim() &&
					this.drugOptions.length === 0;
			},
 
			// 药品下拉框获取焦点
			handleDrugFocus(row) {
			  console.log('药品下拉框获取焦点:', row);
			  if (!row) return;
			  // 如果是新增模式或修改模式的新增行
		      if ((this.mode === 'add' || (this.mode === 'edit' && row.isNewRow)) && row.drugSearchQuery) {
			    // 如果有搜索内容，清空并重新加载全部选项
			    if (row.drugSearchQuery && row.drugSearchQuery.trim()) {
			      console.log('有搜索内容，清空并重置');
			      
			      // 清空搜索内容
			      row.drugSearchQuery = '';
			      row.drugSearchResults = [];
			      this.drugSearchQuery = '';
			      
			      // 重置搜索条件
			      this.resetDrugSearch();
			      
			      // 重新加载默认药品列表
			      this.loadDefaultDrugs();
			      
			      // 显示提示
			      this.$message.info('已清空搜索内容，显示全部药品');
			    } else {
			      // 如果没有搜索内容，加载默认列表
			      if (this.drugOptions.length === 0) {
			        console.log('没有药品列表，加载默认列表');
			        this.loadDefaultDrugs();
			      }
			    }
			  }
			},
 
			// 药品滚动到底部
			handleDrugScroll(row) {
			  // 只在可以加载更多时触发
			  if (this.canLoadMore(row) && !this.drugSearchLoading && !this.loadingMoreDrugs) {
			    console.log('滚动到底部，加载更多药品');
			    this.loadMoreDrugs();
			  }
			},
 
			// 加载更多药品
			async loadMoreDrugs() {
			  console.log('加载更多药品，当前页:', this.drugPageNum);
			  
			  this.loadingMoreDrugs = true;
			  this.drugPageNum++;
			  
			  try {
			    const searchParams = {
			      pageNum: this.drugPageNum,
			      pageSize: this.drugPageSize
			    };
			    
			    // 如果有搜索词，添加到参数中
			    if (this.drugSearchQuery && this.drugSearchQuery.trim()) {
			      searchParams.name = this.drugSearchQuery;
			      searchParams.drugName = this.drugSearchQuery;
			    }
			    
			    const response = await getWare(searchParams);
			    
			    if (response && response.code === 200) {
			      const newDrugs = response.data?.content || response.data || [];
			      
			      // 追加到现有列表
			      this.drugOptions = [...this.drugOptions, ...newDrugs];
			      
			      // 更新是否有更多数据的状态
			      this.drugHasMore = newDrugs.length >= this.drugPageSize;
			      
			      console.log('加载更多成功，总药品数:', this.drugOptions.length);
			    }
			  } catch (error) {
			    console.error('加载更多药品失败:', error);
			  } finally {
			    this.loadingMoreDrugs = false;
			  }
			},
			
			// 药品选择变化
			async handleDrugChange(row) {
			  if (!row.drugId) {
			    console.log('药品ID为空，重置药品信息');
			    this.resetRowDrugInfo(row);
			    return;
			  }
			
			  console.log('药品选择变化:', row.drugId);
			
			  // 在新增模式下，处理药品变化
			  if (this.mode === 'add') {
			    const selectedDrug = this.drugOptions.find(item => item.id === row.drugId);
			    if (selectedDrug) {
			      console.log('选择了新药品:', selectedDrug);
			
			      // 填充药品信息
			      row.drugName = selectedDrug.drugName;
			      row.spec = selectedDrug.drugSpecifications || selectedDrug.drugSpec || '';
			      row.packageSpec = selectedDrug.pacSpec || '';
			      row.costPric = selectedDrug.costPric || 0;
			      row.pacCnt = selectedDrug.pacCnt || 1;
			      row.dosUnt = selectedDrug.dosUnt || '单位';
			      row.pacUnt = selectedDrug.pacUnt || '包装单位';
			      row.isBar = selectedDrug.isBar || 0;
			      row.markUpId = selectedDrug.markUpId || 1;        // 关键：获取加成方式
			      row.isFixPrice = selectedDrug.isFixPrice || 0;
			      row.markupMethodText = this.getMarkupMethodText(row.markUpId, row.isFixPrice);
			      row.isFixedPriceText = row.isFixPrice === 1 ? '已指定' : '未指定';
			      row.unitLabel = row.purcType === 1 ? row.dosUnt : row.pacUnt;
				  row.periodControl = selectedDrug.periodControl !== undefined ? parseInt(selectedDrug.periodControl) : 1;
				  row.expyDateDisabled = row.periodControl === 0;
				  row.expyDateDays = selectedDrug.expyDate !== undefined && selectedDrug.expyDate !== null ? parseInt(selectedDrug.expyDate) : null; // 新增
			      // 根据加成方式计算零售价
			      if (row.costPric > 0) {
			        if (row.markUpId === 4) {
			          // 不加成：零售价等于成本价
			          row.salePric = row.costPric;
			        } else {
			          await this.loadMarkupInfo(row);
			        }
			      }
			      this.calculateRowAmount(row);
			      await this.loadManufacturers(row);
			    }
			  }
			
			  // 修改模式下，如果允许重新选择，也处理药品变化
			  if (this.mode === 'edit') {
			    const selectedDrug = this.drugOptions.find(item => item.id === row.drugId);
			    if (selectedDrug) {
			      console.log('修改模式下选择了新药品:', selectedDrug);
			
			      // 填充药品信息
			      row.drugName = selectedDrug.drugName;
			      row.spec = selectedDrug.drugSpecifications || selectedDrug.drugSpec || '';
			      row.packageSpec = selectedDrug.pacSpec || '';
			      row.costPric = selectedDrug.costPric || 0;
			      row.pacCnt = selectedDrug.pacCnt || 1;
			      row.dosUnt = selectedDrug.dosUnt || '单位';
			      row.pacUnt = selectedDrug.pacUnt || '包装单位';
			      row.isBar = selectedDrug.isBar || 0;
			      row.markUpId = selectedDrug.markUpId || 1;        // 关键：获取加成方式
			      row.isFixPrice = selectedDrug.isFixPrice || 0;
			      row.markupMethodText = this.getMarkupMethodText(row.markUpId, row.isFixPrice);
			      row.isFixedPriceText = row.isFixPrice === 1 ? '已指定' : '未指定';
			      row.unitLabel = row.purcType === 1 ? row.dosUnt : row.pacUnt;
				  row.periodControl = selectedDrug.periodControl !== undefined ? parseInt(selectedDrug.periodControl) : 1;
				  row.expyDateDisabled = row.periodControl === 0;
				  row.expyDateDays = selectedDrug.expyDate !== undefined && selectedDrug.expyDate !== null ? parseInt(selectedDrug.expyDate) : null; // 新增
			      // 根据加成方式计算零售价
			      if (row.costPric > 0) {
			        if (row.markUpId === 4) {
			          // 不加成：零售价等于成本价
			          row.salePric = row.costPric;
			        } else {
			          await this.loadMarkupInfo(row);
			        }
			      }
			      this.calculateRowAmount(row);
			      await this.loadManufacturers(row);
			    }
			  }
			},
 
			// 加载生产厂家
			async loadManufacturers(row) {
				try {
					console.log('加载生产厂家，药品ID:', row.drugId);
 
					const response = await getProdent({
						drugId: row.drugId
					});
 
					if (response && response.code === 200 && response.data) {
						const manufacturers = Array.isArray(response.data) ? response.data : [response.data];
						row.manufacturerOptions = manufacturers;
 
						console.log('加载到的生产厂家:', manufacturers);
 
						// 如果有生产厂家，设置默认值
						if (manufacturers.length > 0) {
							// 如果当前药品有生产厂家ID，查找匹配的生产厂家
							if (row.prodentpNameId) {
								const matchedManufacturer = manufacturers.find(m => m.prodentpId === row
									.prodentpNameId);
								if (matchedManufacturer) {
									row.prodentpNameId = matchedManufacturer.prodentpId;
									row.manufacturer = matchedManufacturer.prodentpName;
								} else {
									// 如果没有匹配的生产厂家，使用第一个
									row.prodentpNameId = manufacturers[0].prodentpId;
									row.manufacturer = manufacturers[0].prodentpName;
								}
							} else {
								// 如果没有生产厂家ID，使用第一个
								row.prodentpNameId = manufacturers[0].prodentpId;
								row.manufacturer = manufacturers[0].prodentpName;
							}
						}
					} else {
						console.log('没有找到生产厂家');
						row.manufacturerOptions = [];
					}
				} catch (error) {
					console.error('加载生产厂家失败:', error);
					row.manufacturerOptions = [];
				}
			},
			
			// 计算零售价（基于成本价和加成方式）
			async calculateRetailPrice(row) {
			  if (!row.costPric || row.costPric <= 0) {
			    console.log('成本无效，跳过零售价计算');
			    return;
			  }
			  try {
			    const response = await docMarkById({
			      drugId: row.drugId,
			      costPric: row.costPric || 0,
			      purcType: row.purcType || 2,
			      drugType: 1
			    });
			
			    if (response.code === 200) {
			      // 根据库存类型显示不同的零售价
			      if (row.purcType === 1) {
			        row.salePric = response.data.minSalePrice;
			      } else {
			        row.salePric = response.data.pacSalePrice;
			      }
			      this.calculateRowAmount(row);
			    } else {
			      console.error('计算零售价失败:', response.message);
			    }
			  } catch (error) {
			    console.error('计算零售价异常:', error);
			  }
			},
			
			// 加载加成信息
			async loadMarkupInfo(row) {
			 // 如果不加成，直接返回
			   if (row.markUpId === 4) {
			     console.log('不加成模式，不调用加成接口');
			     row.salePric = row.costPric;
			     this.calculateRowAmount(row);
			     return;
			   }
			   if (!row.costPric || row.costPric <= 0) {
			     console.log('成本无效，跳过加载加成信息');
			     return;
			   }
			  try {
			    const response = await docMarkById({
			      drugId: row.drugId,
			      costPric: row.costPric || 0,
			      purcType: row.purcType || 2,
			      drugType: 1
			    });
			
			    if (response.code === 200) {
			      if (row.purcType === 1) {
			        row.salePric = response.data.minSalePrice;
			      } else {
			        row.salePric = response.data.pacSalePrice;
			      }
			      this.calculateRowAmount(row);
			    } else {
			      this.$message.error(response.message || '获取加成信息失败');
			    }
			  } catch (error) {
			    console.error('加载加成信息失败:', error);
			    this.$message.error('加载加成信息失败');
			  }
			},
 
			// 成本单价变化
			handleCostPriceChange(row) {
			  console.log('处理成本价格变化，当前行：', row);
			  console.log('markUpId：', row.markUpId, 'isFixPrice：', row.isFixPrice);
			
			  // 计算行金额
			  this.calculateRowAmount(row);
			
			  // 关键修改：根据 markUpId 判断计算方式
			  if (row.costPric > 0) {
			    if (row.markUpId === 1 || row.markUpId === 3) {
			      // 比例加成或手工比例加成，调用接口计算零售价
			      this.calculateRetailPrice(row);
			    } else if (row.markUpId === 4) {
			      // 不加成：零售价直接等于成本单价，零售金额等于成本金额
			      console.log(`markUpId=${row.markUpId}（不加成），零售价等于成本单价`);
			      row.salePric = row.costPric;
			      this.calculateRowAmount(row);  // 重新计算金额
			    } else {
			      // 其他情况（如固定加成），暂时将零售价等于成本价
			      console.log(`markUpId=${row.markUpId}，使用默认逻辑：零售价等于成本单价`);
			      row.salePric = row.costPric;
			      this.calculateRowAmount(row);
			    }
			  } else {
			    // 成本为0或空时，清空零售价
			    row.salePric = '';
			    this.calculateRowAmount(row);
			  }
			},
 
			// 处理库存类型变化
			handlePurcTypeChange(row) {
			  console.log('库存类型变化:', row.purcType, '包装数量:', row.pacCnt);
			  
			  // 更新单位标签
			  this.updateUnitLabel(row);
			  
			  // 如果库存类型为最小单位 (purcType === 1)，检查入库数量是否超过包装数量
			  if (row.purcType === 1) {
			    if (row.inboundQty > row.pacCnt) {
			      this.$message.warning('最小单位时，入库数量不能超过包装数量');
			    }
			  } else {
			    // 如果库存类型为包装单位 (purcType === 2)，入库数量默认为1
			    row.inboundQty = 1;
			  }
			  
			  // 更新提示文字
			  this.updateInboundQtyTip(row);
			  
			  // 验证入库数量
			  this.validateInboundQty(row);
			  
			  console.log('库存类型变化后:', row);
			},
 
			// 厂家变化
			handleManufacturerChange(row) {
				const selectedManufacturer = row.manufacturerOptions.find(item => item.prodentpId === row.prodentpNameId);
				if (selectedManufacturer) {
					row.manufacturer = selectedManufacturer.prodentpName;
 
					if (row.manuDate) {
						this.calculateExpiryDate(row);
					}
				}
			},
 
			// 生产日期变化
			async handleManuDateChange(row) {
				if (row.manuDate && row.expyDate) {
					await this.validateDateRange(row);
				}
 
				if (row.manuDate && parseInt(row.periodControl) === 1 && row.expyDateDays) {
				    this.calculateExpiryDate(row);
				}
			},
 
			// 有效日期变化
			async handleExpiryDateChange(row) {
				if (row.manuDate && row.expyDate) {
					await this.validateDateRange(row);
				}
			},
 
			// 计算有效日期
			calculateExpiryDate(row) {
				if (!row.manuDate || !row.expyDateDays || parseInt(row.periodControl) !== 1) return;
 
				const manufacturer = row.manufacturerOptions.find(item => item.prodentpId === row.prodentpNameId);
				if (manufacturer && manufacturer.expyDate) {
					const manuDate = new Date(row.manuDate);
					const expiryDays = parseInt(manufacturer.expyDate) || 0;
 
					if (expiryDays > 0) {
						manuDate.setDate(manuDate.getDate() + expiryDays);
 
						const year = manuDate.getFullYear();
						const month = String(manuDate.getMonth() + 1).padStart(2, '0');
						const day = String(manuDate.getDate()).padStart(2, '0');
 
						row.expyDate = `${year}-${month}-${day}`;
 
						this.$nextTick(() => {
							this.validateDateRange(row);
						});
					}
				}
			},
 
			// 验证日期范围
			async validateDateRange(row) {
				if (!row.manuDate || !row.expyDate) return;
 
				const manuDate = new Date(row.manuDate);
				const expyDate = new Date(row.expyDate);
				const currentDate = new Date();
 
				manuDate.setHours(0, 0, 0, 0);
				expyDate.setHours(0, 0, 0, 0);
				currentDate.setHours(0, 0, 0, 0);
 
				if (expyDate < manuDate) {
					this.$message.warning('有效日期不能小于生产日期');
					row.expyDate = '';
					return false;
				}
 
				if (expyDate < currentDate) {
					this.$message.warning('有效日期不能小于当前日期');
					row.expyDate = '';
					return false;
				}
 
				if (manuDate > expyDate) {
					this.$message.warning('生产日期不能大于有效日期');
					row.manuDate = '';
					return false;
				}
 
				return true;
			},
 
			// 获取有效日期选择器的限制选项
			getExpiryDatePickerOptions(row) {
				return {
					disabledDate: (time) => {
						const currentDate = new Date();
						currentDate.setHours(0, 0, 0, 0);
 
						let manuDate = null;
						if (row.manuDate) {
							manuDate = new Date(row.manuDate);
							manuDate.setHours(0, 0, 0, 0);
						}
 
						if (time < currentDate) {
							return true;
						}
 
						if (manuDate && time < manuDate) {
							return true;
						}
 
						return false;
					}
				};
			},
 
			// 生产日期选择器限制选项
			getManuDatePickerOptions(row) {
				return {
					disabledDate: (time) => {
						let expyDate = null;
						if (row.expyDate) {
							expyDate = new Date(row.expyDate);
							expyDate.setHours(0, 0, 0, 0);
						}
 
						if (expyDate && time > expyDate) {
							return true;
						}
 
						return false;
					}
				};
			},
			
			// 快速获取供应商entId
			getSupplierEntId(supplierId) {
			  if (!supplierId || !this.supplierList.length) {
			    return '';
			  }
			  
			  const supplier = this.supplierList.find(item => item.id === supplierId);
			  return supplier ? (supplier.entId || '') : '';
			},
			
			// 在需要获取供应商entId的地方调用此方法
			// 例如，在重新补传前可以调用
			async refreshSupplierEntId() {
			  if (this.formData.supplierId) {
			    const entId = this.getSupplierEntId(this.formData.supplierId);
			    if (entId) {
			      this.formData.entId = entId;
			      return true;
			    }
			  }
			  return false;
			},
			
			// 采购药库变化
			handleWarehouseChange(newVal) {
				if (this.mode == 'add') {
					if (newVal !== 1) {
						this.$confirm(
							`请知悉，当前模块为【西药库】，而您已将采购药库切换为了【西药房】，此操作会将采购的药品直接入库至药房西，会省去调拨等相关步骤，请在录入药品的时候进行检查，仔细比对数据的准确性，创建成功后此单据以及后续过单等操作将显示在已采购的【西药房】列表之西。`,
							'切换药库提示', {
								confirmButtonText: '确认切换',
								cancelButtonText: '取消',
								type: 'warning',
								customClass: 'warehouse-change-confirm',
								center: true
							}
						).then(() => {
							this.formData.warehouseId = 3;
 
							// 如果有未完成的药品信息，清空当前填写的药品数据
							const hasIncompleteData = this.medicineList.some(item =>
								!item.drugId || !item.manuLotnum || !item.manuDate || !item.expyDate || !item
								.prodentpNameId
							);
 
							if (hasIncompleteData && this.medicineList.length > 0) {
								this.medicineList = [];
								this.$message.info('已清空当前填写的药品数据，请重新添加药品');
							}
						}).catch(() => {
							// 取消切换，恢复原值
							this.formData.warehouseId = oldWarehouse;
						});
					}
				} else {
					// 非新增模式下，不处理切换逻辑
					this.formData.warehouseId = newVal;
				}
			},
 
			// 供应商选择变化
			handleSupplierChange(supplierId) {
			  console.log('选择的供应商ID:', supplierId);
			  
			  if (supplierId) {
			    const selectedSupplier = this.supplierList.find(item => item.id === supplierId);
			    if (selectedSupplier) {
			      this.formData.supplierName = selectedSupplier.supplierName;
			      this.formData.supplierCode = selectedSupplier.contactPhone || '';
			      
			      // 保存供应商的entId，字段名为entId
			      this.formData.entId = selectedSupplier.entId || '';
			      console.log('选择的供应商entId:', this.formData.entId);
			      
			      this.$message.success(`已选择供应商: ${selectedSupplier.supplierName}`);
			    }
			  } else {
			    this.formData.supplierName = '';
			    this.formData.supplierCode = '';
			    this.formData.entId = '';
			  }
			},
 
			// 添加供应商
			handleAddSupplier() {
				this.supplierForm = {
					address: "",
					clinicId: 0,
					contact: "",
					contactPhone: "",
					id: 0,
					payAmt: 0,
					permitNumber: "",
					entId: "",
					receAmt: 0,
					remark: "",
					status: 0,
					supplierName: ""
				};
				this.supplierDialogVisible = true;
			},
 
			// 保存供应商
			async handleSaveSupplier() {
				this.$refs.supplierForm.validate(async (valid) => {
					if (valid) {
						this.supplierSaving = true;
						try {
							const response = await addSupplierEntity(this.supplierForm);
							if (response && response.code === 200) {
								this.$message.success('供应商添加成功');
								this.supplierDialogVisible = false;
 
								await this.loadSuppliers();
 
								if (response.data && response.data.id) {
									this.formData.supplierId = response.data.id;
								}
							} else {
								this.$message.error(response.message || '添加供应商失败');
							}
						} catch (error) {
							console.error('添加供应商失败:', error);
							this.$message.error('添加供应商失败');
						} finally {
							this.supplierSaving = false;
						}
					}
				});
			},
 
			// 新增：判断药品是否可以选择
			canSelectDrug(row) {
				// 如果是修改模式
				if (this.isEditMode) {
					// 如果当前行标记为新增行，则可以编辑
					if (row.isNewRow) {
						return true;
					}
					// 如果当前行是原始数据行，则不可编辑
					return false;
				}
 
				// 其他模式（新增、查看、提交、审核等）按照原有逻辑处理
				if (this.mode === 'add') {
					return true;
				}
				return false;
			},
 
			// 修改：获取药品选项用于显示
			getDrugOptionsForDisplay(row) {
				// 如果当前有搜索查询，使用搜索结果
				if (this.drugSearchQuery && this.drugSearchQuery.trim()) {
					// 如果搜索后有结果，显示搜索结果
					if (this.drugOptions.length > 0) {
						return this.drugOptions;
					}
					// 如果搜索后没有结果，回退到默认列表
					else {
						return this.defaultDrugOptions || [];
					}
				}
 
				// 如果没有搜索查询，使用默认选项
				return this.getDefaultDrugOptionsForRow(row);
			},
 
			// 新增：获取默认药品选项
			getDefaultDrugOptionsForRow(row) {
				// 新增模式下，使用全局药品列表
				if (this.mode === 'add') {
					return this.drugOptions;
				}
 
				// 非新增模式下
				// 如果当前行有药品ID，查找匹配的药品
				if (row.drugId) {
					const foundDrug = this.drugOptions.find(drug => drug.id === row.drugId);
					if (foundDrug) {
						return [foundDrug];
					} else {
						// 如果没有找到，创建临时选项
						return [{
							id: row.drugId,
							drugName: row.drugName || '未知药品',
							label: row.drugName || '未知药品',
							drugSpecifications: row.spec,
							pacSpec: row.packageSpec
						}];
					}
				} else {
					// 如果没有药品ID，使用全局药品列表
					return this.drugOptions;
				}
			},
 
			// 处理药品清空事件
			handleDrugClear(row) {
			  console.log('药品选择框被清空:', row);
			  
			  // 重置当前行的药品信息
			  this.resetRowDrugInfo(row);
			  
			  // 清空搜索内容
			  if (row.isNewRow || this.mode === 'add') {
			    row.drugSearchQuery = '';
			    row.drugSearchResults = [];
			  }
			  
			  // 重置搜索条件
			  this.resetDrugSearch();
			  
			  // 重新加载默认药品列表
			  this.loadDefaultDrugs();
			  
			  this.$message.info('已清空药品选择，可重新选择');
			},
			
			// 重置行的药品信息
			resetRowDrugInfo(row) {
			  row.drugId = '';
			  row.drugName = '';
			  row.spec = '';
			  row.packageSpec = '';
			  row.costPric = 0;
			  row.pacCnt = 1;
			  row.dosUnt = '单位';
			  row.pacUnt = '包装单位';
			  row.markupMethodText = '';
			  row.isFixedPriceText = '';
			  row.unitLabel = row.purcType === 1 ? row.dosUnt : row.pacUnt;
			  row.totalCost = 0;
			  row.totalRetail = 0;
			  row.manufacturerOptions = [];
			  row.prodentpNameId = '';
			  row.manufacturer = '';
			  row.periodControl = 1;
			  row.expyDateDays = null; // 新增
			  row.expyDateDisabled = false;
			  // 关键：重置isBar字段
			  row.isBar = 0; // 重置为0，表示不显示追溯码按钮
			  
			  // 清空搜索相关内容
			  if (row.isNewRow || this.mode === 'add') {
			    row.drugSearchQuery = '';
			    row.drugSearchResults = [];
			  }
			  
			  console.log('药品信息已重置，isBar:', row.isBar);
			},
 
			// 新增：重置药品搜索条件
			resetDrugSearch() {
				this.drugSearchQuery = '';
				this.drugPageNum = 1;
				this.drugHasMore = true;
 
				console.log('药品搜索条件已重置');
			},
 
			// 新增：加载默认药品列表
			async loadDefaultDrugs() {
			  try {
			    console.log('加载默认药品列表...');
			    
			    this.drugSearchLoading = true;
			    this.drugPageNum = 1;
			    this.drugHasMore = true;
			    this.drugSearchQuery = '';
			    
			    // 调用getWare接口获取第一页数据
			    const response = await getWare({
			      pageNum: 1,
			      pageSize: this.drugPageSize
			    });
			    
			    if (response && response.code === 200) {
			      const newDrugs = response.data?.content || response.data || [];
			      this.drugOptions = newDrugs;
			      this.allDrugOptions = [...newDrugs]; // 缓存全部
			      console.log('默认药品列表已加载:', this.drugOptions.length, '个药品');
			      console.log('前5个药品:', this.drugOptions.slice(0, 5));
			    } else {
			      console.error('加载默认药品列表失败:', response?.message);
			      this.drugOptions = [];
			    }
			  } catch (error) {
			    console.error('加载默认药品列表失败:', error);
			    this.drugOptions = [];
			  } finally {
			    this.drugSearchLoading = false;
			  }
			},
 
			// 添加药品
			handleAddMedicine() {
			  // 过滤掉 null 元素，防止渲染报错
			  this.medicineList = this.medicineList.filter(item => item !== null);
			
			  console.log('添加药品按钮被点击，当前模式:', this.mode);
			  
			  if (this.medicineList.length > 0) {
			    const lastRow = this.medicineList[this.medicineList.length - 1];
			    if (!lastRow) {
			      this.medicineList = this.medicineList.filter(item => item !== null);
			      if (this.medicineList.length === 0) {
			        this.pushNewMedicine();
			        return;
			      }
			    }
			    const lastRowValid = this.medicineList[this.medicineList.length - 1];
			    if (!lastRowValid) {
			      this.pushNewMedicine();
			      return;
			    }
			    // 基础必填字段（不包含有效日期）
			    const requiredFields = ['inboundQty', 'manuLotnum', 'manufacturer', 'costPric', 'manuDate'];
			    // 只有启用了效期管理（periodControl === 1）时，才要求有效日期必填
			    if (parseInt(lastRowValid.periodControl) === 1) {
			      requiredFields.push('expyDate');
			    }
			    for (const field of requiredFields) {
			      if (!lastRowValid[field] && lastRowValid[field] !== 0) {
			        this.$message.warning(`请先完成当前行「${this.getFieldLabel(field)}」的填写`);
			        return;
			      }
			    }
			    // 如果药品启用了追溯码，但未录入，拦截
			    if (lastRowValid.isBar === 1 && (!lastRowValid.traceCodes || lastRowValid.traceCodes.length === 0)) {
			      this.$message.warning(`请先为「${lastRowValid.drugName}」录入追溯码`);
			      return;
			    }
			  }
			
			  // 添加新行
			  this.pushNewMedicine();
			},
			
			// 提取添加新行的逻辑
			pushNewMedicine() {
			  // 重置全局药品列表为全部药品
			  if (this.allDrugOptions && this.allDrugOptions.length > 0) {
			    this.drugOptions = [...this.allDrugOptions];
			  } else {
			    // 缓存为空则重新加载（确保有数据）
			    this.loadDefaultDrugs();
			  }
			  this.drugSearchQuery = '';
			
			  const newMedicine = {
			    id: Date.now() + Math.random(),
			    drugId: '',
			    drugName: '',
			    inboundQty: 1,
			    purcType: 2,
			    pacCnt: 1,
			    manuLotnum: '',
			    manuDate: '',
			    expyDate: '',
			    prodentpNameId: '',
			    manufacturer: '',
			    manufacturerOptions: [],
			    costPric: 0,
			    totalCost: 0,
			    salePric: 0,
			    totalRetail: 0,
			    markupMethod: 1,
			    markupMethodText: '',
			    isFixedPriceText: '',
			    spec: '',
			    packageSpec: '',
			    dosUnt: '单位',
			    pacUnt: '包装单位',
			    unitLabel: '包装单位',
			    expyDateDisabled: false,
			    isBar: 0,
			    traceCodes: [],
			    tracCodeJson: '',
			    isNewRow: this.isEditMode,
				periodControl: 1,
				expyDateDays: null, // 新增
			    drugSearchQuery: '',
			    drugSearchResults: [],
			    drugLoading: false,
			  };
			
			  this.medicineList.push(newMedicine);
			  if (this.drugOptions.length === 0) {
			    this.loadDefaultDrugs();
			  }
			},
			
			// 判断追溯码按钮是否可用
			canTraceCode(row) {
			  // 在新增模式下
			  if (this.mode === 'add') {
			    // 必须选择了药品信息
			    if (!row.drugId) {
			      return false;
			    }
			    // 检查isBar字段是否为1
			    if (row.isBar !== 1) {
			      return false;
			    }
			    return true;
			  }
			  
			  // 在修改模式下，只有草稿状态（state===0）才可用
			  if (this.mode === 'edit') {
			    return this.rowData && this.rowData.state === 0;
			  }
			  
			  return false;
			},
			
			// 获取追溯码按钮的提示信息
			getTraceCodeTooltip(row) {
			  if (this.mode === 'add') {
			    if (!row.drugId) {
			      return '要上传追溯码，请先选择对应的药品信息';
			    }
			    if (row.isBar === 0) {
			      return '当前药品未启用追溯码功能';
			    }
			  } else if (this.mode === 'edit') {
			    if (!this.rowData || this.rowData.state !== 0) {
			      return '只有草稿状态的单据才能上传追溯码';
			    }
			  }
			  return '';
			},
			
			// 加载已存在的追溯码
			async loadExistingTraceCodes(row) {
			  try {
			    console.log('加载已存在的追溯码，行数据:', row);
			    
			    // 从行的traceCodes字段加载已存在的追溯码
			    if (row.traceCodes && row.traceCodes.length > 0) {
			      console.log('从traceCodes字段加载追溯码，数量:', row.traceCodes.length);
			      
			      // 将追溯码数据复制到补录列表
			      this.traceCodeSupplementList = row.traceCodes.map(item => ({
			        ...item,
			        id: item.id || Date.now() + Math.random()
			      }));
			      
			      console.log('已加载的追溯码列表:', this.traceCodeSupplementList);
			    } 
			    // 如果traceCodes为空，尝试从tracCodeJson解析
			    else if (row.tracCodeJson && row.tracCodeJson !== null && row.tracCodeJson !== '') {
			      console.log('从tracCodeJson解析追溯码:', row.tracCodeJson);
			      
			      // 解析tracCodeJson字符串
			      const traceCodeData = this.parseTraceCodeJson(row.tracCodeJson, row);
			      
			      if (traceCodeData && traceCodeData.length > 0) {
			        this.traceCodeSupplementList = traceCodeData.map((item, index) => ({
			          id: index + 1,
			          traceCode: item.traceCode || '',
			          drugName: row.drugName || '',
			          spec: row.spec || '',
			          availableQty: 1,
			          manufacturer: row.manufacturer || '',
			          remark: '',
			          status: 'active',
			          batchNo: '',
			          approvalLicenceNo: '',
			          produceDate: '',
			          expireDate: '',
			          chgCnt: item.chgCnt || row.pacCnt || 1
			        }));
			      } else {
			        console.log('无法解析tracCodeJson，使用空列表');
			        this.traceCodeSupplementList = [];
			      }
			    }
			    // 如果都没有，初始化空列表
			    else {
			      console.log('没有已存在的追溯码，初始化空列表');
			      this.traceCodeSupplementList = [];
			    }
			    
			    // 更新总追溯码数量
			    this.totalTraceQty = this.traceCodeSupplementList.length;
			    
			  } catch (error) {
			    console.error('加载已存在追溯码失败:', error);
			    this.$message.error('加载追溯码失败');
			    this.traceCodeSupplementList = [];
			  }
			},
			
			// 解析追溯码对象
			parseTraceCodeObject(tracCodeJson, row) {
			  try {
			    console.log('解析追溯码对象:', tracCodeJson);
			    
			    if (!tracCodeJson || tracCodeJson === null) {
			      return [];
			    }
			    
			    // 如果是对象
			    if (typeof tracCodeJson === 'object') {
			      // 获取对象的所有键（追溯码）
			      const traceCodes = Object.keys(tracCodeJson);
			      console.log('对象中的追溯码:', traceCodes);
			      
			      // 转换为数组格式
			      return traceCodes.map(traceCode => {
			        const traceCodeData = tracCodeJson[traceCode];
			        return {
			          traceCode: traceCode,
			          ...traceCodeData
			        };
			      });
			    }
			    
			    return [];
			  } catch (error) {
			    console.error('解析追溯码对象失败:', error);
			    return [];
			  }
			},
			
			// 解析追溯码JSON字符串
			parseTraceCodeJson(tracCodeJson, row) {
			  try {
			    console.log('解析tracCodeJson:', tracCodeJson);
			    
			    if (!tracCodeJson || tracCodeJson.trim() === '') {
			      return [];
			    }
			    
			    // 尝试解析JSON字符串
			    let traceCodeData = null;
			    try {
			      traceCodeData = JSON.parse(tracCodeJson);
			    } catch (parseError) {
			      console.log('tracCodeJson不是有效的JSON字符串:', parseError);
			      return [];
			    }
			    
			    // 检查解析后的数据类型
			    if (Array.isArray(traceCodeData)) {
			      // 数组格式，每个元素是 {barcode: "追溯码", chgCnt: 包装数量}
			      return traceCodeData.map(item => {
			        return {
			          traceCode: item.barcode || item.traceCode || '',
			          availableQty: 1,
			          chgCnt: item.chgCnt || row.pacCnt || 1
			        };
			      });
			    } else if (typeof traceCodeData === 'object' && traceCodeData !== null) {
			      // 对象格式（旧格式），转换为数组格式
			      console.log('检测到旧格式的tracCodeJson，转换为数组格式');
			      return Object.keys(traceCodeData).map(key => {
			        const item = traceCodeData[key];
			        return {
			          traceCode: key,
			          availableQty: item.availableQty || 1,
			          chgCnt: item.chgCnt || row.pacCnt || 1
			        };
			      });
			    }
			    
			    return [];
			  } catch (error) {
			    console.error('解析tracCodeJson失败:', error);
			    return [];
			  }
			},
			
			// 解析简单的{追溯码1,追溯码2,...}格式
			parseSimpleTraceCodeJson(tracCodeJson, row) {
			  try {
			    // 移除两端的空格
			    const jsonStr = tracCodeJson.trim();
			    console.log('解析简单格式的tracCodeJson:', jsonStr);
			    
			    // 检查是否是对象格式
			    if (typeof tracCodeJson === 'object' && tracCodeJson !== null) {
			      console.log('tracCodeJson已经是对象格式，直接返回');
			      return { traceCodes: Object.keys(tracCodeJson).map(key => ({
			        traceCode: key,
			        ...tracCodeJson[key]
			      })) };
			    }
			    
			    // 尝试解析为JSON字符串
			    try {
			      const parsed = JSON.parse(tracCodeJson);
			      if (typeof parsed === 'object' && parsed !== null) {
			        console.log('成功解析为JSON对象');
			        return { traceCodes: Object.keys(parsed).map(key => ({
			          traceCode: key,
			          ...parsed[key]
			        })) };
			      }
			    } catch (parseError) {
			      console.log('不是JSON字符串，尝试其他格式');
			    }
			    
			    // 检查是否是{追溯码1,追溯码2,...}格式
			    if (jsonStr.startsWith('{') && jsonStr.endsWith('}')) {
			      // 提取{}中的内容
			      const content = jsonStr.substring(1, jsonStr.length - 1).trim();
			      console.log('提取的内容:', content);
			      
			      if (content === '') {
			        return { traceCodes: [] };
			      }
			      
			      // 按逗号分割追溯码
			      const traceCodeArray = content.split(',').map(code => code.trim()).filter(code => code !== '');
			      console.log('分割后的追溯码数组:', traceCodeArray);
			      
			      // 转换为对象格式
			      const traceCodeObject = {};
			      traceCodeArray.forEach((code, index) => {
			        traceCodeObject[code] = {
			          traceCode: code,
			          availableQty: 1,
			          remark: `从tracCodeJson解析的追溯码`,
			          status: 'active',
			          batchNo: '',
			          approvalLicenceNo: '',
			          produceDate: '',
			          expireDate: ''
			        };
			      });
			      
			      return traceCodeObject;
			    }
			    
			    return null;
			  } catch (error) {
			    console.error('解析简单格式失败:', error);
			    return null;
			  }
			},
			
			// 初始化追溯码数据
			initTraceCodeData(row) {
			  // 清空之前的追溯码数据
			  this.traceCodeList = [];
			  this.totalTraceQty = 0;
			  this.scanInput = '';
			  
			  // 如果有已有的追溯码数据，从药品行中加载
			  if (row.traceCodes && Array.isArray(row.traceCodes) && row.traceCodes.length > 0) {
			    this.traceCodeList = row.traceCodes.map((code, index) => ({
			      id: index + 1,
			      traceCode: code.code || '',
			      drugName: code.drugName || row.drugName || '',
			      spec: code.spec || row.spec || '',
			      availableQty: code.availableQty || 1,
			      manufacturer: code.manufacturer || row.manufacturer || '',
			      remark: code.remark || '',
			      status: code.status || 'active',
			      // 新增字段
			      batchNo: code.batchNo || '',
			      approvalLicenceNo: code.approvalLicenceNo || '',
			      produceDate: code.produceDate || '',
			      expireDate: code.expireDate || '',
			      originalProduceDate: code.originalProduceDate || '',
			      pkgAmount: code.pkgAmount || '',
			      physicTypeDesc: code.physicTypeDesc || '',
			      prepnTypeDesc: code.prepnTypeDesc || '',
			      codeStatus: code.codeStatus || '',
			      packageLevel: code.packageLevel || ''
			    }));
			    
			    // 计算总数量
			    this.calculateTotalTraceQty();
			    console.log(`从药品行加载${this.traceCodeList.length}条追溯码数据`);
			  }
			  
			  // 不自动添加空记录，由扫码录入添加
			},
			
			// 获取最大可用数量（不能大于药品明细中的包装数量）
			getMaxAvailableQty(row) {
			  if (!this.currentTraceMedicine) {
			    return 1;
			  }
			  // 返回药品明细中的包装数量
			  return parseInt(this.currentTraceMedicine.pacCnt) || 1;
			},
			
			// 是否可以编辑可用数量
			canEditAvailableQty(row) {
			  if (!this.currentTraceMedicine) return false;
			  
			  // 库存类型为最小单位时可以编辑
			  if (this.currentTraceMedicine.purcType === 1) {
			    return true;
			  }
			  
			  // 库存类型为包装单位时不可编辑
			  return false;
			},
			
			// 处理可用数量变化
			handleAvailableQtyChange(row, index) {
			  console.log('可用数量变化:', row.availableQty, '索引:', index);
			  
			  if (!this.currentTraceMedicine) return;
			  
			  const packageCount = parseInt(this.currentTraceMedicine.pacCnt) || 1;
			  const availableQty = parseInt(row.availableQty) || 1;
			  
			  // 确保可用数量不小于1
			  if (availableQty < 1) {
			    row.availableQty = 1;
			  }
			  
			  // 如果库存类型为最小单位，检查是否超过包装数量
			  if (this.currentTraceMedicine.purcType === 1 && availableQty > packageCount) {
			    console.log('可用数量超过包装数量，触发自动拆分');
			    this.handleAutoSplitTraceCode(row, index, availableQty, packageCount);
			  }
			},
			
			// 处理可用数量失去焦点
			handleAvailableQtyBlur(row, index) {
			  console.log('可用数量失去焦点:', row.availableQty, '索引:', index);
			  
			  if (!this.currentTraceMedicine) return;
			  
			  const packageCount = parseInt(this.currentTraceMedicine.pacCnt) || 1;
			  const availableQty = parseInt(row.availableQty) || 1;
			  
			  // 确保可用数量不小于1
			  if (availableQty < 1) {
			    row.availableQty = 1;
			  }
			},
			
			// 自动拆分追溯码
			handleAutoSplitTraceCode(row, index, availableQty, packageCount) {
			  console.log('开始自动拆分追溯码:', {
			    可用数量: availableQty,
			    包装数量: packageCount,
			    当前索引: index
			  });
			  
			  // 计算需要拆分的行数
			  const rowsNeeded = Math.ceil(availableQty / packageCount);
			  console.log('需要拆分为行数:', rowsNeeded);
			  
			  if (rowsNeeded <= 1) {
			    // 不需要拆分
			    row.availableQty = availableQty;
			    return;
			  }
			  
			  // 第一行使用包装数量
			  row.availableQty = packageCount;
			  
			  // 创建剩余的行
			  for (let i = 1; i < rowsNeeded; i++) {
			    const remainingQty = Math.min(packageCount, availableQty - (i * packageCount));
			    
			    if (remainingQty > 0) {
			      // 创建新行
			      const newRow = {
			        id: Date.now() + Math.random(),
			        traceCode: '',
			        drugName: row.drugName,
			        spec: row.spec,
			        availableQty: remainingQty,
			        manufacturer: row.manufacturer,
			        batchNo: row.batchNo,
			        produceDate: row.produceDate,
			        expireDate: row.expireDate,
			        isFirstRow: false,
			        isEditing: true
			      };
			      
			      // 在当前行之后插入
			      this.traceCodeSupplementList.splice(index + i, 0, newRow);
			      
			      console.log('添加拆分行:', {
			        索引: index + i,
			        可用数量: remainingQty
			      });
			    }
			  }
			  
			  this.$message.info(`已自动拆分为 ${rowsNeeded} 行追溯码`);
			},
			
			// 处理追溯码失去焦点
			handleTraceCodeBlur(row, index) {
			  if (!row.traceCode || row.traceCode.trim() === '') {
			    return;
			  }
			  
			  // 验证追溯码不能重复
			  const duplicateIndex = this.traceCodeSupplementList.findIndex((item, idx) => 
			    idx !== index && item.traceCode.trim() === row.traceCode.trim()
			  );
			  
			  if (duplicateIndex !== -1) {
			    this.$message.warning('追溯码不能重复');
			    row.traceCode = '';
			  }
			},
			
			// 计算总追溯码数量
			calculateTotalTraceQty() {
			  let total = 0;
			  this.traceCodeList.forEach(item => {
			    total += parseInt(item.availableQty) || 0;
			  });
			  this.totalTraceQty = total;
			  return total;
			},
			
			// 获取码状态标签类型
			getCodeStatusType(codeStatus) {
			  if (!codeStatus) return 'info';
			  
			  const statusMap = {
			    '正常': 'success',
			    '激活': 'success',
			    '已使用': 'info',
			    '已过期': 'danger',
			    '禁用': 'warning',
			    '停用': 'warning',
			    '注销': 'danger'
			  };
			  
			  return statusMap[codeStatus] || 'info';
			},
			
			// 处理扫码输入
			async handleScanInput() {
			  if (!this.scanInput || this.scanInput.trim() === '') {
			    this.$message.warning('请输入追溯码');
			    return;
			  }
			  
			  const traceCode = this.scanInput.trim();
			  
			  // 检查追溯码是否已存在
			  const exists = this.traceCodeList.some(item => item.traceCode === traceCode);
			  if (exists) {
			    this.$message.warning('该追溯码已存在');
			    this.scanInput = '';
			    return;
			  }
			  
			  try {
			    this.traceCodeLoading = true;
			    
			    // 调用msfxCodeDetail接口获取追溯码详情
			    const response = await msfxCodeDetail({
			      codes: traceCode
			    });
			    
			    if (response && response.code === 200 && response.data && response.data.length > 0) {
			      const traceCodeData = response.data[0];
			      console.log('追溯码详情接口返回:', traceCodeData);
			      
			      // 提取接口返回的数据
			      const drugInfo = traceCodeData.drugEntBaseDTO || {};
			      const produceInfo = traceCodeData.codeProduceInfoDTO?.produceInfoList?.[0] || {};
			      const entInfo = traceCodeData.pUserEntDTO || {};
			      const codeStatus = traceCodeData.codeStatusTypeDTO || {};
			      
			      // 获取当前药品的入库数量
			      const inboundQty = this.currentTraceMedicine ? parseInt(this.currentTraceMedicine.inboundQty) : 0;
			      
			      // 计算当前总数量
			      const currentTotal = this.calculateTotalTraceQty();
			      
			      // 检查是否超过入库数量
			      if (currentTotal >= inboundQty) {
			        this.$message.warning(`追溯码总数量（${currentTotal}）已达到入库数量（${inboundQty}），无法添加更多`);
			        this.scanInput = '';
			        return;
			      }
			      
			      // 计算可用数量
			      const pacCnt = parseInt(produceInfo.pkgAmount) || 1;
			      const remainingQty = inboundQty - currentTotal;
			      const defaultQty = Math.min(pacCnt, remainingQty);
			      
			      // 构建备注信息
			      let remark = '';
			      if (produceInfo.produceDateStr) {
			        remark += `生产日期: ${produceInfo.produceDateStr}`;
			      }
			      if (produceInfo.originalExpireDate) {
			        remark += (remark ? ', ' : '') + `有效期: ${produceInfo.originalExpireDate}`;
			      }
			      if (drugInfo.approvalLicenceNo) {
			        remark += (remark ? ', ' : '') + `批准文号: ${drugInfo.approvalLicenceNo}`;
			      }
			      if (codeStatus.codeStatus) {
			        remark += (remark ? ', ' : '') + `码状态: ${codeStatus.codeStatus}`;
			      }
			      
			      // 添加追溯码到表格
			      this.traceCodeList.push({
			        id: this.traceCodeList.length + 1,
			        traceCode: traceCode,
			        drugName: drugInfo.physicName || this.currentTraceMedicine?.drugName || '',
			        spec: drugInfo.prepnSpec || drugInfo.pkgSpecCrit || this.currentTraceMedicine?.spec || '',
			        availableQty: defaultQty,
			        manufacturer: entInfo.entName || this.currentTraceMedicine?.manufacturer || '',
			        remark: remark,
			        status: 'active',
			        // 新增字段
			        batchNo: produceInfo.batchNo || '',
			        approvalLicenceNo: drugInfo.approvalLicenceNo || '',
			        produceDate: produceInfo.produceDateStr || '',
			        expireDate: produceInfo.originalExpireDate || '',
			        originalProduceDate: produceInfo.originalProduceDate || '',
			        pkgAmount: produceInfo.pkgAmount || '',
			        physicTypeDesc: drugInfo.physicTypeDesc || '',
			        prepnTypeDesc: drugInfo.prepnTypeDesc || '',
			        codeStatus: codeStatus.codeStatus || '',
			        packageLevel: traceCodeData.packageLevel || ''
			      });
			      
			      this.$message.success(`追溯码添加成功，数量：${defaultQty}`);
			      this.scanInput = '';
			      
			      // 重新计算总数量
			      this.calculateTotalTraceQty();
			      
			      // 检查是否达到入库数量
			      const newTotal = this.totalTraceQty;
			      if (newTotal >= inboundQty) {
			        this.$message.success(`追溯码总数量（${newTotal}）已达到入库数量（${inboundQty}）`);
			      }
			    } else {
			      this.$message.error(response.message);
			    }
			  } catch (error) {
			    console.error('获取追溯码详情失败:', error);
			    this.$message.error(response.message);
			  } finally {
			    this.traceCodeLoading = false;
			  }
			},
			
			// 打开追溯码补录模态框
			openTraceCodeSupplement(row) {
			  console.log('打开追溯码补录，当前行:', row);
			  console.log('包装数量:', row.pacCnt, '入库数量:', row.inboundQty, '库存类型:', row.purcType);
			  console.log('已存在的追溯码:', row.traceCodes);
			  console.log('药品行详细信息（完整对象）:', row);
			  
			  // 详细打印药品行的字段
			  console.log('药品行字段检查:', {
			    药品名称: row.drugName,
			    规格: row.spec,
			    包装规格: row.packageSpec,
			    生产日期: row.manuDate,
			    有效日期: row.expyDate,
			    生产厂家: row.manufacturer,
			    生产批号: row.manuLotnum
			  });
			  
			  // 设置当前药品
			  this.currentTraceMedicine = row;
			  
			  // 初始化追溯码补录列表
			  this.traceCodeSupplementList = [];
			  
			  // 获取包装数量
			  const packageCount = parseInt(row.pacCnt) || 1;
			  const inboundQty = parseInt(row.inboundQty) || 1;
			  const purcType = parseInt(row.purcType) || 2;
			  
			  // 关键修复：直接从当前药品行中获取字段值
			  const drugName = row.drugName || '';
			  const drugSpec = row.spec || ''; // 规格
			  const packageSpec = row.packageSpec || ''; // 包装规格
			  const produceDate = row.manuDate || ''; // 生产日期
			  const expireDate = row.expyDate || ''; // 有效日期
			  const manufacturer = row.manufacturer || ''; // 生产厂家
			  const batchNo = row.manuLotnum || ''; // 生产批号
			  
			  console.log('从药品行提取的字段值:', {
			    药品名称: drugName,
			    规格: drugSpec,
			    包装规格: packageSpec,
			    生产日期: produceDate,
			    有效日期: expireDate,
			    生产厂家: manufacturer,
			    生产批号: batchNo
			  });
			  
			  // 如果有已存在的追溯码，加载到表格中
			  if (row.traceCodes && row.traceCodes.length > 0) {
			    console.log('加载已存在的追溯码到补录表格，数量:', row.traceCodes.length);
			    
			    row.traceCodes.forEach((trace, index) => {
			      const traceRow = {
			        id: Date.now() + index,
			        traceCode: trace.traceCode || '',
			        drugName: trace.drugName || drugName,
			        spec: trace.spec || drugSpec, // 优先使用追溯码中的规格
			        packageSpec: packageSpec, // 使用药品行的包装规格
			        availableQty: trace.availableQty || packageCount,
			        manufacturer: trace.manufacturer || manufacturer, // 优先使用追溯码中的厂家
			        batchNo: trace.batchNo || batchNo, // 优先使用追溯码中的批号
			        produceDate: produceDate, // 使用药品行的生产日期
			        expireDate: expireDate, // 使用药品行的有效日期
			        isEditing: false // 已存在的追溯码不可编辑
			      };
			      
			      console.log(`添加追溯码行${index + 1}:`, {
			        追溯码: traceRow.traceCode,
			        规格: traceRow.spec,
			        包装规格: traceRow.packageSpec,
			        生产日期: traceRow.produceDate,
			        有效日期: traceRow.expireDate
			      });
			      
			      this.traceCodeSupplementList.push(traceRow);
			    });
			  } else {
			    // 如果没有已存在的追溯码，添加一个空行
			    console.log('没有已存在的追溯码，添加空行');
			    
			    // 关键修复：确保首行正确设置所有字段值
			    const newRow = {
			      id: Date.now(),
			      traceCode: '',
			      drugName: drugName,
			      spec: drugSpec, // 使用药品行的规格
			      packageSpec: packageSpec, // 使用药品行的包装规格
			      availableQty: packageCount, // 默认可用数量为包装数量
			      manufacturer: manufacturer, // 使用药品行的生产厂家
			      batchNo: batchNo, // 使用药品行的生产批号
			      produceDate: produceDate, // 使用药品行的生产日期
			      expireDate: expireDate, // 使用药品行的有效日期
			      isEditing: true // 空行可以直接编辑
			    };
			    
			    console.log('创建的默认首行数据:', {
			      追溯码: newRow.traceCode,
			      规格: newRow.spec,
			      包装规格: newRow.packageSpec,
			      生产日期: newRow.produceDate,
			      有效日期: newRow.expireDate,
			      生产厂家: newRow.manufacturer,
			      生产批号: newRow.batchNo
			    });
			    
			    this.traceCodeSupplementList.push(newRow);
			  }
			  
			  console.log('追溯码补录列表初始化完成，行数:', this.traceCodeSupplementList.length);
			  console.log('首行数据详情:', this.traceCodeSupplementList[0]);
			  this.traceCodeSupplementDialogVisible = true;
			},
			
			// 处理关闭进度模态框
			handleCloseProgressDialog() {
			  this.passProgressDialogVisible = false;
			  // 单据已过单成功，需要刷新外层表格数据
			  this.$emit('success'); // 触发父组件的刷新
			  this.handleClose();
			},
			
			// 处理进度模态框关闭前的确认
			handleProgressDialogClose(done) {
			  if (this.showCloseButton) {
			    // 如果显示关闭按钮，说明是失败状态，允许直接关闭
			    // 但在关闭前触发刷新事件
			    this.$emit('success'); // 触发父组件刷新表格
			    done();
			  } else if (this.passLoading) {
			    this.$confirm('上传正在进行中，确定要关闭吗？', '提示', {
			      type: 'warning'
			    }).then(() => {
			      this.$emit('success'); // 触发父组件刷新表格
			      done();
			    }).catch(() => {});
			  } else {
			    this.$emit('success'); // 触发父组件刷新表格
			    done();
			  }
			},
			
			// 验证追溯码
			validateTraceCode(row) {
			  if (row.traceCode && row.traceCode.trim()) {
			    // 这里可以添加追溯码格式验证逻辑
			    if (row.traceCode.length < 6) {
			      this.$message.warning('追溯码长度至少6位');
			    }
			  }
			},
			
			// 是否可以确认追溯码录入
			canConfirmTraceCode() {
			  console.log('检查是否可以确认追溯码录入');
			  
			  // 验证必填项
			  if (!this.validateTraceCodeInputForm()) {
			    console.log('验证必填项失败');
			    return false;
			  }
			  
			  // 验证药品是否存在于系统中
			  if (!this.drugExistsInSystem) {
			    console.log('药品不存在于系统中');
			    return false;
			  }
			  
			  // 验证追溯码次数是否超出包装数量
			  if (!this.validateTraceCodeCount()) {
			    console.log('追溯码验证失败');
			    return false;
			  }
			  
			  // 验证入库数量：最小单位时不能超过包装数量
			  if (this.traceCodeInputForm.purcType === 1 && 
			      this.traceCodeInputForm.inboundQty > this.traceCodeInputForm.pacCnt) {
			    console.log('最小单位时入库数量超过包装数量');
			    return false;
			  }
			  
			  console.log('所有验证通过，可以确认');
			  return true;
			},
			
			// 处理关闭追溯码录入模态框
			handleCloseTraceCodeInput() {
			  console.log('关闭追溯码录入模态框');
			  
			  // 重置追溯码录入表单
			  this.resetTraceCodeInputForm();
			  
			  // 重置扫码枪输入框
			  this.outerScanInput = '';
			  
			  // 重置getCJSomeWare空数据标志
			  this.isCJSomeWareEmpty = false;
			  
			  // 关闭模态框
			  this.traceCodeInputDialogVisible = false;
			  
			  console.log('已重置所有表单和输入框数据');
			},
			
			// 取消追溯码录入
			handleCancelTraceCodeInput() {
			  console.log('取消追溯码录入');
			  this.handleCloseTraceCodeInput();
			},
			
			// 取消追溯码补录
			handleCancelTraceCodeSupplement() {
			  console.log('取消追溯码补录');
			  this.traceCodeSupplementDialogVisible = false;
			  this.traceCodeSupplementList = [];
			},
			
			// 验证追溯码数量
			validateTraceCodeCount() {
			  console.log('验证追溯码数量');
			
			  if (!this.traceCodeInputList || this.traceCodeInputList.length === 0) {
			    console.log('没有追溯码，验证通过');
			    return true;
			  }
			
			  // 统计每个追溯码的出现次数
			  const traceCodeCounts = {};
			
			  this.traceCodeInputList.forEach(item => {
			    if (item.traceCode) {
			      const code = item.traceCode.trim();
			      if (code) {
			        traceCodeCounts[code] = (traceCodeCounts[code] || 0) + 1;
			      }
			    }
			  });
			
			  // 检查是否有追溯码出现次数超过包装数量
			  for (const [traceCode, count] of Object.entries(traceCodeCounts)) {
			    if (count > this.traceCodeInputForm.pacCnt) {
			      console.log(`追溯码 ${traceCode} 超过包装数量: ${count} > ${this.traceCodeInputForm.pacCnt}`);
			      return false;
			    }
			  }
			
			  console.log('所有追溯码次数验证通过');
			  return true;
			},
			
			// 处理入库数量变化
			handleInboundQtyChange(row) {
			  console.log('入库数量变化:', row.inboundQty);
			  
			  // 验证入库数量
			  this.validateInboundQty(row);
			},
			
			// 验证入库数量
			validateInboundQty(row) {
			  if (row.purcType === 1 && row.inboundQty > row.pacCnt) {
			    this.$message.error(`最小单位时，入库数量不能超过包装数量 ${row.pacCnt}`);
			    row.inboundQty = row.pacCnt || 1;
			  }
			},
			
			// 更新入库数量提示
			updateInboundQtyTip(row) {
			  if (row.purcType === 1) {
			    row.inboundQtyTip = '库存类型为最小单位，入库数量不能超过包装数量';
			  } else {
			    row.inboundQtyTip = '库存类型为包装单位';
			  }
			},
			
			// 更新单位标签
			updateUnitLabel(row) {
			  if (row.purcType === 1) {
			    row.unitLabel = row.dosUnt || '最小单位';
			  } else if (row.purcType === 2) {
			    row.unitLabel = row.pacUnt || '包装单位';
			  } else {
			    row.unitLabel = '单位';
			  }
			  console.log('更新单位标签:', row.unitLabel, '库存类型:', row.purcType);
			},
			
			// 删除追溯码
			handleRemoveTraceCode(index) {
			  this.$confirm('确定删除这条追溯码吗？', '提示', {
			    confirmButtonText: '确定',
			    cancelButtonText: '取消',
			    type: 'warning'
			  }).then(() => {
			    this.traceCodeList.splice(index, 1);
			    this.$message.success('删除成功');
			    
			    // 重新计算总数量
			    this.calculateTotalTraceQty();
			  }).catch(() => {});
			},
			
			// 确认追溯码录入
			async handleConfirmTraceCode() {
			  // 验证追溯码数据
			  const invalidCodes = this.traceCodeList.filter(item => !item.traceCode || item.traceCode.trim() === '');
			  
			  if (invalidCodes.length > 0) {
			    this.$message.warning(`有${invalidCodes.length}条追溯码为空，请填写完整`);
			    return;
			  }
			  
			  const inboundQty = this.currentTraceMedicine ? parseInt(this.currentTraceMedicine.inboundQty) : 0;
			  
			  // 检查总数量是否等于入库数量
			  if (this.totalTraceQty !== inboundQty) {
			    this.$message.warning(`追溯码总数量（${this.totalTraceQty}）必须等于入库数量（${inboundQty}）`);
			    return;
			  }
			  
			  try {
			    this.traceCodeLoading = true;
			    
			    // 构建追溯码JSON字符串
			    const traceCodeJson = JSON.stringify({
			      drugId: this.currentTraceMedicine.drugId,
			      drugName: this.currentTraceMedicine.drugName,
			      traceCodes: this.traceCodeList.map(item => ({
			        code: item.traceCode,
			        availableQty: item.availableQty,
			        remark: item.remark,
			        status: item.status,
			        batchNo: item.batchNo,
			        approvalLicenceNo: item.approvalLicenceNo,
			        produceDate: item.produceDate,
			        expireDate: item.expireDate,
			        originalProduceDate: item.originalProduceDate,
			        pkgAmount: item.pkgAmount,
			        physicTypeDesc: item.physicTypeDesc,
			        prepnTypeDesc: item.prepnTypeDesc,
			        codeStatus: item.codeStatus,
			        packageLevel: item.packageLevel,
			        manufacturer: item.manufacturer,
			        drugName: item.drugName,
			        spec: item.spec
			      }))
			    });
			    
			    console.log('追溯码JSON字符串:', traceCodeJson);
			    
			    // 保存追溯码到当前药品行
			    if (this.currentTraceMedicine) {
			      // 将追溯码数据保存到药品行，包含所有字段
			      this.currentTraceMedicine.traceCodes = this.traceCodeList.map(item => ({
			        code: item.traceCode,
			        availableQty: item.availableQty,
			        remark: item.remark,
			        status: item.status,
			        // 保存接口返回的详细信息
			        batchNo: item.batchNo,
			        approvalLicenceNo: item.approvalLicenceNo,
			        produceDate: item.produceDate,
			        expireDate: item.expireDate,
			        originalProduceDate: item.originalProduceDate,
			        pkgAmount: item.pkgAmount,
			        physicTypeDesc: item.physicTypeDesc,
			        prepnTypeDesc: item.prepnTypeDesc,
			        codeStatus: item.codeStatus,
			        packageLevel: item.packageLevel,
			        manufacturer: item.manufacturer,
			        drugName: item.drugName,
			        spec: item.spec
			      }));
			      
			      // 保存追溯码JSON字符串到当前药品行，用于接口参数
			      this.currentTraceMedicine.tracCodeJson = traceCodeJson;
			      
			      this.$message.success(`已保存${this.traceCodeList.length}条追溯码，总数量：${this.totalTraceQty}`);
			    }
			    
			    // 关闭模态框
			    this.traceCodeDialogVisible = false;
			    this.resetTraceCodeDialog();
			    
			  } catch (error) {
			    console.error('保存追溯码失败:', error);
			    this.$message.error('保存追溯码失败');
			  } finally {
			    this.traceCodeLoading = false;
			  }
			},
			
			// 关闭追溯码模态框
			handleTraceCodeDialogClose(done) {
			  if (this.traceCodeList.length > 0) {
			    this.$confirm('确定关闭追溯码录入吗？未保存的数据将丢失', '提示', {
			      confirmButtonText: '确定',
			      cancelButtonText: '取消',
			      type: 'warning'
			    }).then(() => {
			      this.resetTraceCodeDialog();
			      done();
			    }).catch(() => {});
			  } else {
			    this.resetTraceCodeDialog();
			    done();
			  }
			},
			
			// 添加新的追溯码
			handleAddSupplementTraceCode() {
			  if (!this.currentTraceMedicine) {
			    this.$message.warning('未找到当前药品信息！');
			    return;
			  }
			  
			  const packageCount = parseInt(this.currentTraceMedicine.pacCnt) || 1;
			  
			  // 从当前药品行获取字段值
			  const drugName = this.currentTraceMedicine.drugName || '';
			  const drugSpec = this.currentTraceMedicine.spec || '';
			  const manufacturer = this.currentTraceMedicine.manufacturer || '';
			  const batchNo = this.currentTraceMedicine.manuLotnum || '';
			  const produceDate = this.currentTraceMedicine.manuDate || '';
			  const expireDate = this.currentTraceMedicine.expyDate || '';
			  
			  console.log('添加新行时使用的字段值:', {
			    规格: drugSpec,
			    生产日期: produceDate,
			    有效日期: expireDate
			  });
			  
			  // 创建一个空行
			  const newRow = {
			    id: Date.now() + Math.random(),
			    traceCode: '',
			    drugName: drugName,
			    spec: drugSpec, // 使用药品行的规格
			    availableQty: packageCount, // 默认可用数量为包装数量
			    manufacturer: manufacturer, // 使用药品行的生产厂家
			    batchNo: batchNo, // 使用药品行的生产批号
			    produceDate: produceDate, // 使用药品行的生产日期
			    expireDate: expireDate, // 使用药品行的有效日期
			    isEditing: true // 处于编辑状态
			  };
			  
			  // 添加到列表
			  this.traceCodeSupplementList.push(newRow);
			  console.log('已添加新的追溯码行，字段值:', {
			    traceCode: newRow.traceCode,
			    spec: newRow.spec,
			    produceDate: newRow.produceDate,
			    expireDate: newRow.expireDate
			  });
			  this.$message.success('已添加新的追溯码行，请填写追溯码');
			},
			
			// 编辑追溯码行
			handleEditSupplementRow(index) {
			  this.traceCodeSupplementList[index].isEditing = true;
			},
			
			// 取消编辑
			handleCancelSupplementEdit(index) {
			  if (this.traceCodeSupplementList[index].isFirstRow) {
			    // 首行取消编辑，不做任何操作
			    return;
			  }
			  
			  // 如果是新增行且追溯码为空，直接删除
			  if (!this.traceCodeSupplementList[index].traceCode || 
			      this.traceCodeSupplementList[index].traceCode.trim() === '') {
			    this.traceCodeSupplementList.splice(index, 1);
			  } else {
			    // 有内容，只是退出编辑状态
			    this.traceCodeSupplementList[index].isEditing = false;
			  }
			},
			
			// 保存追溯码行
			handleSaveSupplementRow(index) {
			  const row = this.traceCodeSupplementList[index];
			  
			  // 验证追溯码
			  if (!row.traceCode || row.traceCode.trim() === '') {
			    this.$message.warning('请输入追溯码');
			    return;
			  }
			  
			  // 验证追溯码不能包含中文
			  const chineseRegex = /[\u4e00-\u9fa5]/;
			  if (chineseRegex.test(row.traceCode)) {
			    this.$message.warning('追溯码不能包含中文');
			    return;
			  }
			  
			  // 验证追溯码不能重复
			  const traceCodes = this.traceCodeSupplementList.map(item => item.traceCode.trim());
			  const duplicateIndex = traceCodes.findIndex((code, idx) => 
			    idx !== index && code === row.traceCode.trim() && code !== ''
			  );
			  
			  if (duplicateIndex !== -1) {
			    this.$message.warning('追溯码不能重复');
			    return;
			  }
			  
			  // 保存成功，退出编辑状态
			  row.isEditing = false;
			  this.$message.success('保存成功');
			},
			
			// 移除追溯码行
			handleRemoveSupplementRow(index) {
			  if (this.traceCodeSupplementList[index].isFirstRow && this.traceCodeSupplementList.length === 1) {
			    // 如果只有首行，直接关闭模态框
			    this.traceCodeSupplementDialogVisible = false;
			  } else {
			    this.traceCodeSupplementList.splice(index, 1);
			  }
			},
			
			// 确认追溯码补录
			handleConfirmTraceCodeSupplement() {
			  // 验证至少有一个追溯码
			  if (this.traceCodeSupplementList.length === 0) {
			    this.$message.warning('请至少录入一个追溯码');
			    return;
			  }
			  
			  // 验证所有追溯码都已填写
			  const emptyTraceCode = this.traceCodeSupplementList.find(row => 
			    !row.traceCode || row.traceCode.trim() === ''
			  );
			  
			  if (emptyTraceCode) {
			    this.$message.warning('请填写所有追溯码');
			    return;
			  }
			  
			  // 验证追溯码不能重复
			  const traceCodes = this.traceCodeSupplementList.map(row => row.traceCode.trim());
			  const duplicateSet = new Set();
			  const duplicates = [];
			  
			  traceCodes.forEach((code, index) => {
			    if (duplicateSet.has(code) && code !== '') {
			      duplicates.push(code);
			    } else {
			      duplicateSet.add(code);
			    }
			  });
			  
			  if (duplicates.length > 0) {
			    this.$message.warning(`追溯码不能重复: ${duplicates.join(', ')}`);
			    return;
			  }
			  
			  // 验证可用数量
			  if (this.currentTraceMedicine) {
			    const purcType = parseInt(this.currentTraceMedicine.purcType) || 2;
			    const packageCount = parseInt(this.currentTraceMedicine.pacCnt) || 1;
			    
			    this.traceCodeSupplementList.forEach(row => {
			      const availableQty = parseInt(row.availableQty) || 1;
			      
			      if (availableQty < 1) {
			        row.availableQty = 1;
			      }
			      
			      // 库存类型为包装单位时，确保可用数量等于包装数量
			      if (purcType === 2 && availableQty !== packageCount) {
			        console.log(`修正可用数量: ${availableQty} -> ${packageCount}`);
			        row.availableQty = packageCount;
			      }
			    });
			  }
			  
			  // 更新当前药品的追溯码信息
			  if (this.currentTraceMedicine) {
			    // 获取药品基本信息
			    const purcType = parseInt(this.currentTraceMedicine.purcType) || 2;
			    const packageCount = parseInt(this.currentTraceMedicine.pacCnt) || 1;
			    
			    console.log('当前药品信息:', {
			      库存类型: purcType === 1 ? '最小单位' : '包装单位',
			      包装数量: packageCount
			    });
			    
			    // 构建追溯码列表
			    const traceCodes = this.traceCodeSupplementList.map(row => {
			      const availableQty = parseInt(row.availableQty) || 1;
			      
			      return {
			        traceCode: row.traceCode,
			        drugName: row.drugName,
			        spec: row.spec,
			        packageSpec: row.packageSpec,
			        manufacturer: row.manufacturer,
			        batchNo: row.batchNo,
			        produceDate: row.produceDate,
			        expireDate: row.expireDate,
			        availableQty: availableQty
			      };
			    });
			    
			    console.log('构建的追溯码列表:', traceCodes);
			    
			    // 构建追溯码JSON，增加 manuLotnum 字段（生产批号）
			    const tracCodeJson = traceCodes.map(item => {
			      // 关键修改：根据库存类型确定chgCnt
			      let chgCnt = item.availableQty;
			      
			      // 如果库存类型为包装单位，chgCnt就是包装数量
			      if (purcType === 2) {
			        chgCnt = packageCount;
			      } 
			      
			      console.log(`构建追溯码JSON:`, {
			        追溯码: item.traceCode,
			        库存类型: purcType === 1 ? '最小单位' : '包装单位',
			        可用数量: item.availableQty,
			        包装数量: packageCount,
			        chgCnt: chgCnt,
			        生产批号: item.batchNo   // 新增日志
			      });
			      
			      return {
			        barcode: item.traceCode,
			        chgCnt: chgCnt,
			        manuLotnum: item.batchNo || ''   // 新增字段：生产批号，取值来自追溯码行的 batchNo
			      };
			    });
			    
			    console.log('构建的追溯码JSON:', tracCodeJson);
			    
			    // 将追溯码数组转换为JSON字符串
			    const tracCodeJsonString = JSON.stringify(tracCodeJson);
			    
			    // 更新当前药品行
			    this.currentTraceMedicine.traceCodes = traceCodes;
			    this.currentTraceMedicine.tracCodeJson = tracCodeJsonString;
			    
			    // 更新追溯码按钮文字
			    this.currentTraceMedicine.traceCodeButtonText = `追溯码(${traceCodes.length})`;
			    
			    console.log('更新后的药品行追溯码信息:', {
			      traceCodes: this.currentTraceMedicine.traceCodes,
			      tracCodeJson: this.currentTraceMedicine.tracCodeJson,
			      traceCodeButtonText: this.currentTraceMedicine.traceCodeButtonText
			    });
			    
			    this.$message.success('追溯码补录成功');
			    this.traceCodeSupplementDialogVisible = false;
			    this.traceCodeSupplementList = [];
			  }
			},
			
			// 解析追溯码数组
			parseTraceCodeArray(tracCodeJson, row) {
			  try {
			    console.log('解析追溯码数组:', tracCodeJson);
			    
			    if (!tracCodeJson || tracCodeJson === null) {
			      return [];
			    }
			    
			    // 如果是数组
			    if (Array.isArray(tracCodeJson)) {
			      // 从数组中提取追溯码
			      return tracCodeJson.map(item => {
			        return {
			          traceCode: item.barcode || item.traceCode || '',
			          availableQty: 1,
			          chgCnt: item.chgCnt || row.pacCnt || 1
			        };
			      });
			    }
			    
			    return [];
			  } catch (error) {
			    console.error('解析追溯码数组失败:', error);
			    return [];
			  }
			},
			
			// 重置追溯码对话框
			resetTraceCodeDialog() {
			  this.traceCodeDialogVisible = false;
			  this.currentTraceMedicine = null;
			  this.currentTraceIndex = -1;
			  this.traceCodeList = [];
			  this.totalTraceQty = 0;
			  this.scanInput = '';
			},
			
			// 取消追溯码录入
			handleCancelTraceCode() {
			  this.traceCodeDialogVisible = false;
			  this.resetTraceCodeDialog();
			},
			
			// 添加追溯码条目
			addTraceCodeItem() {
			  this.traceCodeList.push({
			    id: this.traceCodeList.length + 1,
			    traceCode: '',
			    drugName: this.currentTraceMedicine ? this.currentTraceMedicine.drugName : '',
			    spec: this.currentTraceMedicine ? this.currentTraceMedicine.spec : '',
			    pacCnt: this.currentTraceMedicine ? this.currentTraceMedicine.pacCnt || 1 : 1,
			    manufacturer: this.currentTraceMedicine ? this.currentTraceMedicine.manufacturer : '',
			    remark: '',
			    status: 'active'
			  });
			},
			
			// 处理追溯码设置
			handleTraceCodeSetting(row, index) {
			  console.log('设置追溯码:', row, index);
			  this.$message.info('设置功能待实现');
			},
			
			// 打印追溯码
			handlePrintTraceCode() {
			  console.log('打印追溯码');
			  this.$message.info('打印功能待实现');
			},
			
			// 批量生成追溯码
			handleBatchGenerate() {
			  console.log('批量生成追溯码');
			  this.$confirm('确定批量生成追溯码吗？', '提示', {
			    confirmButtonText: '确定',
			    cancelButtonText: '取消',
			    type: 'info'
			  }).then(() => {
			    // 生成5个示例追溯码
			    for (let i = 0; i < 5; i++) {
			      this.addTraceCodeItem();
			      const lastIndex = this.traceCodeList.length - 1;
			      this.traceCodeList[lastIndex].traceCode = `TRACE-${Date.now()}-${i + 1}`;
			      this.traceCodeList[lastIndex].pacCnt = 1;
			    }
			    this.$message.success('已生成5个追溯码');
			  }).catch(() => {});
			},
			
			// 处理添加药品目录成功
			handleAddDrugSuccess(addedDrugData) {
			  // addedDrugData 包含：drugId, drugName, spec, pacCnt, approvalLicenceNo,
			  // manufacturerId, manufacturerName, dosageFormName（剂型中文）
			  this.$message.success('药品目录添加成功');
			  
			  // 更新追溯码录入表单
			  this.traceCodeInputForm.drugName = addedDrugData.drugName || this.traceCodeInputForm.drugName;
			  this.traceCodeInputForm.spec = addedDrugData.spec || this.traceCodeInputForm.spec;
			  this.traceCodeInputForm.pacCnt = addedDrugData.pacCnt || this.traceCodeInputForm.pacCnt;
			  this.traceCodeInputForm.approvalLicenceNo = addedDrugData.approvalLicenceNo || this.traceCodeInputForm.approvalLicenceNo;
			  this.traceCodeInputForm.manufacturer = addedDrugData.manufacturerName || '';
			  this.traceCodeInputForm.manufacturerId = addedDrugData.manufacturerId || '';
			  
			  // 更新剂型显示（prepnTypeDesc）
			  if (addedDrugData.dosageFormName) {
			    if (this.traceCodeDetailData && this.traceCodeDetailData.drugEntBaseDTO) {
			      this.traceCodeDetailData.drugEntBaseDTO.prepnTypeDesc = addedDrugData.dosageFormName;
			    }
			    // 同时更新 form 中的显示
			    this.traceCodeInputForm.dosageFormName = addedDrugData.dosageFormName;
			  }
			  
			  // 重新调用 getSomeWare 验证药品是否已存在于系统（现在应该存在）
			  if (this.traceCodeInputForm.drugName && this.traceCodeInputForm.pacCnt) {
			    this.callGetSomeWare(this.traceCodeInputForm.drugName, this.traceCodeInputForm.pacCnt);
			  }
			  
			  // 关闭添加药品目录模态框
			  this.addDrugDialogVisible = false;
			  // 重置底部按钮
			  this.showBottomAddButton = false;
			  // 更新右上角按钮状态
			  this.showAddDrugButton = true;
			  this.addDrugButtonText = '已添加';
			  this.addDrugButtonDisabled = true;
			},
			
			// 清空追溯码
			handleClearTraceCode() {
			  this.$confirm('确定清空所有追溯码吗？', '提示', {
			    confirmButtonText: '确定',
			    cancelButtonText: '取消',
			    type: 'warning'
			  }).then(() => {
			    this.traceCodeList = [];
			    this.$message.success('已清空所有追溯码');
			  }).catch(() => {});
			},
			
			// 导入追溯码
			handleImportTraceCode() {
			  console.log('导入追溯码');
			  this.$message.info('导入功能待实现');
			},
			
			// 导出追溯码
			handleExportTraceCode() {
			  console.log('导出追溯码');
			  this.$message.info('导出功能待实现');
			},
			
			// 编辑药品
			handleEditMedicine(index, row) {
				console.log('编辑药品:', index, row);
				this.$message.info('编辑药品功能待实现');
			},
 
			// 移除药品
			handleRemoveMedicine(index, row) {
				// 如果是修改模式的新增行，且没有选择药品，直接移除
				if (this.isEditMode && row.isNewRow && !row.drugId) {
					this.medicineList.splice(index, 1);
					this.$message.success('已移除');
					return;
				}
 
				// 其他情况需要确认
				const confirmMessage = row.drugName ?
					`您目前已选择了（${row.drugName}），请确认是否继续移除？` :
					'确定移除该药品吗?';
 
				this.$confirm(confirmMessage, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.medicineList.splice(index, 1);
					this.$message.success('移除成功');
				}).catch(() => {});
			},
 
			// 计算单行金额
			calculateRowAmount(row) {
			  const inboundQty = parseFloat(row.inboundQty) || 0;
			  const costPric = parseFloat(row.costPric) || 0;
			  const salePric = parseFloat(row.salePric) || 0;
			
			  row.totalCost = inboundQty * costPric;
			  row.totalRetail = inboundQty * salePric;
			},
 
			// 计算汇总信息
			calculateSummary() {
				this.totalInboundQty = this.medicineList.reduce((sum, item) => {
					return sum + (parseFloat(item.inboundQty) || 0);
				}, 0);
 
				this.totalCost = this.medicineList.reduce((sum, item) => {
					return sum + (parseFloat(item.totalCost) || 0);
				}, 0);
 
				this.totalRetail = this.medicineList.reduce((sum, item) => {
					return sum + (parseFloat(item.totalRetail) || 0);
				}, 0);
			},
 
			// 验证必填字段
			validateRequired(row, field) {
				if (!row[field]) {
					this.$message.warning(`请填写${this.getFieldLabel(field)}`);
				}
			},
 
			getFieldLabel(field) {
				const fieldLabels = {
					manuLotnum: '生产批号',
					manuDate: '生产日期',
					expyDate: '有效日期',
					prodentpNameId: '生产厂家'
				};
				return fieldLabels[field] || field;
			},
 
			// 日期格式化
			formatDate(date) {
				if (!date) return '--';
				const d = new Date(date);
				return d.toLocaleDateString('zh-CN');
			},
 
			// 状态标签类型
			getStatusType(state) {
				switch (state) {
					case 0:
						return 'info';
					case 2:
						return 'warning';
					case 4:
						return 'success';
					case 5:
						return '';
					default:
						return 'info';
				}
			},
 
			// 状态文本
			getStatusText(state) {
				switch (state) {
					case 0:
						return '草稿';
					case 2:
						return '已提交';
					case 4:
						return '已审核';
					case 5:
						return '已过单';
					default:
						return '未知';
				}
			},
 
			// 确认创建入库单
			async handleCreate() {
			  try {
			    this.saving = true;
			    
			    // 验证表单
			    const valid = await this.$refs.inboundForm.validate();
			    if (!valid) {
			      this.saving = false;
			      return;
			    }
			    
			    // 验证药品明细
			    if (this.medicineList.length === 0) {
			      this.$message.warning('请至少添加一种药品');
			      this.saving = false;
			      return;
			    }
			    
			    // 验证每个药品明细
			    for (const medicine of this.medicineList) {
			      if (!this.validateMedicine(medicine)) {
			        this.saving = false;
			        return;
			      }
			    }
			    
			    // 计算成本合计金额和零售合计金额
			    let costAmt = 0;
			    let saleAmt = 0;
			    
			    // 构建药品明细列表
			    const list = this.medicineList.map(item => {
			      // 计算单条单据的成本金额
			      const purcAmt = (item.costPric || 0) * (item.inboundQty || 0);
			      // 计算单条单据的销售金额
			      const saleAmtItem = (item.salePric || 0) * (item.inboundQty || 0);
			      
			      // 累加到总金额
			      costAmt += purcAmt;
			      saleAmt += saleAmtItem;
			      
			      // 构建每个药品明细
			      const medicineItem = {
			        drugId: item.drugId || 0,
			        expyDate: item.expyDate || '',
			        manuDate: item.manuDate || '',
			        manuLotnum: item.manuLotnum || '',
			        planId: item.planId || this.formData.purchasePlanId || '',
			        prodentpName: item.manufacturer || '', // 生产厂家名称
			        prodentpNameId: item.prodentpNameId || 0, // 生产厂家id
			        purcAmt: purcAmt, // 单条单据的成本金额
			        purcCnt: item.inboundQty || 0, // 单条单据的采购数量
			        purcPric: item.costPric || 0, // 单条单据的成本单价
			        purcType: item.purcType || 0, // 库存类型 1最小单位2包装单位
			        saleAmt: saleAmtItem, // 单条单据的销售金额
			        salePric: item.salePric || 0, // 单条单据的销售单价
			        tracCodeJson: item.tracCodeJson || '' // 单条单据的追溯码JSON字符串
			      };
			      
			      return medicineItem;
			    });
			    
			    // 构建请求数据
			    const requestData = {
			      costAmt: costAmt, // 成本合计金额
			      invoDate: this.formData.businessDate || '', // 发票日期
			      list: list, // 药品明细列表
			      printCnt: 0, // 打印次数，新增默认为0
			      purcInvoCodg: this.formData.invoiceNo || '', // 发票号码
			      putinTypeId: this.formData.putinTypeId || '', // 入库方式
			      remarks: this.formData.remark || '', // 备注
			      saleAmt: saleAmt, // 零售总金额
			      shedId: this.formData.warehouseId || 3, // 库房序号西药f为3
			      state: 0, // 状态 新增默认为0
			      supplyCandidateId: this.formData.supplierId || 0, // 选择的供应商id
			      supplyCode: this.formData.supplierCode || '' // 供应商号码
			    };
			    
			    console.log('创建入库单请求数据:', requestData);
			    
			    // 调用创建入库单接口
			    const response = await addXYFDrugStorage(requestData);
			    
			    if (response.code === 200) {
			      this.$message.success('入库单创建成功');
			      this.$emit('success');
			      this.handleClose();
			    } else {
			      this.$message.error(response.message || '创建入库单失败');
			    }
			  } catch (error) {
			    console.error('创建入库单失败:', error);
			    this.$message.error('创建入库单失败: ' + (error.message || '请检查供货单位等必填项是否填写完毕。'));
			  } finally {
			    this.saving = false;
			  }
			},
			
			// 保存修改
			async handleSave() {
			  try {
			    this.saving = true;
			    
			    // 验证表单
			    const valid = await this.$refs.inboundForm.validate();
			    if (!valid) {
			      this.saving = false;
			      return;
			    }
			    
			    // 验证药品明细
			    if (this.medicineList.length === 0) {
			      this.$message.warning('请至少添加一种药品');
			      this.saving = false;
			      return;
			    }
			    
			    // 验证每个药品明细
			    for (const medicine of this.medicineList) {
			      if (!this.validateMedicine(medicine)) {
			        this.saving = false;
			        return;
			      }
			    }
			    
			    // 计算成本合计金额和零售合计金额
			    let costAmt = 0;
			    let saleAmt = 0;
			    
			    // 构建药品明细列表
			    const list = this.medicineList.map(item => {
			      // 计算单条单据的成本金额
			      const purcAmt = (item.costPric || 0) * (item.inboundQty || 0);
			      // 计算单条单据的销售金额
			      const saleAmtItem = (item.salePric || 0) * (item.inboundQty || 0);
			      
			      // 累加到总金额
			      costAmt += purcAmt;
			      saleAmt += saleAmtItem;
			      
			      // 构建每个药品明细
			      const medicineItem = {
			        id: item.id || 0, // 编辑模式下需要传递id
			        drugId: item.drugId || 0,
			        expyDate: item.expyDate || '',
			        manuDate: item.manuDate || '',
			        manuLotnum: item.manuLotnum || '',
			        planId: item.planId || this.formData.purchasePlanId || '',
			        prodentpName: item.manufacturer || '', // 生产厂家名称
			        prodentpNameId: item.prodentpNameId || 0, // 生产厂家id
			        purcAmt: purcAmt, // 单条单据的成本金额
			        purcCnt: item.inboundQty || 0, // 单条单据的采购数量
			        purcPric: item.costPric || 0, // 单条单据的成本单价
			        purcType: item.purcType || 0, // 库存类型
			        saleAmt: saleAmtItem, // 单条单据的销售金额
			        salePric: item.salePric || 0, // 单条单据的销售单价
			        tracCodeJson: item.tracCodeJson || '' // 追溯码JSON字符串
			      };
			      
			      return medicineItem;
			    });
			    
			    // 构建请求数据
			    const requestData = {
			      id: this.rowData.id, // 编辑模式下需要传递id
			      costAmt: costAmt, // 成本合计金额
			      invoDate: this.formData.businessDate || '', // 发票日期
			      list: list, // 药品明细列表
			      printCnt: 0, // 打印次数
			      purcInvoCodg: this.formData.invoiceNo || '', // 发票号码
			      putinTypeId: this.formData.putinTypeId || '', // 入库方式
			      remarks: this.formData.remark || '', // 备注
			      saleAmt: saleAmt, // 零售总金额
			      shedId: this.formData.warehouseId || 3, // 库房序号
			      state: 0, // 状态
			      supplyCandidateId: this.formData.supplierId || 0, // 供应商id
			      supplyCode: this.formData.supplierCode || '' // 供应商号码
			    };
			    
			    // 如果有采购计划id，也传递
			    if (this.formData.purchasePlanId) {
			      requestData.planId = this.formData.purchasePlanId;
			    }
			    
			    console.log('保存修改请求数据:', requestData);
			    
			    // 调用编辑接口
			    const response = await editXYFPurchase(requestData);
			    
			    if (response.code === 200) {
			      this.$message.success('修改保存成功');
			      this.$emit('success');
			      this.handleClose();
			    } else {
			      this.$message.error(response.message || '保存修改失败');
			    }
			  } catch (error) {
			    console.error('保存修改失败:', error);
			    this.$message.error('保存修改失败: ' + (error.message || '网络错误'));
			  } finally {
			    this.saving = false;
			  }
			},
 
			// 保存并提交
			async handleSaveAndSubmit() {
			    try {
			      this.saving = true;
			      
			      // 验证表单
			      const valid = await this.$refs.inboundForm.validate();
			      if (!valid) {
			        this.saving = false;
			        return;
			      }
			      
			      // 验证药品明细
			      if (this.medicineList.length === 0) {
			        this.$message.warning('请至少添加一种药品');
			        this.saving = false;
			        return;
			      }
			      
			      // 验证每个药品明细
			      for (const medicine of this.medicineList) {
			        if (!this.validateMedicine(medicine)) {
			          this.saving = false;
			          return;
			        }
			      }
			      
			      // 计算成本合计金额和零售合计金额
			      let costAmt = 0;
			      let saleAmt = 0;
			      
			      // 构建药品明细列表
			      const list = this.medicineList.map(item => {
			        // 计算单条单据的成本金额
			        const purcAmt = (item.costPric || 0) * (item.inboundQty || 0);
			        // 计算单条单据的销售金额
			        const saleAmtItem = (item.salePric || 0) * (item.inboundQty || 0);
			        
			        // 累加到总金额
			        costAmt += purcAmt;
			        saleAmt += saleAmtItem;
			        
			        // 构建每个药品明细
			        const medicineItem = {
			          id: item.id || 0, // 编辑模式下需要传递id
			          drugId: item.drugId || 0,
			          expyDate: item.expyDate || '',
			          manuDate: item.manuDate || '',
			          manuLotnum: item.manuLotnum || '',
			          planId: this.formData.purchasePlanId || '', // 采购计划id
			          prodentpName: item.manufacturer || '', // 生产厂家名称
			          prodentpNameId: item.prodentpNameId || 0, // 生产厂家id
			          purcAmt: purcAmt, // 单条单据的成本金额
			          purcCnt: item.inboundQty || 0, // 单条单据的采购数量
			          purcPric: item.costPric || 0, // 单条单据的成本单价
			          purcType: item.purcType || 0, // 库存类型
			          saleAmt: saleAmtItem, // 单条单据的销售金额
			          salePric: item.salePric || 0, // 单条单据的销售单价
			          tracCodeJson: item.tracCodeJson || '' // 追溯码JSON字符串
			        };
			        
			        return medicineItem;
			      });
			      
			      // 构建请求数据
			      const requestData = {
			        id: this.rowData.id, // 编辑模式下需要传递id
			        costAmt: costAmt, // 成本合计金额
			        invoDate: this.formData.businessDate || '', // 发票日期
			        list: list, // 药品明细列表
			        printCnt: 0, // 打印次数
			        purcInvoCodg: this.formData.invoiceNo || '', // 发票号码
			        putinTypeId: this.formData.putinTypeId || '', // 入库方式
			        remarks: this.formData.remark || '', // 备注
			        saleAmt: saleAmt, // 零售总金额
			        shedId: this.formData.warehouseId || 3, // 库房序号
			        state: 2, // 状态
			        supplyCandidateId: this.formData.supplierId || 0, // 供应商id
			        supplyCode: this.formData.supplierCode || '' // 供应商号码
			      };
			      
			      // 如果有采购计划id，也传递
			      if (this.formData.purchasePlanId) {
			        requestData.planId = this.formData.purchasePlanId;
			      }
			      
			      console.log('保存修改请求数据:', requestData);
			      
			      // 调用编辑接口
			      const response = await editXYFPurchase(requestData);
			      
			      if (response.code === 200) {
			        this.$message.success('修改保存成功');
			        this.$emit('success');
			        this.handleClose();
			      } else {
			        this.$message.error(response.message || '保存修改失败');
			      }
			    } catch (error) {
			      console.error('保存修改失败:', error);
			      this.$message.error('保存修改失败: ' + (error.message || '网络错误'));
			    } finally {
			      this.saving = false;
			    }
			},
 
			// 提交确认
			async handleSubmitConfirm() {
				this.saving = true;
				try {
					const response = await toXYFDrugExamine({
						id: this.rowData.id,
						state: 2
					});
 
					if (response && response.code === 200) {
						this.$message.success('提交成功');
						this.$emit('success', response.data);
						this.dialogVisible = false;
					} else {
						this.$message.error(response.message || '提交失败');
					}
				} catch (error) {
					console.error('提交失败:', error);
					this.$message.error('提交失败');
				} finally {
					this.saving = false;
				}
			},
 
			// 回退草稿
			async handleRollbackDraft() {
				this.saving = true;
				try {
					const response = await toXYFDrugExamine({
						id: this.rowData.id,
						state: 0
					});
 
					if (response && response.code === 200) {
						this.$message.success('回退草稿成功');
						this.$emit('success', response.data);
						this.dialogVisible = false;
					} else {
						this.$message.error(response.message || '回退草稿失败');
					}
				} catch (error) {
					console.error('回退草稿失败:', error);
					this.$message.error('回退草稿失败');
				} finally {
					this.saving = false;
				}
			},
 
			// 审核确认
			async handleReviewConfirm() {
				this.saving = true;
				try {
					const response = await toXYFDrugExamine({
						id: this.rowData.id,
						state: 4
					});
 
					if (response && response.code === 200) {
						this.$message.success('审核成功');
						this.$emit('success', response.data);
						this.dialogVisible = false;
					} else {
						this.$message.error(response.message || '审核失败');
					}
				} catch (error) {
					console.error('审核失败:', error);
					this.$message.error('审核失败');
				} finally {
					this.saving = false;
				}
			},
 
			// 回退审核
			async handleRollbackReview() {
				this.saving = true;
				try {
					const response = await toXYFDrugExamine({
						id: this.rowData.id,
						state: 2
					});
 
					if (response && response.code === 200) {
						this.$message.success('回退审核成功');
						this.$emit('success', response.data);
						this.dialogVisible = false;
					} else {
						this.$message.error(response.message || '回退审核失败');
					}
				} catch (error) {
					console.error('回退审核失败:', error);
					this.$message.error('回退审核失败');
				} finally {
					this.saving = false;
				}
			},
 
			// 确认过单入库
			async handlePassConfirm() {
			  let globalLoading = null;
			  
			  try {
			    this.saving = true;
			    
			    // 显示全局加载
			    globalLoading = this.$loading({
			      lock: true,
			      text: '正在处理过单操作，请稍候...',
			      background: 'rgba(0, 0, 0, 0.7)',
			      customClass: 'pass-confirm-loading'
			    });
			    
			    // 验证表单
			    const valid = await this.$refs.inboundForm.validate();
			    if (!valid) {
			      throw new Error('表单验证失败');
			    }
			    
			    // 验证药品明细
			    if (this.medicineList.length === 0) {
			      throw new Error('请至少添加一种药品');
			    }
			    
			    // 验证每个药品明细
			    for (const medicine of this.medicineList) {
			      if (!this.validateMedicine(medicine)) {
			        throw new Error(`药品"${medicine.drugName}"验证失败`);
			      }
			    }
			    
			    // 计算成本合计金额和零售合计金额
			    let costAmt = 0;
			    let saleAmt = 0;
			    
			    // 构建药品明细列表
			    const list = this.medicineList.map(item => {
			      // 计算单条单据的成本金额
			      const purcAmt = (item.costPric || 0) * (item.inboundQty || 0);
			      // 计算单条单据的销售金额
			      const saleAmtItem = (item.salePric || 0) * (item.inboundQty || 0);
			      
			      // 累加到总金额
			      costAmt += purcAmt;
			      saleAmt += saleAmtItem;
			      
			      // 构建每个药品明细
			      const medicineItem = {
			        id: item.id || 0, // 编辑模式下需要传递id
			        drugId: item.drugId || 0,
			        expyDate: item.expyDate || '',
			        manuDate: item.manuDate || '',
			        manuLotnum: item.manuLotnum || '',
			        planId: this.formData.purchasePlanId || 0, // 采购计划id
			        prodentpName: item.manufacturer || '', // 生产厂家名称
			        prodentpNameId: item.prodentpNameId || 0, // 生产厂家id
			        purcAmt: purcAmt, // 单条单据的成本金额
			        purcCnt: item.inboundQty || 0, // 单条单据的采购数量
			        purcPric: item.costPric || 0, // 单条单据的成本单价
			        purcType: item.purcType || 0, // 库存类型
			        saleAmt: saleAmtItem, // 单条单据的销售金额
			        salePric: item.salePric || 0, // 单条单据的销售单价
			        tracCodeJson: item.tracCodeJson || '' // 追溯码JSON字符串
			      };
			      
			      return medicineItem;
			    });
			    
			    // 构建请求数据
			    const requestData = {
			      id: this.rowData.id, // 需要传递id
			      state: 5, // 过单状态
			    };
			    
			    // 如果有采购计划id，也传递
			    if (this.formData.purchasePlanId) {
			      requestData.planId = this.formData.purchasePlanId;
			    }
			    
			    console.log('过单确认请求数据:', requestData);
			    
			    // 调用过单入库接口
			    const response = await toXYFDrugExamine(requestData);
			    
			    if (response.code === 200) {
			      this.$message.success('过单成功');
			      
			      // 关闭全局加载
			      if (globalLoading) {
			        globalLoading.close();
			        globalLoading = null;
			      }
			      
			      // 过单成功后，打开追溯码上传进度模态框
			      await this.handleTraceCodeUploadProcess();
			      
			    } else {
			      throw new Error(response.message || '过单失败');
			    }
			  } catch (error) {
			    console.error('过单失败:', error);
			    this.$message.error('过单失败: ' + error.message);
			  } finally {
			    this.saving = false;
			    // 确保关闭全局加载
			    if (globalLoading) {
			      globalLoading.close();
			    }
			  }
			},
			
			// 验证可用数量
			validateAvailableQty(row) {
			  if (this.currentTraceMedicine && this.currentTraceMedicine.pacCnt) {
			    const packageCount = parseInt(this.currentTraceMedicine.pacCnt) || 1;
			    const availableQty = parseInt(row.availableQty) || 1;
			    
			    if (availableQty != packageCount) {
			      console.warn(`可用数量(${availableQty})与包装数量(${packageCount})不一致，已自动修正`);
			      row.availableQty = packageCount;
			    }
			  }
			},
			
			// 处理追溯码上传进度流程
			async handleTraceCodeUploadProcess() {
			  // 重置状态
			  this.resetPassProgress();
			  
			  // 打开进度模态框
			  this.passProgressDialogVisible = true;
			  this.showCloseButton = false; // 重置关闭按钮状态
			  
			  try {
			    // 第一步：当前单据已过单
			    await this.executeStepWithProgress(0, async () => {
			      this.updateProgressStep(0, 'finish', '当前单据已过单');
			      await this.delay(1000);
			    });
			    
			    // 第二步：正在获取系统参数
			    await this.executeStepWithProgress(1, async () => {
			      this.updateProgressStep(1, 'process', '正在获取系统参数...');
			      
			      // 获取系统参数
			      const success = await this.getSystemParameters();
			      
			      if (success && this.msfxEntId) {
			        this.updateProgressStep(1, 'finish', '系统参数获取成功');
			      } else {
			        this.updateProgressStep(1, 'error', '获取系统参数失败，将使用默认值');
			      }
			    });
			    
			    // 第三步：正在验证是否需要上传追溯码
			    await this.executeStepWithProgress(2, async () => {
			      this.updateProgressStep(2, 'process', '正在验证是否需要上传追溯码');
			      
			      // 检查是否需要上传追溯码
			      await this.checkNeedUploadTraceCode();
			      
			      if (this.needUploadTraceCode) {
			        this.updateProgressStep(2, 'finish', '已检测到需要上传追溯码');
			      } else {
			        this.updateProgressStep(2, 'finish', '本次单据无需上传追溯码');
			      }
			    });
			    
			    if (this.needUploadTraceCode) {
			      // 第四步：正在提取追溯码
			      await this.executeStepWithProgress(3, async () => {
			        this.updateProgressStep(3, 'process', '正在提取追溯码...');
			        
			        // 提取追溯码
			        await this.extractTraceCodes();
			        
			        this.updateProgressStep(3, 'finish', '正在提取追溯码...');
			      });
			      
			      // 第五步：追溯码提取成功
			      await this.executeStepWithProgress(4, async () => {
			        this.updateProgressStep(4, 'process', `追溯码提取成功：${this.traceCodeString}`);
			        
			        await this.delay(1000);
			        this.updateProgressStep(4, 'finish', `追溯码提取成功：共提取到 ${this.traceCodeCount} 个追溯码`);
			      });
			      
			      // 第六步：正在连接码上放心平台进行追溯码上传
			      await this.executeStepWithProgress(5, async () => {
			        this.updateProgressStep(5, 'process', '正在连接码上放心平台进行追溯码上传');
			        
			        // 上传追溯码
			        const uploadResult = await this.uploadTraceCodes();
			        
			        if (uploadResult.success) {
			          this.updateProgressStep(5, 'finish', '正在连接码上放心平台进行追溯码上传');
			          
			          // 第七步：上传追溯码已完成
			          await this.executeStepWithProgress(6, async () => {
			            this.updateProgressStep(6, 'process', '上传追溯码已完成');
			            
			            await this.delay(1000);
			            this.updateProgressStep(6, 'finish', '上传追溯码已完成');
			            
			            // 只有上传成功时才延迟关闭模态框
			            setTimeout(() => {
			              this.passProgressDialogVisible = false;
			              this.$emit('success'); // 触发父组件刷新表格
			              this.handleClose();
			            }, 2000);
			          });
			          
			        } else {
			          // 上传失败，设置重新补传按钮
			          this.updateProgressStep(5, 'error', '上传失败，请点击重新补传按钮重试');
			          this.updateStepRetryButton(5, true); // 显示重新补传按钮
			          this.showCloseButton = true; // 显示关闭按钮
			          
			          // 设置失败描述
			          this.updateStepDescription(5, `失败原因：${uploadResult.message}`);
			        }
			        
			        return uploadResult;
			      });
			      
			    } else {
			      // 不需要上传追溯码，跳过后续步骤
			      for (let i = 3; i <= 6; i++) {
			        await this.executeStepWithProgress(i, async () => {
			          this.updateProgressStep(i, 'finish', '无需上传追溯码');
			        });
			      }
			      
			      // 延迟关闭模态框
			      setTimeout(() => {
			        this.passProgressDialogVisible = false;
			        this.$emit('success'); // 触发父组件刷新表格
			        this.handleClose();
			      }, 2000);
			    }
			    
			  } catch (error) {
			    console.error('追溯码上传流程出错:', error);
			    this.updateProgressStep(6, 'error', '流程执行出错，请联系管理员');
			    this.showCloseButton = true; // 显示关闭按钮
			  }
			},
			
			// 处理重新补传
			async handleRetryUpload() {
			  let msfxLoading = null;
			
			  try {
			    console.log('开始重新补传流程');
			
			    // 设置重新补传加载状态
			    this.updateStepRetryButton(5, true, true);
			
			    // 重置第六步状态
			    this.updateProgressStep(5, 'process', '正在重新连接码上放心平台进行追溯码上传');
			    this.updateStepDescription(5, '');
			
			    // 步骤1：从已输入的追溯码中提取第一个追溯码（仅用于日志，不再用于获取refEntId）
			    if (!this.traceCodeString) {
			      this.updateProgressStep(5, 'error', '重新补传失败：追溯码为空');
			      this.updateStepDescription(5, '未找到可用的追溯码');
			      this.updateStepRetryButton(5, true, false);
			      this.showCloseButton = true;
			      this.$message.error('重新补传失败：追溯码为空');
			      return;
			    }
			
			    const traceCodes = this.traceCodeString.split(',');
			    if (traceCodes.length === 0) {
			      this.updateProgressStep(5, 'error', '重新补传失败：追溯码为空');
			      this.updateStepDescription(5, '未找到可用的追溯码');
			      this.updateStepRetryButton(5, true, false);
			      this.showCloseButton = true;
			      this.$message.error('重新补传失败：追溯码为空');
			      return;
			    }
			
			    // 步骤2：直接使用行数据中的 entId 作为 fromUserId
			    const fromUserId = this.formData?.entId || this.rowData?.entId || '';
			
			    if (!fromUserId) {
			      this.updateProgressStep(5, 'error', '重新补传失败：缺少供应商ID');
			      this.updateStepDescription(5, '行数据中未找到 entId');
			      this.updateStepRetryButton(5, true, false);
			      this.showCloseButton = true;
			      this.$message.error('重新补传失败：缺少供应商ID');
			      return;
			    }
			
			    console.log('重新补传-使用 entId:', fromUserId);
			
			    // 步骤3：获取系统参数中的码上放心entid
			    let toUserId = '';
			    if (this.msfxEntId) {
			      toUserId = this.msfxEntId;
			      console.log('重新补传-使用系统参数中的码上放心entid:', toUserId);
			    } else {
			      console.warn('系统参数中未找到码上放心entid，使用默认值');
			      toUserId = 'default_ent_id';
			    }
			
			    // 步骤4：准备上传参数
			    const uploadData = {
			      billType: this.getBillType(this.formData.putinTypeId),
			      bizNum: this.rowData.docNum || '',
			      fromUserId: fromUserId, // 直接使用 supplyCandidateId
			      physicType: 3,
			      toUserId: toUserId,
			      traceCodes: this.traceCodeString.replace(/,\s*/g, ',')
			    };
			
			    console.log('重新补传-上传参数:', uploadData);
			
			    // 步骤5：检查必要的参数
			    if (!uploadData.bizNum) {
			      this.updateProgressStep(5, 'error', '重新补传失败：业务单据编号为空');
			      this.updateStepDescription(5, '业务单据编号为空');
			      this.updateStepRetryButton(5, true, false);
			      this.showCloseButton = true;
			      this.$message.error('重新补传失败：业务单据编号为空');
			      return;
			    }
			
			    if (!uploadData.traceCodes) {
			      this.updateProgressStep(5, 'error', '重新补传失败：追溯码为空');
			      this.updateStepDescription(5, '追溯码为空');
			      this.updateStepRetryButton(5, true, false);
			      this.showCloseButton = true;
			      this.$message.error('重新补传失败：追溯码为空');
			      return;
			    }
			
			    // 步骤6：调用上传接口
			    this.updateProgressStep(5, 'process', '正在重新上传追溯码到码上放心平台...');
			
			    const uploadResult = await msfxUploadInoutBill(uploadData);
			
			    console.log('重新补传-上传接口返回:', uploadResult);
			
			    if (uploadResult.code === 200) {
			      this.updateProgressStep(5, 'finish', '正在连接码上放心平台进行追溯码上传');
			      this.updateStepRetryButton(5, false);
			      this.showCloseButton = false;
			
			      // 继续执行第七步
			      await this.executeStepWithProgress(6, async () => {
			        this.updateProgressStep(6, 'process', '上传追溯码已完成');
			        await this.delay(1000);
			        this.updateProgressStep(6, 'finish', '上传追溯码已完成');
			      });
			
			      // 延迟关闭模态框
			      setTimeout(() => {
			        this.passProgressDialogVisible = false;
			        this.$emit('success');
			        this.handleClose();
			      }, 2000);
			
			    } else {
			      this.updateProgressStep(5, 'error', '重新补传失败，请点击重新补传按钮重试');
			      this.updateStepDescription(5, `失败原因：${uploadResult.message || uploadResult.msg || '上传失败'}`);
			      this.updateStepRetryButton(5, true, false);
			      this.showCloseButton = true;
			      this.$message.error('重新补传失败');
			    }
			
			  } catch (error) {
			    console.error('重新补传流程出错:', error);
			    this.updateStepDescription(5, '重新补传流程出错，请联系管理员');
			    this.updateStepRetryButton(5, true, false);
			    this.$message.error('重新补传失败');
			  } finally {
			    if (msfxLoading) {
			      msfxLoading.close();
			    }
			  }
			},
			
			// 更新步骤重新补传按钮状态
			updateStepRetryButton(stepIndex, show, loading = false) {
			  if (stepIndex >= 0 && stepIndex < this.passProgressSteps.length) {
			    const step = { ...this.passProgressSteps[stepIndex] };
			    step.showRetryButton = show;
			    step.retryLoading = loading;
			    this.$set(this.passProgressSteps, stepIndex, step);
			  }
			},
			
			// 更新步骤描述
			updateStepDescription(stepIndex, description) {
			  if (stepIndex >= 0 && stepIndex < this.passProgressSteps.length) {
			    const step = { ...this.passProgressSteps[stepIndex] };
			    step.description = description;
			    this.$set(this.passProgressSteps, stepIndex, step);
			  }
			},
			
			// 执行步骤并显示进度条
			async executeStepWithProgress(stepIndex, stepAction) {
			  return new Promise(async (resolve) => {
			    // 设置当前步骤
			    this.passCurrentStep = stepIndex;
			    
			    // 启动进度条动画
			    this.startProgressAnimation(stepIndex);
			    
			    try {
			      // 执行步骤动作
			      const result = await stepAction();
			      
			      // 步骤完成，停止进度条动画
			      this.stopProgressAnimation(stepIndex);
			      
			      // 设置步骤为完成状态
			      this.updateStepProgress(stepIndex, 100);
			      
			      resolve(result);
			    } catch (error) {
			      console.error(`步骤${stepIndex}执行失败:`, error);
			      
			      // 步骤失败，停止进度条动画
			      this.stopProgressAnimation(stepIndex);
			      
			      // 设置步骤为错误状态
			      this.updateStepProgress(stepIndex, 0, 'error');
			      
			      resolve(null);
			    }
			  });
			},
			
			// 启动进度条动画
			startProgressAnimation(stepIndex) {
			  if (stepIndex < 0 || stepIndex >= this.passProgressSteps.length) {
			    return;
			  }
			  
			  // 清除之前的计时器
			  if (this.progressTimer) {
			    clearInterval(this.progressTimer);
			  }
			  
			  // 设置步骤状态为进行中
			  this.updateProgressStep(stepIndex, 'process');
			  
			  // 开始进度条动画
			  let progress = 0;
			  const stepDuration = 3000; // 每个步骤持续3秒
			  const interval = 50; // 更新间隔50ms
			  const increment = 100 / (stepDuration / interval);
			  
			  this.progressTimer = setInterval(() => {
			    progress += increment;
			    
			    if (progress >= 100) {
			      progress = 100;
			      clearInterval(this.progressTimer);
			    }
			    
			    // 更新步骤进度
			    this.updateStepProgress(stepIndex, progress);
			    
			    // 更新总进度
			    this.updateTotalProgress();
			    
			  }, interval);
			},
			
			// 停止进度条动画
			stopProgressAnimation(stepIndex) {
			  if (this.progressTimer) {
			    clearInterval(this.progressTimer);
			    this.progressTimer = null;
			  }
			  
			  // 确保进度为100%
			  this.updateStepProgress(stepIndex, 100);
			  this.updateTotalProgress();
			},
			
			// 更新步骤进度
			updateStepProgress(stepIndex, progress, status = null) {
			  if (stepIndex >= 0 && stepIndex < this.passProgressSteps.length) {
			    const step = this.passProgressSteps[stepIndex];
			    step.progress = Math.min(progress, 100);
			    
			    if (status) {
			      step.status = status;
			    }
			    
			    // 进度达到100%时，更新图标
			    if (progress >= 100 && step.status !== 'error') {
			      step.icon = 'el-icon-success';
			    } else if (step.status === 'error') {
			      step.icon = 'el-icon-error';
			    } else {
			      step.icon = '';
			    }
			    
			    this.$set(this.passProgressSteps, stepIndex, step);
			  }
			},
			
			// 更新总进度
			updateTotalProgress() {
			  if (this.passProgressSteps.length === 0) {
			    this.totalProgress = 0;
			    return;
			  }
			  
			  // 计算已完成步骤的数量
			  const completedSteps = this.passProgressSteps.filter(step => 
			    step.status === 'finish' || step.status === 'error'
			  ).length;
			  
			  // 如果当前有正在进行的步骤，加上其进度比例
			  const currentStep = this.passCurrentStep;
			  if (currentStep < this.passProgressSteps.length && 
			      this.passProgressSteps[currentStep].status === 'process') {
			    const currentStepProgress = this.passProgressSteps[currentStep].progress;
			    this.totalProgress = Math.round(
			      ((completedSteps - 1) + currentStepProgress / 100) / 
			      this.passProgressSteps.length * 100
			    );
			  } else {
			    this.totalProgress = Math.round(
			      completedSteps / this.passProgressSteps.length * 100
			    );
			  }
			},
			
			// 在resetPassProgress方法中，确保步骤描述正确
			resetPassProgress() {
			  this.passProgressSteps = [
			    { 
			      title: '当前单据已过单', 
			      status: 'wait', 
			      progress: 0, 
			      icon: '',
			      description: '',
			      showProgressBar: true,
			      showRetryButton: false,
			      retryLoading: false
			    },
			    { 
			      title: '正在获取系统参数...', 
			      status: 'wait', 
			      progress: 0, 
			      icon: '',
			      description: '',
			      showProgressBar: true,
			      showRetryButton: false
			    },
			    { 
			      title: '正在验证是否需要上传追溯码', 
			      status: 'wait', 
			      progress: 0, 
			      icon: '',
			      description: '',
			      showProgressBar: true,
			      showRetryButton: false
			    },
			    { 
			      title: '正在提取追溯码...', 
			      status: 'wait', 
			      progress: 0, 
			      icon: '',
			      description: '',
			      showProgressBar: true,
			      showRetryButton: false
			    },
			    { 
			      title: '追溯码提取成功', 
			      status: 'wait', 
			      progress: 0, 
			      icon: '',
			      description: '',
			      showProgressBar: true,
			      showRetryButton: false
			    },
			    { 
			      title: '正在连接码上放心平台进行追溯码上传', 
			      status: 'wait', 
			      progress: 0, 
			      icon: '',
			      description: '',
			      showProgressBar: true,
			      showRetryButton: false
			    },
			    { 
			      title: '上传追溯码已完成', 
			      status: 'wait', 
			      progress: 0, 
			      icon: '',
			      description: '',
			      showProgressBar: true,
			      showRetryButton: false
			    }
			  ];
			  this.passCurrentStep = 0;
			  this.needUploadTraceCode = false;
			  this.traceCodeCount = 0;
			  this.traceCodeString = '';
			  this.needUploadDrugs = [];
			  this.totalProgress = 0;
			  this.msfxEntId = '';
			  this.systemParameterList = [];
			  this.showCloseButton = false;
			  
			  if (this.progressTimer) {
			    clearInterval(this.progressTimer);
			    this.progressTimer = null;
			  }
			},
			
			// 检查是否需要上传追溯码
			async checkNeedUploadTraceCode() {
			  try {
			    // 假设我们已经有了药品明细数据
			    this.needUploadTraceCode = false;
			    this.needUploadDrugs = [];
			    
			    // 检查medicineList中的每个药品
			    this.medicineList.forEach(item => {
			      if (item.tracCodeJson && item.tracCodeJson.trim() !== '' && item.tracCodeJson !== '[]') {
			        this.needUploadTraceCode = true;
			        this.needUploadDrugs.push({
			          drugName: item.drugName,
			          tracCodeJson: item.tracCodeJson,
					  // 保存生产厂家refEntId
					  refEntId: item.refEntId || ''
			        });
			      }
			    });
			    
			    // 如果有需要上传追溯码的药品，更新提示信息
			    if (this.needUploadTraceCode && this.needUploadDrugs.length > 0) {
			      const drugNames = this.needUploadDrugs.map(drug => drug.drugName).join('、');
			      this.updateProgressStep(1, 'finish', `已检测到 ${drugNames} 需要上传追溯码`);
			    } else {
			      this.updateProgressStep(1, 'finish', '本次单据无需上传追溯码');
			    }
			    
			  } catch (error) {
			    console.error('检查追溯码失败:', error);
			    throw error;
			  }
			},
			
			// 提取追溯码
			async extractTraceCodes() {
			  try {
			    const allTraceCodes = [];
			    
			    // 从needUploadDrugs中提取追溯码
			    this.needUploadDrugs.forEach(drug => {
			      try {
			        const tracCodeJson = JSON.parse(drug.tracCodeJson);
			        if (Array.isArray(tracCodeJson)) {
			          tracCodeJson.forEach(item => {
			            if (item.barcode) {
			              allTraceCodes.push(item.barcode);
			            }
			          });
			        }
			      } catch (parseError) {
			        console.error('解析追溯码JSON失败:', parseError, drug);
			      }
			    });
			    
			    this.traceCodeCount = allTraceCodes.length;
			    this.traceCodeString = allTraceCodes.join(', ');
			    
			    console.log('提取到的追溯码:', {
			      count: this.traceCodeCount,
			      codes: this.traceCodeString
			    });
			    
			  } catch (error) {
			    console.error('提取追溯码失败:', error);
			    throw error;
			  }
			},
			
			// 上传追溯码
			async uploadTraceCodes() {
			  let loadingInstance = null;
			
			  try {
			    if (!this.traceCodeString) {
			      return { success: true, message: '无追溯码需要上传' };
			    }
			    // 步骤1：使用供应商的 entId 作为 fromUserId（从详情接口获取）
			    const fromUserId = this.formData?.entId || this.rowData?.entId || '';
			    if (!fromUserId) {
			      return {
			        success: false,
			        message: '缺少供应商ID（supplyCandidateId）'
			      };
			    }
			
			    // 步骤2：获取系统参数中的码上放心entid
			    let toUserId = '';
			    if (this.msfxEntId) {
			      toUserId = this.msfxEntId;
			      console.log('使用系统参数中的码上放心entid:', toUserId);
			    } else {
			      console.warn('系统参数中未找到码上放心entid，使用默认值');
			      toUserId = 'default_ent_id';
			    }
			
			    // 步骤3：准备上传参数
			    const uploadData = {
			      billType: this.getBillType(this.formData.putinTypeId),
			      bizNum: this.rowData.docNum || '',
			      fromUserId: fromUserId, // 直接使用 supplyCandidateId
			      physicType: 3,
			      toUserId: toUserId,
			      traceCodes: this.traceCodeString.replace(/,\s*/g, ',')
			    };
			
			    console.log('首次上传-上传参数:', uploadData);
			
			    // 步骤4：检查必要的参数
			    if (!uploadData.bizNum) {
			      return { success: false, message: '业务单据编号为空' };
			    }
			    if (!uploadData.traceCodes) {
			      return { success: false, message: '追溯码为空' };
			    }
			
			    // 步骤5：调用上传接口
			    console.log('开始调用msfxUploadInoutBill接口');
			    this.updateProgressStep(5, 'process', '正在上传追溯码到码上放心平台...');
			
			    const response = await msfxUploadInoutBill(uploadData);
			
			    console.log('首次上传-上传接口返回:', response);
			
			    if (response.code === 200) {
			      return { success: true, message: '上传成功' };
			    } else {
			      return {
			        success: false,
			        message: response.message || response.msg || '上传失败'
			      };
			    }
			  } catch (error) {
			    console.error('上传追溯码失败:', error);
			    return { success: false, message: error.message || '网络错误' };
			  } finally {
			    if (loadingInstance) {
			      loadingInstance.close();
			    }
			  }
			},
			
			// 获取单据类型
			getBillType(putinTypeId) {
			  const typeMap = {
			    1: 102, // 采购入库
			    2: 113, // 其他入库
			    3: 111, // 盘盈入库 (假设赠送入库对应盘盈入库)
			    4: 111, // 盘点入库
			    5: 111  // 系统切换入库
			  };
			  return typeMap[putinTypeId] || 102;
			},
			
			// 获取发货企业ent_id
			getFromUserId() {
			  // 这里需要根据实际情况获取发货企业ent_id
			  // 对于采购入库，发货企业是药品供应商
			  // 暂时返回供应商ID
			  return this.formData.supplierId || '';
			},
			
			// 获取收货企业ent_id
			getToUserId() {
			  // 这里需要根据实际情况获取收货企业ent_id
			  // 对于采购入库，收货企业是医院
			  // 暂时返回固定值，实际应该从系统配置获取
			  return 'hospital_id_here'; // 需要替换为实际的医院ID
			},
			
			// 更新进度步骤
			updateProgressStep(index, status, title = null) {
			  if (index >= 0 && index < this.passProgressSteps.length) {
			    const step = { ...this.passProgressSteps[index] };
			    step.status = status;
			    
			    if (title) {
			      step.title = title;
			    }
			    
			    // 更新图标
			    if (status === 'finish') {
			      step.icon = 'el-icon-success';
			    } else if (status === 'error') {
			      step.icon = 'el-icon-error';
			    } else {
			      step.icon = '';
			    }
			    
			    this.$set(this.passProgressSteps, index, step);
			  }
			},
			
			// 延迟函数
			delay(ms) {
			  return new Promise(resolve => setTimeout(resolve, ms));
			},
 
			// 回退确认
			async handleRollbackConfirm() {
				this.saving = true;
				try {
					const response = await toXYFDrugExamine({
						id: this.rowData.id,
						state: 0
					});
 
					if (response && response.code === 200) {
						this.$message.success('回退成功');
						this.$emit('success', response.data);
						this.dialogVisible = false;
					} else {
						this.$message.error(response.message || '回退失败');
					}
				} catch (error) {
					console.error('回退失败:', error);
					this.$message.error('回退失败');
				} finally {
					this.saving = false;
				}
			},
 
			// 快速调拨确认
			async handleFastTransferConfirm() {
			  try {
			    this.saving = true;
			    
			    // 验证表单
			    const valid = await this.$refs.inboundForm.validate();
			    if (!valid) {
			      this.saving = false;
			      return;
			    }
			    
			    // 验证药品明细
			    if (this.medicineList.length === 0) {
			      this.$message.warning('请至少添加一种药品');
			      this.saving = false;
			      return;
			    }
			    
			    // 验证每个药品明细
			    for (const medicine of this.medicineList) {
			      if (!this.validateMedicine(medicine)) {
			        this.saving = false;
			        return;
			      }
			    }
			    
			    // 计算成本合计金额和零售合计金额
			    let costAmt = 0;
			    let saleAmt = 0;
			    
			    // 构建药品明细列表
			    const list = this.medicineList.map(item => {
			      // 计算单条单据的成本金额
			      const purcAmt = (item.costPric || 0) * (item.inboundQty || 0);
			      // 计算单条单据的销售金额
			      const saleAmtItem = (item.salePric || 0) * (item.inboundQty || 0);
			      
			      // 累加到总金额
			      costAmt += purcAmt;
			      saleAmt += saleAmtItem;
			      
			      // 构建每个药品明细
			      const medicineItem = {
			        drugId: item.drugId || 0,
			        expyDate: item.expyDate || '',
			        manuDate: item.manuDate || '',
			        manuLotnum: item.manuLotnum || '',
			        planId: this.formData.purchasePlanId || '', // 采购计划id
			        prodentpName: item.manufacturer || '', // 生产厂家名称
			        prodentpNameId: item.prodentpNameId || '', // 生产厂家id
			        purcAmt: purcAmt, // 单条单据的成本金额
			        purcCnt: item.inboundQty || 0, // 单条单据的采购数量
			        purcPric: item.costPric || 0, // 单条单据的成本单价
			        purcType: item.purcType || 0, // 库存类型
			        saleAmt: saleAmtItem, // 单条单据的销售金额
			        salePric: item.salePric || 0, // 单条单据的销售单价
			        tracCodeJson: item.tracCodeJson || '' // 追溯码JSON字符串
			      };
			      
			      return medicineItem;
			    });
			    
			    // 构建快速调拨请求数据
			    const requestData = {
			      id: this.rowData.id || 0, // 采购入库单id
			    };
			    
			    // 如果有采购计划id，也传递
			    if (this.formData.purchasePlanId) {
			      requestData.planId = this.formData.purchasePlanId;
			    }
			    
			    console.log('快速调拨请求数据:', requestData);
			    
			    // 调用快速调拨接口
			    const response = await fastTransfer(requestData);
			    
			    if (response.code === 200) {
			      this.$message.success('快速调拨成功');
			      this.$emit('success');
			      this.handleClose();
			    } else {
			      this.$message.error(response.message || '快速调拨失败');
			    }
			  } catch (error) {
			    console.error('快速调拨失败:', error);
			    this.$message.error('快速调拨失败: ' + (error.message || '网络错误'));
			  } finally {
			    this.saving = false;
			  }
			},
			
			// 验证药品信息
			validateMedicine(medicine) {
			  // 必填字段验证
			  const requiredFields = [
			    { field: 'drugId', name: '药品' },
			    { field: 'inboundQty', name: '入库数量' },
			    { field: 'purcType', name: '库存类型' },
			    { field: 'pacCnt', name: '包装数量' },
			    { field: 'manufacturer', name: '生产厂家' },
			    { field: 'manuLotnum', name: '生产批号' }
			  ];
			  
			  for (const { field, name } of requiredFields) {
			    if (!medicine[field] && medicine[field] !== 0) {
			      this.$message.warning(`请填写${name}`);
			      return false;
			    }
			  }
			  if (parseInt(medicine.periodControl) === 1) {
			      requiredFields.push({ field: 'expyDate', name: '有效日期' });
			  }
			  // 追溯码验证：如果启用了追溯码，必须有追溯码信息
			  if (medicine.isBar === 1) {
			    if (!medicine.traceCodes || medicine.traceCodes.length === 0) {
			      this.$message.warning(`药品"${medicine.drugName}"已启用追溯码，请录入追溯码`);
			      return false;
			    }
			    
			    // 验证追溯码数量是否与入库数量一致
			    if (medicine.traceCodes.length != medicine.inboundQty) {
			      this.$message.warning(`药品"${medicine.drugName}"的追溯码数量(${medicine.traceCodes.length})与入库数量(${medicine.inboundQty})不一致`);
			      return false;
			    }
			  }
			  
			  return true;
			},
			
			// 关闭对话框
			handleClose() {
				this.dialogVisible = false;
				this.$emit('close');
			}
		}
	};
</script>
 
<style lang="less" scoped>
	::v-deep .el-dialog {
		border-radius: 10px;
	}
 
	::v-deep .el-dialog__body {
		padding: 10px;
	}
 
	.addxyk-dialog {
		border-radius: 8px;
 
		.el-dialog__title {
			font-size: 16px;
			color: #333;
			font-weight: 600;
		}
 
		.section-title {
			font-size: 14px;
			color: #333;
			font-weight: 600;
			margin: 0 0 15px 0;
			padding-bottom: 8px;
			border-bottom: 2px solid #409EFF;
		}
 
		.purchase-info-section {
			margin-bottom: 10px;
			padding-bottom: 10px;
			border-bottom: 1px solid #e8e8e8;
 
			.supplier-wrapper {
				display: flex;
				align-items: center;
 
				.supplier-select {
					flex: 1;
					margin-right: 8px;
				}
 
				.add-supplier-btn {
					border-color: #409EFF;
					color: #409EFF;
					background-color: #f0f9ff;
					margin-right: 8px;
					padding: 7px 8px;
 
					&:hover {
						background-color: #409EFF;
						color: white;
					}
				}
 
				.supplier-code-input {
					width: 140px;
				}
			}
 
			.plan-code-select {
				display: flex;
				align-items: center;
 
				.plan-option {
					display: flex;
					flex-direction: column;
					padding: 5px 0;
 
					.plan-code {
						font-weight: bold;
						color: #333;
						margin-bottom: 2px;
					}
 
					.plan-supplier {
						font-size: 12px;
						color: #666;
					}
				}
			}
 
			.selected-plan-info {
				margin-top: 5px;
			}
		}
 
		.medicine-detail-section {
			.section-header {
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin-bottom: 10px;
			}
 
			/* 药品选择容器样式 */
			.drug-select-container {
				position: relative;
 
				.drug-loading-icon {
					position: absolute;
					right: 5px;
					top: 50%;
					transform: translateY(-50%);
				}
			}
 
			/* 药品选项样式 - 使用参考代码西的样式 */
			.drug-option {
				display: flex;
				flex-direction: column;
				padding: 5px 0;
				line-height: 1.4;
 
				.drug-name {
					font-weight: bold;
					color: #333;
					margin-bottom: 2px;
				}
 
				.drug-spec {
					font-size: 12px;
					color: #666;
					margin-top: 1px;
 
					&:not(:last-child) {
						margin-bottom: 1px;
					}
				}
			}
 
			/* 加载更多选项样式 */
			.load-more-option {
				text-align: center;
				padding: 8px 0;
				color: #909399;
				cursor: pointer;
 
				&:hover {
					background-color: #f5f7fa;
				}
			}
 
			.no-more-option {
				text-align: center;
				padding: 8px 0;
				color: #909399;
			}
 
			.loading-option {
				text-align: center;
				padding: 8px 0;
				color: #909399;
			}
 
			.qty-wrapper {
				display: flex;
				align-items: center;
 
				.qty-input {
					flex: 1;
					margin-right: 8px;
				}
 
				.unit-label {
					min-width: 40px;
					color: #666;
					font-size: 12px;
					text-align: left;
				}
			}
 
			.summary-info {
				margin-top: 10px;
				padding: 12px;
				background-color: #f5f7fa;
				border-radius: 4px;
 
				.summary-item {
					display: flex;
					justify-content: space-between;
					align-items: center;
					font-size: 14px;
 
					.label {
						color: #606266;
					}
 
					.value {
						color: #409EFF;
						font-weight: 600;
					}
				}
			}
 
			.load-more {
				text-align: center;
				padding: 8px;
				color: #909399;
				font-size: 12px;
			}
		}
	}
 
	/* 采购计划抽屉样式 */
	.purchase-plan-drawer {
		.el-drawer__header {
			margin-bottom: 0;
			padding-bottom: 20px;
			border-bottom: 1px solid #e8e8e8;
		}
 
		.drawer-content {
			height: 100%;
			display: flex;
			flex-direction: column;
		}
 
		.drawer-search {
			padding: 20px;
			background-color: #fff;
			border-bottom: 1px solid #e8e8e8;
 
			.plan-query-form {
				.el-form-item {
					margin-bottom: 10px;
				}
			}
		}
 
		.drawer-table {
			flex: 1;
			overflow: hidden;
			padding: 20px;
 
			.el-table {
				height: 100%;
			}
		}
 
		.drawer-pagination {
			padding: 20px;
			border-top: 1px solid #e8e8e8;
			text-align: right;
		}
	}
</style>
 
<!-- 药品下拉框全局样式 - 解决样式穿透问题 -->
<style lang="less">
	/* 药品下拉框的全局样式 - 针对挂载在body上的popper */
	.drug-select-popper {
		.el-select-dropdown__item {
			height: auto;
			min-height: 50px;
			padding: 8px 12px;
			display: flex;
			align-items: center;
 
			&.selected,
			&.hover {
				.drug-option {
 
					.drug-name,
					.drug-spec {
						color: #409EFF;
					}
				}
			}
 
			.drug-option {
				display: flex;
				flex-direction: column;
				width: 100%;
				line-height: 1.4;
				min-height: 50px;
 
				.drug-name {
					font-weight: 600;
					color: #303133;
					margin-bottom: 3px;
					font-size: 13px;
				}
 
				.drug-spec {
					font-size: 12px;
					color: #606266;
					line-height: 1.3;
 
					&:not(:last-child) {
						margin-bottom: 2px;
					}
				}
			}
		}
 
		/* 加载更多、没有更多、加载西的选项样式 */
		.load-more-option,
		.no-more-option,
		.loading-option {
			text-align: center;
			padding: 12px 0;
			color: #909399;
			font-size: 12px;
		}
 
		.load-more-option {
			cursor: pointer;
 
			&:hover {
				background-color: #f5f7fa;
			}
		}
	}
 
	/* 确保采购计划抽屉西的表格样式正确 */
	.purchase-plan-drawer {
		.el-drawer__body {
			display: flex;
			flex-direction: column;
		}
 
		.drawer-content {
			display: flex;
			flex-direction: column;
			height: 100%;
		}
 
		.drawer-search {
			flex-shrink: 0;
		}
 
		.drawer-table {
			flex: 1;
			min-height: 0;
		}
 
		.drawer-pagination {
			flex-shrink: 0;
		}
	}
 
	/* 金额输入框的全局样式，确保8位小数显示正确 */
	.el-input-number--small {
		.el-input__inner {
			text-align: right;
		}
	}
 
	/* 禁用输入框的样式优化 */
	.el-input.is-disabled .el-input__inner {
		background-color: #f5f7fa;
		border-color: #e4e7ed;
		color: #606266;
		cursor: not-allowed;
	}
 
	/* 表格西tooltip的样式优化 */
	.el-tooltip__popper {
		max-width: 300px;
		word-break: break-word;
	}
</style>
<style lang="less">
/* 药品下拉框的全局样式 - 针对挂载在body上的popper */
.drug-select-popper {
  .el-select-dropdown__item {
    height: auto;
    min-height: 50px;
    padding: 8px 12px;
    display: flex;
    align-items: center;
    
    &:hover,
    &.selected,
    &.hover {
      .drug-option {
        .drug-name {
          .highlight-keyword {
            color: #ff6700;
            background-color: rgba(255, 103, 0, 0.15);
          }
        }
      }
    }
    
    .drug-option {
      display: flex;
      flex-direction: column;
      width: 100%;
      line-height: 1.4;
      min-height: 50px;
      
      .drug-name {
        font-weight: 600;
        color: #303133;
        margin-bottom: 3px;
        font-size: 13px;
        
        /* 高亮关键词样式 */
        .highlight-keyword {
          color: #ff6700;
          font-weight: bold;
          background-color: rgba(255, 103, 0, 0.1);
          padding: 0 2px;
          border-radius: 2px;
        }
      }
      
      .drug-spec {
        font-size: 12px;
        color: #606266;
        line-height: 1.3;
        
        &:not(:last-child) {
          margin-bottom: 2px;
        }
      }
    }
  }
}
</style>
 
<style lang="less" scoped>
/deep/ .el-dialog__header {
	padding-bottom: 10px;
	background: linear-gradient(135deg, #ebfaff 0%, #00557f 100%);
	border-bottom: 1px solid #e8e8e8;
	border-radius: 8px;
	}
 
/deep/ .el-dialog__headerbtn .el-dialog__close{
	color: #ffffff;
}
/deep/ .el-dialog__headerbtn .el-dialog__close:hover{
	color: #000042;
	font-weight: bold;
}
</style>
<style lang="less" scoped>
/* 追溯码对话框样式 */
/deep/ .trace-code-dialog {
  .el-dialog__header {
    background-color: #f5f7fa !important; /* 浅灰色背景 */
    border-bottom: 1px solid #ebeef5;
  }
  
  .el-dialog__title {
    color: #303133 !important; /* 亮黑色文字 */
    font-weight: 600;
  }
  
  .el-dialog__body {
    padding: 0 !important;
    background-color: #ffffff; /* 白色背景 */
  }
  
  .el-dialog__footer {
    background-color: #ffffff; /* 白色背景 */
    border-top: 1px solid #ebeef5;
    padding: 10px 20px;
  }
}
 
/* 追溯码对话框内容 */
.trace-code-dialog-content {
  padding: 20px;
}
 
/* 功能按钮区域 - 左右布局 */
.function-buttons-section {
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #ebeef5;
}
 
.function-button-group {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
 
.left-function-area {
  flex: 1;
  min-width: 300px;
  margin-right: 20px;
}
 
.right-function-area {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  min-width: 200px;
}
 
.scan-input-area {
  background-color: #f8f9fa;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 4px;
  
  .scan-area-title {
    font-size: 14px;
    color: #606266;
    margin-bottom: 10px;
    font-weight: 600;
  }
  
  .scan-input-wrapper {
    margin-bottom: 8px;
  }
  
  .scan-tips {
    font-size: 12px;
    color: #909399;
    
    i {
      margin-right: 5px;
    }
  }
}
 
.function-button-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  padding: 10px 15px;
  border-radius: 4px;
  transition: all 0.3s;
  min-width: 80px;
  margin-left: 10px;
  
  &:hover {
    background-color: #f5f7fa;
    transform: translateY(-2px);
  }
  
  &.active {
    background-color: #ecf5ff;
  }
}
 
.function-icon {
  font-size: 24px;
  color: #409EFF;
  margin-bottom: 8px;
}
 
.function-text {
  font-size: 12px;
  color: #606266;
}
 
/* 统计信息区域 */
.summary-info-section {
  background-color: #f8f9fa;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 15px;
  margin-bottom: 15px;
  
  .summary-item {
    display: flex;
    align-items: center;
    
    .label {
      font-size: 12px;
      color: #606266;
      margin-right: 8px;
      white-space: nowrap;
    }
    
    .value {
      font-size: 13px;
      color: #303133;
      font-weight: 500;
      
      &.warning {
        color: #E6A23C;
        font-weight: 600;
      }
    }
  }
}

/* 在组件的style部分添加 */
.trace-code-descriptions {
  margin: 20px 0;
}

.trace-code-descriptions .description-label {
  background-color: #f5f7fa;
  width: 120px;
  text-align: right;
  font-weight: bold;
}

.trace-code-descriptions .description-content {
  width: 100%;
}

.trace-code-descriptions .el-input,
.trace-code-descriptions .el-input-number {
  width: 100%;
}

/* 追溯码表格区域 */
.trace-code-table-section {
  .trace-code-table {
    /deep/ .el-table {
      border: 1px solid #ebeef5;
      
      th {
        background-color: #f5f7fa;
        font-weight: 600;
        color: #303133;
      }
      
      td, th {
        border-right: 1px solid #ebeef5;
        border-bottom: 1px solid #ebeef5;
      }
    }
  }
}
 
/* 对话框页脚 */
.trace-code-dialog-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  
  .el-button {
    margin-left: 10px;
  }
}
 
/* 药品明细表格中的追溯码按钮样式 */
/deep/ .el-table {
  .cell {
    .el-button--text {
      font-size: 12px;
      padding: 5px 0;
      
      &.is-disabled {
        color: #c0c4cc;
        cursor: not-allowed;
      }
    }
  }
}
</style>

<style lang="less" scoped>
// 进度模态框样式
.progress-dialog {
  .el-dialog {
    border-radius: 8px;
    
    .el-dialog__header {
      background-color: #409EFF;
      padding: 15px 20px;
      
      .el-dialog__title {
        color: white;
        font-weight: 600;
      }
    }
  }
}

.progress-dialog-content {
  padding: 20px;
  max-height: 600px;
  overflow-y: auto;
  
  .step-list {
    .step-item {
      display: flex;
      margin-bottom: 20px;
      padding: 15px;
      border-radius: 8px;
      background-color: #f8f9fa;
      transition: all 0.3s;
      
      &.step-active {
        background-color: #ecf5ff;
        border-left: 4px solid #409EFF;
      }
      
      &.step-completed {
        background-color: #f0f9eb;
      }
      
      &.step-error {
        background-color: #fef0f0;
      }
      
      .step-icon {
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 15px;
        
        i {
          font-size: 24px;
        }
        
        .step-number {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          background-color: #409EFF;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
        }
      }
      
      .step-content {
        flex: 1;
        
        .step-title {
          font-weight: 600;
          margin-bottom: 8px;
          color: #303133;
          font-size: 14px;
        }
        
        .step-description {
          font-size: 12px;
          color: #606266;
          margin-bottom: 10px;
          
          ul {
            margin: 5px 0 0 20px;
            
            li {
              margin-bottom: 3px;
            }
          }
        }
        
        .step-progress {
          margin-top: 10px;
          
          .el-progress {
            width: 80%;
            display: inline-block;
            vertical-align: middle;
          }
          
          .progress-text {
            display: inline-block;
            margin-left: 10px;
            font-size: 12px;
            color: #409EFF;
            font-weight: bold;
          }
        }
        
        .step-complete {
          font-size: 12px;
          color: #67C23A;
          margin-top: 5px;
          display: flex;
          align-items: center;
        }
        
        .step-error {
          font-size: 12px;
          color: #F56C6C;
          margin-top: 5px;
          display: flex;
          align-items: center;
        }
      }
    }
  }
  
  .total-progress-section {
    margin-top: 30px;
    padding: 20px;
    background-color: #f8f9fa;
    border-radius: 8px;
    
    .total-progress-title {
      font-weight: 600;
      margin-bottom: 10px;
      color: #303133;
    }
    
    .el-progress {
      /deep/ .el-progress-bar__inner {
        transition: width 0.5s ease-in-out;
      }
    }
  }
}
</style>